var cc = Object.defineProperty;
var uc = (e, t, r) => t in e ? cc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Vr = (e, t, r) => uc(e, typeof t != "symbol" ? t + "" : t, r);
import * as I from "react";
import Sr, { useSyncExternalStore as Rs, useRef as er, useEffect as or, useCallback as ir, isValidElement as $n, cloneElement as In, Children as fc, forwardRef as pc, useState as vr, useMemo as yt } from "react";
import { jsx as L, jsxs as Fe, Fragment as gi } from "react/jsx-runtime";
import { Box as wr, CircularProgress as ks, Stack as yi, Checkbox as Ps, Divider as As, Collapse as Zi, ListItem as _s, alpha as dc, TextField as hc, Typography as Gn, Chip as Kn } from "@mui/material";
import { v4 as gc } from "uuid";
import Ve, { debounce as ea, clone as ta } from "lodash";
import { format as Ft, subDays as mi, isBefore as yc, isEqual as mc, isAfter as vc, addDays as Dn } from "date-fns";
import { TZDate as zt } from "@date-fns/tz";
import bc from "@emotion/styled";
import { ThemeContext as Sc, keyframes as nn, css as Ms } from "@emotion/react";
import { MoreHoriz as wc } from "@mui/icons-material";
import * as Oc from "react-dom";
function Ec(e, t) {
  for (var r = 0; r < t.length; r++) {
    const n = t[r];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const o in n)
        if (o !== "default" && !(o in e)) {
          const i = Object.getOwnPropertyDescriptor(n, o);
          i && Object.defineProperty(e, o, i.get ? i : {
            enumerable: !0,
            get: () => n[o]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
let jt = { uuids: {} }, Wr = [];
const lt = {
  blockingStarted: (e) => {
    jt.uuids[e] = !0, jt = { ...jt }, ra();
  },
  blockingStopped: (e) => {
    delete jt.uuids[e], jt = { ...jt }, ra();
  },
  subscribe(e) {
    return Wr = [...Wr, e], () => {
      Wr = Wr.filter((t) => t !== e);
    };
  },
  getSnapshot() {
    return jt;
  }
};
function ra() {
  for (let e of Wr)
    e();
}
function Ds() {
  const e = Rs(lt.subscribe, lt.getSnapshot);
  return Object.keys(e.uuids).length > 0;
}
function xc() {
  return Ds() ? L(wr, { sx: {
    display: "flex",
    backgroundColor: "rgba(0,0,0,0.4)",
    alignItems: "center",
    alignContent: "center",
    justifyItems: "center",
    justifyContent: "center",
    position: "fixed",
    height: "100vh",
    width: "100vw",
    zIndex: 15e3,
    left: 0,
    top: 0
  }, children: L(ks, { color: "primary", thickness: 6, size: 50 }) }) : null;
}
function Cc() {
  const e = jt.uuids;
  return Object.keys(e).length > 0;
}
function Tc(e) {
  lt.blockingStarted(e);
}
function $c(e) {
  lt.blockingStopped(e);
}
function Ns(e) {
  const t = er(""), n = Rs(lt.subscribe, lt.getSnapshot).uuids[t.current];
  return or(() => (t.current = gc(), () => {
    lt.blockingStopped(t.current);
  }), []), or(() => {
    !n && e ? lt.blockingStarted(t.current) : n && e === !1 && lt.blockingStopped(t.current);
  }, [e, n]), {
    blockingStarted: ir(() => {
      lt.blockingStarted(t.current);
    }, []),
    blockingStopped: ir(() => {
      lt.blockingStopped(t.current);
    }, [])
  };
}
function Ic(e) {
  const { blockingStarted: t, blockingStopped: r } = Ns();
  return async (...n) => {
    t();
    const o = await e(...n);
    return r(), o;
  };
}
const Ls = {
  zIndex: 100,
  position: "sticky",
  pointerEvents: "none"
}, na = {
  ...Ls,
  left: 0,
  minWidth: "100%",
  height: "40px",
  minHeight: "40px",
  marginTop: "-40px"
}, oa = {
  ...Ls,
  top: 0,
  minHeight: "100%",
  width: "20px",
  minWidth: "20px",
  marginLeft: "-20px"
}, Rc = {
  top: 0,
  backgroundImage: "radial-gradient(farthest-side at 50% 0%, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%)",
  opacity: 0
}, kc = {
  bottom: 0,
  backgroundImage: "radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%)"
}, Pc = {
  left: 0,
  backgroundImage: "radial-gradient(farthest-side at 0% 50%, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%)",
  opacity: 0
}, Ac = {
  right: 0,
  backgroundImage: "radial-gradient(farthest-side at 100% 50%, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%)"
};
function cm({ children: e, containerRef: t, direction: r = "column", styleTopShadow: n = {}, styleBottomShadow: o = {}, threshold: i = 40 }) {
  return _c({ direction: r, container: t, threshold: i }), Fe(gi, { children: [r == "column" ? L(wr, { className: "shadow--top", sx: { ...na, ...Rc, ...n } }) : null, r == "row" ? L(wr, { className: "shadow--left", sx: { ...oa, ...Pc, ...n } }) : null, e, r == "column" ? L(wr, { className: "shadow--bottom", sx: { ...na, ...kc, ...o } }) : null, r == "row" ? L(wr, { className: "shadow--right", sx: { ...oa, ...Ac, ...o } }) : null] });
}
const Rn = 150, So = Rn;
function _c({ container: e, direction: t, threshold: r }) {
  const n = ir(ea(() => {
    if (e.current) {
      if (t == "column") {
        const a = e.current.querySelector(".shadow--top"), s = e.current.querySelector(".shadow--bottom");
        if (a && s) {
          const l = e.current.scrollHeight - e.current.offsetHeight;
          l < r ? (a.style.opacity = String(0), s.style.opacity = String(0)) : (a.style.opacity = String(Math.min(e.current.scrollTop / Rn, 1)), s.style.opacity = String(Math.min((l - e.current.scrollTop) / Rn, 1)));
        }
      } else if (t == "row") {
        const a = e.current.querySelector(".shadow--left"), s = e.current.querySelector(".shadow--right");
        if (a && s) {
          const l = e.current.scrollWidth - e.current.offsetWidth;
          l < r ? (a.style.opacity = String(0), s.style.opacity = String(0)) : (a.style.opacity = String(Math.min(e.current.scrollLeft / So, 1)), s.style.opacity = String(Math.min((l - e.current.scrollLeft) / So, 1)));
        }
      }
    }
  }), [e.current]), o = ir((a) => {
    if (a) {
      if (t == "column") {
        const s = a.scrollHeight - a.offsetHeight, l = a.querySelector(".shadow--bottom");
        l && (s < r ? l.style.opacity = "0" : l.style.opacity = String(Math.min((s - a.scrollTop) / Rn, 1)));
      } else if (t == "row") {
        const s = a.scrollWidth - a.offsetWidth, l = a.querySelector(".shadow--right");
        l && (s < r ? l.style.opacity = "0" : l.style.opacity = String(Math.min((s - a.scrollLeft) / So, 1)));
      }
    }
  }, []), i = ir(ea(() => {
    const a = e.current;
    a && o(a);
  }), [e.current]);
  return or(() => {
    const a = e.current;
    let s = null;
    return a && (o(a), a.addEventListener("scroll", n), a.addEventListener("resize", i), s = new MutationObserver(i), s.observe(a, { subtree: !0, childList: !0 })), () => {
      a == null || a.removeEventListener("resize", i), a == null || a.removeEventListener("scroll", n), s == null || s.disconnect();
    };
  }, [e, i, n]), e;
}
function on(e) {
  return Mc(typeof e == "string" ? e : e.hours);
}
function Mc(e) {
  const t = e.split("-");
  return { start: ia(t[0]), end: ia(t[1]) };
}
function ia(e) {
  const t = e.split(":");
  return { hours: Number(t[0]), minutes: Number(t[1]) };
}
function js(e, t) {
  return e.hours == t.hours && e.minutes == t.minutes;
}
function Vs(e, t) {
  return Kr(e) > Kr(t);
}
function Dc(e, t) {
  return Kr(e) < Kr(t);
}
function Nc(e, t) {
  return js(e, t) || Vs(e, t);
}
function Kr(e) {
  return e.hours * 60 + e.minutes;
}
function Lc(e) {
  return String(e.hours).padStart(2, "0") + ":" + String(e.minutes).padStart(2, "0");
}
function jc(e) {
  return {
    hours: Number(Ft(e, "H")),
    minutes: Number(Ft(e, "m"))
  };
}
const Ee = { isSame: js, isBefore: Dc, isAfter: Vs, isSameOrAfter: Nc, timeToNumber: Kr, fromDate: jc, timeToString: Lc };
function Vc(e) {
  return Ee.isAfter(e.start, e.end);
}
function Bs(e) {
  return Vc(e);
}
function Fs(e, t) {
  return Ee.isSameOrAfter(t, e.start) && (Bs(e) || Ee.isBefore(t, e.end));
}
function Bc(e, t) {
  return Bs(e) && Fs({ ...e, start: { hours: 0, minutes: 0 } }, t);
}
function Fc(e) {
  return `${Ee.timeToString(e.start)}-${Ee.timeToString(e.end)}`;
}
function zc(e, t) {
  return Ee.isSame(e.start, t.start) && Ee.isSame(e.end, t.end);
}
const vi = { containsTime: Fs, containsNightTime: Bc, timeRangeToString: Fc, timeRangesAreEqual: zc };
function zs(e, t) {
  return Ee.isBefore(e, t.start) ? t : null;
}
function qc(e, t) {
  var r;
  return ((r = zs(e, t)) == null ? void 0 : r.start) ?? null;
}
function Wc(e, t) {
  var r;
  return ((r = zs(e, t)) == null ? void 0 : r.end) ?? null;
}
function Uc(e, t) {
  return vi.containsTime(t, e) ? t.end : null;
}
function Hc(e, t) {
  for (const r of e)
    if (vi.containsNightTime(on(r), t))
      return !0;
  return !1;
}
function qs(e, t) {
  for (const r of e)
    if (vi.containsTime(on(r), t))
      return !0;
  return !1;
}
function Yc(e) {
  return qs(e, { hours: 23, minutes: 59 });
}
function Qc(e, t) {
  for (const r of e.map((n) => on(n)).sort((n, o) => Ee.timeToNumber(n.start) - Ee.timeToNumber(o.start))) {
    const n = qc(Ee.fromDate(t), r);
    if (n)
      return n;
  }
  return null;
}
function Gc(e, t) {
  const r = e.map((n) => on(n)).sort((n, o) => Ee.timeToNumber(n.end) - Ee.timeToNumber(o.end));
  for (const n of r) {
    const o = Uc(Ee.fromDate(t), n);
    if (o)
      return o;
  }
  for (const n of r) {
    const o = Wc(Ee.fromDate(t), n);
    if (o)
      return o;
  }
  return null;
}
const mt = {
  isOpenAtNight: Hc,
  nextClose: Gc,
  nextOpen: Qc,
  isOpenAtTheEndOfTheDay: Yc,
  isOpenAt: qs
}, Kc = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"], um = (e) => Kc.includes(e);
function fm(e, t) {
  return (e == null ? void 0 : e.some((r) => Ws(t, typeof r == "string" ? r : r.hours))) ?? !1;
}
function Ws(e, t) {
  const [r, n] = t.split("-"), [o, i] = r.split(":"), [a, s] = n.split(":");
  let l = ta(e);
  l.setHours(Number(o), Number(i), 0, 0);
  let u = ta(e);
  u.setHours(Number(a), Number(s), 0, 0);
  const f = 60 * Number(a) + Number(s), h = 60 * Number(o) + Number(i);
  return f < h && (l = mi(l, 1)), (yc(l, e) || mc(l, e)) && vc(u, e);
}
function ar(e, t) {
  var r, n;
  return ((r = e.exceptions) == null ? void 0 : r[Ft(t, "yyyy-MM-dd")]) ?? ((n = e.exceptions) == null ? void 0 : n[Ft(t, "MM-dd")]) ?? e[Ft(t, "EEEE").toLowerCase()] ?? [];
}
function Xc(e, t) {
  var n, o, i;
  return ((i = [...((n = e.exceptions) == null ? void 0 : n[Ft(t, "yyyy-MM-dd")]) ?? ((o = e.exceptions) == null ? void 0 : o[Ft(t, "MM-dd")]) ?? e[Ft(t, "EEEE").toLowerCase()] ?? null ?? []].reverse()) == null ? void 0 : i.find((a) => Ws(t, typeof a == "string" ? a : a.hours))) ?? null;
}
function qt(e) {
  return e.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function Jc(e, t) {
  const r = Xc(e, t);
  return r ? on(r) : null;
}
function Zc(e, t = null, r = null) {
  t = t ?? new zt(/* @__PURE__ */ new Date(), qt(e)), t = new zt(t.getTime(), qt(e));
  let n = ar(e, t), o = mt.nextOpen(n, t), i = 366;
  for (; !o || o.hours >= 24; ) {
    if (--i < 0)
      return null;
    if (t = Dn(t, 1), t == null || t.setHours(0, 0, 0, 0), Xn(e, t) && !mt.isOpenAtTheEndOfTheDay(n))
      return t;
    if (r && (t == null ? void 0 : t.getTime()) > r.getTime())
      return r;
    n = ar(e, t), o = mt.nextOpen(n, t);
  }
  return o ? (t == null || t.setHours(o.hours, o.minutes, 0, 0), t) : null;
}
function eu(e, t = null, r = null) {
  var s;
  t = t ?? new zt(/* @__PURE__ */ new Date(), qt(e)), t = new zt(t.getTime(), qt(e));
  const n = (s = Jc(e, t)) == null ? void 0 : s.end;
  if (n && n.hours < 24)
    return t.setHours(n.hours, n.minutes, 0, 0), t;
  let o = null;
  {
    const l = mi(t, 1), u = ar(e, l);
    mt.isOpenAtNight(u, Ee.fromDate(l)) && (o = mt.nextClose(u, t));
  }
  let i = ar(e, t);
  o || (o = mt.nextClose(i, t), o && o.hours < 24 && (Ee.timeToNumber(o) < Ee.timeToNumber(Ee.fromDate(t)) || aa(e, t) && Ee.timeToNumber(Ee.fromDate(Zc(e, t) ?? /* @__PURE__ */ new Date("2100-00-00 00:00:00"))) > Ee.timeToNumber(o)) && (t = Dn(t, 1)));
  let a = 366;
  for (; !o || o.hours >= 24; ) {
    if (--a < 0)
      return null;
    if (t = Dn(t, 1), t == null || t.setHours(0, 0, 0, 0), aa(e, t) && mt.isOpenAtTheEndOfTheDay(i))
      return t;
    if (r && (t == null ? void 0 : t.getTime()) > r.getTime())
      return r;
    i = ar(e, t), o = mt.nextClose(i, t);
  }
  return o ? (t == null || t.setHours(o.hours, o.minutes, 0, 0), t) : null;
}
function tu(e) {
  return Xn(e, /* @__PURE__ */ new Date());
}
function pm(e) {
  return !tu(e);
}
function aa(e, t) {
  return !Xn(e, t);
}
function Xn(e, t) {
  t = t ?? new zt(/* @__PURE__ */ new Date(), qt(e)), t = new zt(t.getTime(), qt(e));
  {
    const n = mi(t, 1), o = ar(e, n);
    if (mt.isOpenAtNight(o, Ee.fromDate(n)))
      return !0;
  }
  const r = ar(e, t);
  return mt.isOpenAt(r, Ee.fromDate(t));
}
function dm(e, t, r = 7) {
  t = t ?? new zt(/* @__PURE__ */ new Date(), qt(e)), t = new zt(t.getTime(), qt(e)), t.setMilliseconds(30);
  const n = Xn(e, t), o = Dn(t, r), i = eu(e, t, o);
  return n && o.getTime() == (i == null ? void 0 : i.getTime());
}
function Us(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var zo = { exports: {} }, bn = { exports: {} }, fe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sa;
function ru() {
  if (sa) return fe;
  sa = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
  function x(S) {
    if (typeof S == "object" && S !== null) {
      var P = S.$$typeof;
      switch (P) {
        case t:
          switch (S = S.type, S) {
            case l:
            case u:
            case n:
            case i:
            case o:
            case h:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case s:
                case f:
                case y:
                case m:
                case a:
                  return S;
                default:
                  return P;
              }
          }
        case r:
          return P;
      }
    }
  }
  function b(S) {
    return x(S) === u;
  }
  return fe.AsyncMode = l, fe.ConcurrentMode = u, fe.ContextConsumer = s, fe.ContextProvider = a, fe.Element = t, fe.ForwardRef = f, fe.Fragment = n, fe.Lazy = y, fe.Memo = m, fe.Portal = r, fe.Profiler = i, fe.StrictMode = o, fe.Suspense = h, fe.isAsyncMode = function(S) {
    return b(S) || x(S) === l;
  }, fe.isConcurrentMode = b, fe.isContextConsumer = function(S) {
    return x(S) === s;
  }, fe.isContextProvider = function(S) {
    return x(S) === a;
  }, fe.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === t;
  }, fe.isForwardRef = function(S) {
    return x(S) === f;
  }, fe.isFragment = function(S) {
    return x(S) === n;
  }, fe.isLazy = function(S) {
    return x(S) === y;
  }, fe.isMemo = function(S) {
    return x(S) === m;
  }, fe.isPortal = function(S) {
    return x(S) === r;
  }, fe.isProfiler = function(S) {
    return x(S) === i;
  }, fe.isStrictMode = function(S) {
    return x(S) === o;
  }, fe.isSuspense = function(S) {
    return x(S) === h;
  }, fe.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === n || S === u || S === i || S === o || S === h || S === g || typeof S == "object" && S !== null && (S.$$typeof === y || S.$$typeof === m || S.$$typeof === a || S.$$typeof === s || S.$$typeof === f || S.$$typeof === v || S.$$typeof === w || S.$$typeof === R || S.$$typeof === p);
  }, fe.typeOf = x, fe;
}
var pe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var la;
function nu() {
  return la || (la = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
    function x(V) {
      return typeof V == "string" || typeof V == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      V === n || V === u || V === i || V === o || V === h || V === g || typeof V == "object" && V !== null && (V.$$typeof === y || V.$$typeof === m || V.$$typeof === a || V.$$typeof === s || V.$$typeof === f || V.$$typeof === v || V.$$typeof === w || V.$$typeof === R || V.$$typeof === p);
    }
    function b(V) {
      if (typeof V == "object" && V !== null) {
        var de = V.$$typeof;
        switch (de) {
          case t:
            var Le = V.type;
            switch (Le) {
              case l:
              case u:
              case n:
              case i:
              case o:
              case h:
                return Le;
              default:
                var ut = Le && Le.$$typeof;
                switch (ut) {
                  case s:
                  case f:
                  case y:
                  case m:
                  case a:
                    return ut;
                  default:
                    return de;
                }
            }
          case r:
            return de;
        }
      }
    }
    var S = l, P = u, q = s, D = a, z = t, d = f, T = n, $ = y, F = m, Q = r, ae = i, Y = o, re = h, oe = !1;
    function Z(V) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), k(V) || b(V) === l;
    }
    function k(V) {
      return b(V) === u;
    }
    function A(V) {
      return b(V) === s;
    }
    function W(V) {
      return b(V) === a;
    }
    function _(V) {
      return typeof V == "object" && V !== null && V.$$typeof === t;
    }
    function M(V) {
      return b(V) === f;
    }
    function N(V) {
      return b(V) === n;
    }
    function j(V) {
      return b(V) === y;
    }
    function U(V) {
      return b(V) === m;
    }
    function G(V) {
      return b(V) === r;
    }
    function H(V) {
      return b(V) === i;
    }
    function K(V) {
      return b(V) === o;
    }
    function Se(V) {
      return b(V) === h;
    }
    pe.AsyncMode = S, pe.ConcurrentMode = P, pe.ContextConsumer = q, pe.ContextProvider = D, pe.Element = z, pe.ForwardRef = d, pe.Fragment = T, pe.Lazy = $, pe.Memo = F, pe.Portal = Q, pe.Profiler = ae, pe.StrictMode = Y, pe.Suspense = re, pe.isAsyncMode = Z, pe.isConcurrentMode = k, pe.isContextConsumer = A, pe.isContextProvider = W, pe.isElement = _, pe.isForwardRef = M, pe.isFragment = N, pe.isLazy = j, pe.isMemo = U, pe.isPortal = G, pe.isProfiler = H, pe.isStrictMode = K, pe.isSuspense = Se, pe.isValidElementType = x, pe.typeOf = b;
  }()), pe;
}
var ca;
function Hs() {
  return ca || (ca = 1, process.env.NODE_ENV === "production" ? bn.exports = ru() : bn.exports = nu()), bn.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var wo, ua;
function ou() {
  if (ua) return wo;
  ua = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(f) {
        return a[f];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        u[f] = f;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return wo = o() ? Object.assign : function(i, a) {
    for (var s, l = n(i), u, f = 1; f < arguments.length; f++) {
      s = Object(arguments[f]);
      for (var h in s)
        t.call(s, h) && (l[h] = s[h]);
      if (e) {
        u = e(s);
        for (var g = 0; g < u.length; g++)
          r.call(s, u[g]) && (l[u[g]] = s[u[g]]);
      }
    }
    return l;
  }, wo;
}
var Oo, fa;
function bi() {
  if (fa) return Oo;
  fa = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Oo = e, Oo;
}
var Eo, pa;
function Ys() {
  return pa || (pa = 1, Eo = Function.call.bind(Object.prototype.hasOwnProperty)), Eo;
}
var xo, da;
function iu() {
  if (da) return xo;
  da = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = bi(), r = {}, n = Ys();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in i)
        if (n(i, f)) {
          var h;
          try {
            if (typeof i[f] != "function") {
              var g = Error(
                (l || "React class") + ": " + s + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            h = i[f](a, f, l, s, null, t);
          } catch (y) {
            h = y;
          }
          if (h && !(h instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in r)) {
            r[h.message] = !0;
            var m = u ? u() : "";
            e(
              "Failed " + s + " type: " + h.message + (m ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, xo = o, xo;
}
var Co, ha;
function au() {
  if (ha) return Co;
  ha = 1;
  var e = Hs(), t = ou(), r = bi(), n = Ys(), o = iu(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Co = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function h(k) {
      var A = k && (u && k[u] || k[f]);
      if (typeof A == "function")
        return A;
    }
    var g = "<<anonymous>>", m = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: R(),
      arrayOf: x,
      element: b(),
      elementType: S(),
      instanceOf: P,
      node: d(),
      objectOf: D,
      oneOf: q,
      oneOfType: z,
      shape: $,
      exact: F
    };
    function y(k, A) {
      return k === A ? k !== 0 || 1 / k === 1 / A : k !== k && A !== A;
    }
    function p(k, A) {
      this.message = k, this.data = A && typeof A == "object" ? A : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function v(k) {
      if (process.env.NODE_ENV !== "production")
        var A = {}, W = 0;
      function _(N, j, U, G, H, K, Se) {
        if (G = G || g, K = K || U, Se !== r) {
          if (l) {
            var V = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw V.name = "Invariant Violation", V;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var de = G + ":" + U;
            !A[de] && // Avoid spamming the console because they are often not actionable except for lib authors
            W < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + K + "` prop on `" + G + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), A[de] = !0, W++);
          }
        }
        return j[U] == null ? N ? j[U] === null ? new p("The " + H + " `" + K + "` is marked as required " + ("in `" + G + "`, but its value is `null`.")) : new p("The " + H + " `" + K + "` is marked as required in " + ("`" + G + "`, but its value is `undefined`.")) : null : k(j, U, G, H, K);
      }
      var M = _.bind(null, !1);
      return M.isRequired = _.bind(null, !0), M;
    }
    function w(k) {
      function A(W, _, M, N, j, U) {
        var G = W[_], H = Y(G);
        if (H !== k) {
          var K = re(G);
          return new p(
            "Invalid " + N + " `" + j + "` of type " + ("`" + K + "` supplied to `" + M + "`, expected ") + ("`" + k + "`."),
            { expectedType: k }
          );
        }
        return null;
      }
      return v(A);
    }
    function R() {
      return v(a);
    }
    function x(k) {
      function A(W, _, M, N, j) {
        if (typeof k != "function")
          return new p("Property `" + j + "` of component `" + M + "` has invalid PropType notation inside arrayOf.");
        var U = W[_];
        if (!Array.isArray(U)) {
          var G = Y(U);
          return new p("Invalid " + N + " `" + j + "` of type " + ("`" + G + "` supplied to `" + M + "`, expected an array."));
        }
        for (var H = 0; H < U.length; H++) {
          var K = k(U, H, M, N, j + "[" + H + "]", r);
          if (K instanceof Error)
            return K;
        }
        return null;
      }
      return v(A);
    }
    function b() {
      function k(A, W, _, M, N) {
        var j = A[W];
        if (!s(j)) {
          var U = Y(j);
          return new p("Invalid " + M + " `" + N + "` of type " + ("`" + U + "` supplied to `" + _ + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(k);
    }
    function S() {
      function k(A, W, _, M, N) {
        var j = A[W];
        if (!e.isValidElementType(j)) {
          var U = Y(j);
          return new p("Invalid " + M + " `" + N + "` of type " + ("`" + U + "` supplied to `" + _ + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(k);
    }
    function P(k) {
      function A(W, _, M, N, j) {
        if (!(W[_] instanceof k)) {
          var U = k.name || g, G = Z(W[_]);
          return new p("Invalid " + N + " `" + j + "` of type " + ("`" + G + "` supplied to `" + M + "`, expected ") + ("instance of `" + U + "`."));
        }
        return null;
      }
      return v(A);
    }
    function q(k) {
      if (!Array.isArray(k))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function A(W, _, M, N, j) {
        for (var U = W[_], G = 0; G < k.length; G++)
          if (y(U, k[G]))
            return null;
        var H = JSON.stringify(k, function(Se, V) {
          var de = re(V);
          return de === "symbol" ? String(V) : V;
        });
        return new p("Invalid " + N + " `" + j + "` of value `" + String(U) + "` " + ("supplied to `" + M + "`, expected one of " + H + "."));
      }
      return v(A);
    }
    function D(k) {
      function A(W, _, M, N, j) {
        if (typeof k != "function")
          return new p("Property `" + j + "` of component `" + M + "` has invalid PropType notation inside objectOf.");
        var U = W[_], G = Y(U);
        if (G !== "object")
          return new p("Invalid " + N + " `" + j + "` of type " + ("`" + G + "` supplied to `" + M + "`, expected an object."));
        for (var H in U)
          if (n(U, H)) {
            var K = k(U, H, M, N, j + "." + H, r);
            if (K instanceof Error)
              return K;
          }
        return null;
      }
      return v(A);
    }
    function z(k) {
      if (!Array.isArray(k))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var A = 0; A < k.length; A++) {
        var W = k[A];
        if (typeof W != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + oe(W) + " at index " + A + "."
          ), a;
      }
      function _(M, N, j, U, G) {
        for (var H = [], K = 0; K < k.length; K++) {
          var Se = k[K], V = Se(M, N, j, U, G, r);
          if (V == null)
            return null;
          V.data && n(V.data, "expectedType") && H.push(V.data.expectedType);
        }
        var de = H.length > 0 ? ", expected one of type [" + H.join(", ") + "]" : "";
        return new p("Invalid " + U + " `" + G + "` supplied to " + ("`" + j + "`" + de + "."));
      }
      return v(_);
    }
    function d() {
      function k(A, W, _, M, N) {
        return Q(A[W]) ? null : new p("Invalid " + M + " `" + N + "` supplied to " + ("`" + _ + "`, expected a ReactNode."));
      }
      return v(k);
    }
    function T(k, A, W, _, M) {
      return new p(
        (k || "React class") + ": " + A + " type `" + W + "." + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + M + "`."
      );
    }
    function $(k) {
      function A(W, _, M, N, j) {
        var U = W[_], G = Y(U);
        if (G !== "object")
          return new p("Invalid " + N + " `" + j + "` of type `" + G + "` " + ("supplied to `" + M + "`, expected `object`."));
        for (var H in k) {
          var K = k[H];
          if (typeof K != "function")
            return T(M, N, j, H, re(K));
          var Se = K(U, H, M, N, j + "." + H, r);
          if (Se)
            return Se;
        }
        return null;
      }
      return v(A);
    }
    function F(k) {
      function A(W, _, M, N, j) {
        var U = W[_], G = Y(U);
        if (G !== "object")
          return new p("Invalid " + N + " `" + j + "` of type `" + G + "` " + ("supplied to `" + M + "`, expected `object`."));
        var H = t({}, W[_], k);
        for (var K in H) {
          var Se = k[K];
          if (n(k, K) && typeof Se != "function")
            return T(M, N, j, K, re(Se));
          if (!Se)
            return new p(
              "Invalid " + N + " `" + j + "` key `" + K + "` supplied to `" + M + "`.\nBad object: " + JSON.stringify(W[_], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(k), null, "  ")
            );
          var V = Se(U, K, M, N, j + "." + K, r);
          if (V)
            return V;
        }
        return null;
      }
      return v(A);
    }
    function Q(k) {
      switch (typeof k) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !k;
        case "object":
          if (Array.isArray(k))
            return k.every(Q);
          if (k === null || s(k))
            return !0;
          var A = h(k);
          if (A) {
            var W = A.call(k), _;
            if (A !== k.entries) {
              for (; !(_ = W.next()).done; )
                if (!Q(_.value))
                  return !1;
            } else
              for (; !(_ = W.next()).done; ) {
                var M = _.value;
                if (M && !Q(M[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ae(k, A) {
      return k === "symbol" ? !0 : A ? A["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && A instanceof Symbol : !1;
    }
    function Y(k) {
      var A = typeof k;
      return Array.isArray(k) ? "array" : k instanceof RegExp ? "object" : ae(A, k) ? "symbol" : A;
    }
    function re(k) {
      if (typeof k > "u" || k === null)
        return "" + k;
      var A = Y(k);
      if (A === "object") {
        if (k instanceof Date)
          return "date";
        if (k instanceof RegExp)
          return "regexp";
      }
      return A;
    }
    function oe(k) {
      var A = re(k);
      switch (A) {
        case "array":
        case "object":
          return "an " + A;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + A;
        default:
          return A;
      }
    }
    function Z(k) {
      return !k.constructor || !k.constructor.name ? g : k.constructor.name;
    }
    return m.checkPropTypes = o, m.resetWarningCache = o.resetWarningCache, m.PropTypes = m, m;
  }, Co;
}
var To, ga;
function su() {
  if (ga) return To;
  ga = 1;
  var e = bi();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, To = function() {
    function n(a, s, l, u, f, h) {
      if (h !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, To;
}
if (process.env.NODE_ENV !== "production") {
  var lu = Hs(), cu = !0;
  zo.exports = au()(lu.isElement, cu);
} else
  zo.exports = su()();
var uu = zo.exports;
const c = /* @__PURE__ */ Us(uu);
function Qs(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = Qs(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function xe() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = Qs(e)) && (n && (n += " "), n += t);
  return n;
}
function fu(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function Gs(e, t, r, n) {
  const o = e[t];
  if (o == null || !Number.isInteger(o)) {
    const i = fu(o);
    return new RangeError(`Invalid ${n} \`${t}\` of type \`${i}\` supplied to \`${r}\`, expected \`integer\`.`);
  }
  return null;
}
function Ks(e, t, r, n) {
  return e[t] === void 0 ? null : Gs(e, t, r, n);
}
function qo() {
  return null;
}
Ks.isRequired = Gs;
qo.isRequired = qo;
const Xs = process.env.NODE_ENV === "production" ? qo : Ks;
function lr(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...n) {
    return e(...n) || t(...n);
  };
}
function At(e, t, r = void 0) {
  const n = {};
  for (const o in e) {
    const i = e[o];
    let a = "", s = !0;
    for (let l = 0; l < i.length; l += 1) {
      const u = i[l];
      u && (a += (s === !0 ? "" : " ") + t(u), s = !1, r && r[u] && (a += " " + r[u]));
    }
    n[o] = a;
  }
  return n;
}
function Wt(e, ...t) {
  const r = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((n) => r.searchParams.append("args[]", n)), `Minified MUI error #${e}; visit ${r} for the full message.`;
}
function pu(e, t = Number.MIN_SAFE_INTEGER, r = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, r));
}
function Si(e, t = 0, r = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > r) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${r}].`), pu(e, t, r);
}
function du(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let r = e.match(t);
  return r && r[0].length === 1 && (r = r.map((n) => n + n)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), r ? `rgb${r.length === 4 ? "a" : ""}(${r.map((n, o) => o < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Ut(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Ut(du(e));
  const t = e.indexOf("("), r = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(r))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : Wt(9, e));
  let n = e.substring(t + 1, e.length - 1), o;
  if (r === "color") {
    if (n = n.split(" "), o = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(o))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : Wt(10, o));
  } else
    n = n.split(",");
  return n = n.map((i) => parseFloat(i)), {
    type: r,
    values: n,
    colorSpace: o
  };
}
const hu = (e) => {
  const t = Ut(e);
  return t.values.slice(0, 3).map((r, n) => t.type.includes("hsl") && n !== 0 ? `${r}%` : r).join(" ");
}, Ur = (e, t) => {
  try {
    return hu(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function Jn(e) {
  const {
    type: t,
    colorSpace: r
  } = e;
  let {
    values: n
  } = e;
  return t.includes("rgb") ? n = n.map((o, i) => i < 3 ? parseInt(o, 10) : o) : t.includes("hsl") && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.includes("color") ? n = `${r} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function Js(e) {
  e = Ut(e);
  const {
    values: t
  } = e, r = t[0], n = t[1] / 100, o = t[2] / 100, i = n * Math.min(o, 1 - o), a = (u, f = (u + r / 30) % 12) => o - i * Math.max(Math.min(f - 3, 9 - f, 1), -1);
  let s = "rgb";
  const l = [Math.round(a(0) * 255), Math.round(a(8) * 255), Math.round(a(4) * 255)];
  return e.type === "hsla" && (s += "a", l.push(t[3])), Jn({
    type: s,
    values: l
  });
}
function Wo(e) {
  e = Ut(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Ut(Js(e)).values : e.values;
  return t = t.map((r) => (e.type !== "color" && (r /= 255), r <= 0.03928 ? r / 12.92 : ((r + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function ya(e, t) {
  const r = Wo(e), n = Wo(t);
  return (Math.max(r, n) + 0.05) / (Math.min(r, n) + 0.05);
}
function Me(e, t) {
  return e = Ut(e), t = Si(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, Jn(e);
}
function Sn(e, t, r) {
  try {
    return Me(e, t);
  } catch {
    return e;
  }
}
function wi(e, t) {
  if (e = Ut(e), t = Si(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let r = 0; r < 3; r += 1)
      e.values[r] *= 1 - t;
  return Jn(e);
}
function me(e, t, r) {
  try {
    return wi(e, t);
  } catch {
    return e;
  }
}
function Oi(e, t) {
  if (e = Ut(e), t = Si(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (255 - e.values[r]) * t;
  else if (e.type.includes("color"))
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (1 - e.values[r]) * t;
  return Jn(e);
}
function ve(e, t, r) {
  try {
    return Oi(e, t);
  } catch {
    return e;
  }
}
function gu(e, t = 0.15) {
  return Wo(e) > 0.5 ? wi(e, t) : Oi(e, t);
}
function wn(e, t, r) {
  try {
    return gu(e, t);
  } catch {
    return e;
  }
}
function Uo(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const Xr = typeof window < "u" ? I.useLayoutEffect : I.useEffect;
function Vt(e) {
  const t = I.useRef(e);
  return Xr(() => {
    t.current = e;
  }), I.useRef((...r) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...r)
  )).current;
}
function $o(e) {
  const {
    controlled: t,
    default: r,
    name: n,
    state: o = "value"
  } = e, {
    current: i
  } = I.useRef(t !== void 0), [a, s] = I.useState(r), l = i ? t : a;
  if (process.env.NODE_ENV !== "production") {
    I.useEffect(() => {
      i !== (t !== void 0) && console.error([`MUI: A component is changing the ${i ? "" : "un"}controlled ${o} state of ${n} to be ${i ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, t]);
    const {
      current: f
    } = I.useRef(r);
    I.useEffect(() => {
      !i && !Object.is(f, r) && console.error([`MUI: A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(r)]);
  }
  const u = I.useCallback((f) => {
    i || s(f);
  }, []);
  return [l, u];
}
let ma = 0;
function yu(e) {
  const [t, r] = I.useState(e), n = e || t;
  return I.useEffect(() => {
    t == null && (ma += 1, r(`mui-${ma}`));
  }, [t]), n;
}
const mu = {
  ...I
}, va = mu.useId;
function Zs(e) {
  if (va !== void 0) {
    const t = va();
    return e ?? t;
  }
  return yu(e);
}
const vu = (e) => {
  const t = I.useRef({});
  return I.useEffect(() => {
    t.current = e;
  }), t.current;
};
function ba(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function bu(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: r = !0,
    limit: n,
    matchFrom: o = "any",
    stringify: i,
    trim: a = !1
  } = e;
  return (s, {
    inputValue: l,
    getOptionLabel: u
  }) => {
    let f = a ? l.trim() : l;
    r && (f = f.toLowerCase()), t && (f = ba(f));
    const h = f ? s.filter((g) => {
      let m = (i || u)(g);
      return r && (m = m.toLowerCase()), t && (m = ba(m)), o === "start" ? m.startsWith(f) : m.includes(f);
    }) : s;
    return typeof n == "number" ? h.slice(0, n) : h;
  };
}
const Su = bu(), wu = 5, Ou = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
}, Eu = [];
function Sa(e, t, r, n) {
  if (t || e == null || n)
    return "";
  const o = r(e);
  return typeof o == "string" ? o : "";
}
function xu(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = Ou,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: r = "Mui",
    autoComplete: n = !1,
    autoHighlight: o = !1,
    autoSelect: i = !1,
    blurOnSelect: a = !1,
    clearOnBlur: s = !e.freeSolo,
    clearOnEscape: l = !1,
    componentName: u = "useAutocomplete",
    defaultValue: f = e.multiple ? Eu : null,
    disableClearable: h = !1,
    disableCloseOnSelect: g = !1,
    disabled: m,
    disabledItemsFocusable: y = !1,
    disableListWrap: p = !1,
    filterOptions: v = Su,
    filterSelectedOptions: w = !1,
    freeSolo: R = !1,
    getOptionDisabled: x,
    getOptionKey: b,
    getOptionLabel: S = (C) => C.label ?? C,
    groupBy: P,
    handleHomeEndKeys: q = !e.freeSolo,
    id: D,
    includeInputInList: z = !1,
    inputValue: d,
    isOptionEqualToValue: T = (C, O) => C === O,
    multiple: $ = !1,
    onChange: F,
    onClose: Q,
    onHighlightChange: ae,
    onInputChange: Y,
    onOpen: re,
    open: oe,
    openOnFocus: Z = !1,
    options: k,
    readOnly: A = !1,
    renderValue: W,
    selectOnFocus: _ = !e.freeSolo,
    value: M
  } = e, N = Zs(D);
  let j = S;
  j = (C) => {
    const O = S(C);
    if (typeof O != "string") {
      if (process.env.NODE_ENV !== "production") {
        const B = O === void 0 ? "undefined" : `${typeof O} (${O})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${u} returned ${B} instead of a string for ${JSON.stringify(C)}.`);
      }
      return String(O);
    }
    return O;
  };
  const U = I.useRef(!1), G = I.useRef(!0), H = I.useRef(null), K = I.useRef(null), [Se, V] = I.useState(null), [de, Le] = I.useState(-1), ut = o ? 0 : -1, Ie = I.useRef(ut), ft = I.useRef(Sa(f ?? M, $, j)).current, [X, wt] = $o({
    controlled: M,
    default: f,
    name: u
  }), [le, ze] = $o({
    controlled: d,
    default: ft,
    name: u,
    state: "inputValue"
  }), [ee, Gt] = I.useState(!1), pt = I.useCallback((C, O, B) => {
    if (!($ ? X.length < O.length : O !== null) && !s)
      return;
    const J = Sa(O, $, j, W);
    le !== J && (ze(J), Y && Y(C, J, B));
  }, [j, le, $, Y, ze, s, X, W]), [Je, _t] = $o({
    controlled: oe,
    default: !1,
    name: u,
    state: "open"
  }), [Ar, Ot] = I.useState(!0), fn = !$ && X != null && le === j(X), qe = Je && !A, Ce = qe ? v(
    k.filter((C) => !(w && ($ ? X : [X]).some((O) => O !== null && T(C, O)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: fn && Ar ? "" : le,
      getOptionLabel: j
    }
  ) : [], it = vu({
    filteredOptions: Ce,
    value: X,
    inputValue: le
  });
  I.useEffect(() => {
    const C = X !== it.value;
    ee && !C || R && !C || pt(null, X, "reset");
  }, [X, pt, ee, it.value, R]);
  const pn = Je && Ce.length > 0 && !A, at = Vt((C) => {
    if (C === -1)
      H.current.focus();
    else {
      const O = W ? "data-item-index" : "data-tag-index";
      Se.querySelector(`[${O}="${C}"]`).focus();
    }
  });
  I.useEffect(() => {
    $ && de > X.length - 1 && (Le(-1), at(-1));
  }, [X, $, de, at]);
  function po(C, O) {
    if (!K.current || C < 0 || C >= Ce.length)
      return -1;
    let B = C;
    for (; ; ) {
      const se = K.current.querySelector(`[data-option-index="${B}"]`), J = y ? !1 : !se || se.disabled || se.getAttribute("aria-disabled") === "true";
      if (se && se.hasAttribute("tabindex") && !J)
        return B;
      if (O === "next" ? B = (B + 1) % Ce.length : B = (B - 1 + Ce.length) % Ce.length, B === C)
        return -1;
    }
  }
  const Et = Vt(({
    event: C,
    index: O,
    reason: B
  }) => {
    if (Ie.current = O, O === -1 ? H.current.removeAttribute("aria-activedescendant") : H.current.setAttribute("aria-activedescendant", `${N}-option-${O}`), ae && ["mouse", "keyboard", "touch"].includes(B) && ae(C, O === -1 ? null : Ce[O], B), !K.current)
      return;
    const se = K.current.querySelector(`[role="option"].${r}-focused`);
    se && (se.classList.remove(`${r}-focused`), se.classList.remove(`${r}-focusVisible`));
    let J = K.current;
    if (K.current.getAttribute("role") !== "listbox" && (J = K.current.parentElement.querySelector('[role="listbox"]')), !J)
      return;
    if (O === -1) {
      J.scrollTop = 0;
      return;
    }
    const ye = K.current.querySelector(`[data-option-index="${O}"]`);
    if (ye && (ye.classList.add(`${r}-focused`), B === "keyboard" && ye.classList.add(`${r}-focusVisible`), J.scrollHeight > J.clientHeight && B !== "mouse" && B !== "touch")) {
      const Ae = ye, je = J.clientHeight + J.scrollTop, Lr = Ae.offsetTop + Ae.offsetHeight;
      Lr > je ? J.scrollTop = Lr - J.clientHeight : Ae.offsetTop - Ae.offsetHeight * (P ? 1.3 : 0) < J.scrollTop && (J.scrollTop = Ae.offsetTop - Ae.offsetHeight * (P ? 1.3 : 0));
    }
  }), st = Vt(({
    event: C,
    diff: O,
    direction: B = "next",
    reason: se
  }) => {
    if (!qe)
      return;
    const ye = po((() => {
      const Ae = Ce.length - 1;
      if (O === "reset")
        return ut;
      if (O === "start")
        return 0;
      if (O === "end")
        return Ae;
      const je = Ie.current + O;
      return je < 0 ? je === -1 && z ? -1 : p && Ie.current !== -1 || Math.abs(O) > 1 ? 0 : Ae : je > Ae ? je === Ae + 1 && z ? -1 : p || Math.abs(O) > 1 ? Ae : 0 : je;
    })(), B);
    if (Et({
      index: ye,
      reason: se,
      event: C
    }), n && O !== "reset")
      if (ye === -1)
        H.current.value = le;
      else {
        const Ae = j(Ce[ye]);
        H.current.value = Ae, Ae.toLowerCase().indexOf(le.toLowerCase()) === 0 && le.length > 0 && H.current.setSelectionRange(le.length, Ae.length);
      }
  }), ho = () => {
    const C = (O, B) => {
      const se = O ? j(O) : "", J = B ? j(B) : "";
      return se === J;
    };
    if (Ie.current !== -1 && it.filteredOptions && it.filteredOptions.length !== Ce.length && it.inputValue === le && ($ ? X.length === it.value.length && it.value.every((O, B) => j(X[B]) === j(O)) : C(it.value, X))) {
      const O = it.filteredOptions[Ie.current];
      if (O)
        return Ce.findIndex((B) => j(B) === j(O));
    }
    return -1;
  }, _r = I.useCallback(() => {
    if (!qe)
      return;
    const C = ho();
    if (C !== -1) {
      Ie.current = C;
      return;
    }
    const O = $ ? X[0] : X;
    if (Ce.length === 0 || O == null) {
      st({
        diff: "reset"
      });
      return;
    }
    if (K.current) {
      if (O != null) {
        const B = Ce[Ie.current];
        if ($ && B && X.findIndex((J) => T(B, J)) !== -1)
          return;
        const se = Ce.findIndex((J) => T(J, O));
        se === -1 ? st({
          diff: "reset"
        }) : Et({
          index: se
        });
        return;
      }
      if (Ie.current >= Ce.length - 1) {
        Et({
          index: Ce.length - 1
        });
        return;
      }
      Et({
        index: Ie.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    Ce.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $ ? !1 : X,
    w,
    st,
    Et,
    qe,
    le,
    $
  ]), go = Vt((C) => {
    Uo(K, C), C && _r();
  });
  process.env.NODE_ENV !== "production" && I.useEffect(() => {
    (!H.current || H.current.nodeName !== "INPUT") && (H.current && H.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${u} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${H.current} while an HTMLInputElement was expected.`, `Instead, ${u} expects an input element.`, "", u === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [u]), I.useEffect(() => {
    _r();
  }, [_r]);
  const We = (C) => {
    Je || (_t(!0), Ot(!0), re && re(C));
  }, Kt = (C, O) => {
    Je && (_t(!1), Q && Q(C, O));
  }, xt = (C, O, B, se) => {
    if ($) {
      if (X.length === O.length && X.every((J, ye) => J === O[ye]))
        return;
    } else if (X === O)
      return;
    F && F(C, O, B, se), wt(O);
  }, ur = I.useRef(!1), dt = (C, O, B = "selectOption", se = "options") => {
    let J = B, ye = O;
    if ($) {
      if (ye = Array.isArray(X) ? X.slice() : [], process.env.NODE_ENV !== "production") {
        const je = ye.filter((Lr) => T(O, Lr));
        je.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${u} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${je.length} matches.`].join(`
`));
      }
      const Ae = ye.findIndex((je) => T(O, je));
      Ae === -1 ? ye.push(O) : se !== "freeSolo" && (ye.splice(Ae, 1), J = "removeOption");
    }
    pt(C, ye, J), xt(C, ye, J, {
      option: O
    }), !g && (!C || !C.ctrlKey && !C.metaKey) && Kt(C, J), (a === !0 || a === "touch" && ur.current || a === "mouse" && !ur.current) && H.current.blur();
  };
  function dn(C, O) {
    if (C === -1)
      return -1;
    let B = C;
    for (; ; ) {
      if (O === "next" && B === X.length || O === "previous" && B === -1)
        return -1;
      const se = W ? "data-item-index" : "data-tag-index", J = Se.querySelector(`[${se}="${B}"]`);
      if (!J || !J.hasAttribute("tabindex") || J.disabled || J.getAttribute("aria-disabled") === "true")
        B += O === "next" ? 1 : -1;
      else
        return B;
    }
  }
  const hn = (C, O) => {
    if (!$)
      return;
    le === "" && Kt(C, "toggleInput");
    let B = de;
    de === -1 ? le === "" && O === "previous" && (B = X.length - 1) : (B += O === "next" ? 1 : -1, B < 0 && (B = 0), B === X.length && (B = -1)), B = dn(B, O), Le(B), at(B);
  }, Xt = (C) => {
    U.current = !0, ze(""), Y && Y(C, "", "clear"), xt(C, $ ? [] : null, "clear");
  }, yo = (C) => (O) => {
    if (C.onKeyDown && C.onKeyDown(O), !O.defaultMuiPrevented && (de !== -1 && !["ArrowLeft", "ArrowRight"].includes(O.key) && (Le(-1), at(-1)), O.which !== 229))
      switch (O.key) {
        case "Home":
          qe && q && (O.preventDefault(), st({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: O
          }));
          break;
        case "End":
          qe && q && (O.preventDefault(), st({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: O
          }));
          break;
        case "PageUp":
          O.preventDefault(), st({
            diff: -5,
            direction: "previous",
            reason: "keyboard",
            event: O
          }), We(O);
          break;
        case "PageDown":
          O.preventDefault(), st({
            diff: wu,
            direction: "next",
            reason: "keyboard",
            event: O
          }), We(O);
          break;
        case "ArrowDown":
          O.preventDefault(), st({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: O
          }), We(O);
          break;
        case "ArrowUp":
          O.preventDefault(), st({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: O
          }), We(O);
          break;
        case "ArrowLeft":
          !$ && W ? at(0) : hn(O, "previous");
          break;
        case "ArrowRight":
          !$ && W ? at(-1) : hn(O, "next");
          break;
        case "Enter":
          if (Ie.current !== -1 && qe) {
            const B = Ce[Ie.current], se = x ? x(B) : !1;
            if (O.preventDefault(), se)
              return;
            dt(O, B, "selectOption"), n && H.current.setSelectionRange(H.current.value.length, H.current.value.length);
          } else R && le !== "" && fn === !1 && ($ && O.preventDefault(), dt(O, le, "createOption", "freeSolo"));
          break;
        case "Escape":
          qe ? (O.preventDefault(), O.stopPropagation(), Kt(O, "escape")) : l && (le !== "" || $ && X.length > 0 || W) && (O.preventDefault(), O.stopPropagation(), Xt(O));
          break;
        case "Backspace":
          if ($ && !A && le === "" && X.length > 0) {
            const B = de === -1 ? X.length - 1 : de, se = X.slice();
            se.splice(B, 1), xt(O, se, "removeOption", {
              option: X[B]
            });
          }
          !$ && W && !A && (wt(null), at(-1));
          break;
        case "Delete":
          if ($ && !A && le === "" && X.length > 0 && de !== -1) {
            const B = de, se = X.slice();
            se.splice(B, 1), xt(O, se, "removeOption", {
              option: X[B]
            });
          }
          !$ && W && !A && (wt(null), at(-1));
          break;
      }
  }, mo = (C) => {
    Gt(!0), Z && !U.current && We(C);
  }, Jt = (C) => {
    if (t(K)) {
      H.current.focus();
      return;
    }
    Gt(!1), G.current = !0, U.current = !1, i && Ie.current !== -1 && qe ? dt(C, Ce[Ie.current], "blur") : i && R && le !== "" ? dt(C, le, "blur", "freeSolo") : s && pt(C, X, "blur"), Kt(C, "blur");
  }, Mr = (C) => {
    const O = C.target.value;
    le !== O && (ze(O), Ot(!1), Y && Y(C, O, "input")), O === "" ? !h && !$ && xt(C, null, "clear") : We(C);
  }, Dr = (C) => {
    const O = Number(C.currentTarget.getAttribute("data-option-index"));
    Ie.current !== O && Et({
      event: C,
      index: O,
      reason: "mouse"
    });
  }, vo = (C) => {
    Et({
      event: C,
      index: Number(C.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), ur.current = !0;
  }, bo = (C) => {
    const O = Number(C.currentTarget.getAttribute("data-option-index"));
    dt(C, Ce[O], "selectOption"), ur.current = !1;
  }, gn = (C) => (O) => {
    const B = X.slice();
    B.splice(C, 1), xt(O, B, "removeOption", {
      option: X[C]
    });
  }, Xi = (C) => {
    xt(C, null, "removeOption", {
      option: X
    });
  }, fr = (C) => {
    Je ? Kt(C, "toggleInput") : We(C);
  }, De = (C) => {
    C.currentTarget.contains(C.target) && C.target.getAttribute("id") !== N && C.preventDefault();
  }, _e = (C) => {
    C.currentTarget.contains(C.target) && (H.current.focus(), _ && G.current && H.current.selectionEnd - H.current.selectionStart === 0 && H.current.select(), G.current = !1);
  }, Mt = (C) => {
    !m && (le === "" || !Je) && fr(C);
  };
  let Nr = R && le.length > 0;
  Nr = Nr || ($ ? X.length > 0 : X !== null);
  let yn = Ce;
  if (P) {
    const C = /* @__PURE__ */ new Map();
    let O = !1;
    yn = Ce.reduce((B, se, J) => {
      const ye = P(se);
      return B.length > 0 && B[B.length - 1].group === ye ? B[B.length - 1].options.push(se) : (process.env.NODE_ENV !== "production" && (C.get(ye) && !O && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${u} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), O = !0), C.set(ye, !0)), B.push({
        key: J,
        index: J,
        group: ye,
        options: [se]
      })), B;
    }, []);
  }
  return m && ee && Jt(), {
    getRootProps: (C = {}) => ({
      ...C,
      onKeyDown: yo(C),
      onMouseDown: De,
      onClick: _e
    }),
    getInputLabelProps: () => ({
      id: `${N}-label`,
      htmlFor: N
    }),
    getInputProps: () => ({
      id: N,
      value: le,
      onBlur: Jt,
      onFocus: mo,
      onChange: Mr,
      onMouseDown: Mt,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": qe ? "" : null,
      "aria-autocomplete": n ? "both" : "list",
      "aria-controls": pn ? `${N}-listbox` : void 0,
      "aria-expanded": pn,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: H,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: m
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Xt
    }),
    getItemProps: ({
      index: C = 0
    } = {}) => ({
      ...$ && {
        key: C
      },
      ...W ? {
        "data-item-index": C
      } : {
        "data-tag-index": C
      },
      tabIndex: -1,
      ...!A && {
        onDelete: $ ? gn(C) : Xi
      }
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: fr
    }),
    // deprecated
    getTagProps: ({
      index: C
    }) => ({
      key: C,
      "data-tag-index": C,
      tabIndex: -1,
      ...!A && {
        onDelete: gn(C)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${N}-listbox`,
      "aria-labelledby": `${N}-label`,
      ref: go,
      onMouseDown: (C) => {
        C.preventDefault();
      }
    }),
    getOptionProps: ({
      index: C,
      option: O
    }) => {
      const B = ($ ? X : [X]).some((J) => J != null && T(O, J)), se = x ? x(O) : !1;
      return {
        key: (b == null ? void 0 : b(O)) ?? j(O),
        tabIndex: -1,
        role: "option",
        id: `${N}-option-${C}`,
        onMouseMove: Dr,
        onClick: bo,
        onTouchStart: vo,
        "data-option-index": C,
        "aria-disabled": se,
        "aria-selected": B
      };
    },
    id: N,
    inputValue: le,
    value: X,
    dirty: Nr,
    expanded: qe && Se,
    popupOpen: qe,
    focused: ee || de !== -1,
    anchorEl: Se,
    setAnchorEl: V,
    focusedItem: de,
    // deprecated
    focusedTag: de,
    groupedOptions: yn
  };
}
const Cu = /* @__PURE__ */ I.createContext();
process.env.NODE_ENV !== "production" && (c.node, c.bool);
const Tu = () => I.useContext(Cu) ?? !1, Ei = c.oneOfType([c.func, c.object]);
function Jr(e, t, r, n, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], a = o || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${n} \`${a}\` supplied to \`${r}\`. Expected an HTMLElement.`) : null;
}
function wa(e) {
  return e && e.ownerDocument || document;
}
function Ht(...e) {
  const t = I.useRef(void 0), r = I.useCallback((n) => {
    const o = e.map((i) => {
      if (i == null)
        return null;
      if (typeof i == "function") {
        const a = i, s = a(n);
        return typeof s == "function" ? s : () => {
          a(null);
        };
      }
      return i.current = n, () => {
        i.current = null;
      };
    });
    return () => {
      o.forEach((i) => i == null ? void 0 : i());
    };
  }, e);
  return I.useMemo(() => e.every((n) => n == null) ? null : (n) => {
    t.current && (t.current(), t.current = void 0), n != null && (t.current = r(n));
  }, e);
}
var Ue = "top", rt = "bottom", nt = "right", He = "left", xi = "auto", an = [Ue, rt, nt, He], Cr = "start", Zr = "end", $u = "clippingParents", el = "viewport", Br = "popper", Iu = "reference", Oa = /* @__PURE__ */ an.reduce(function(e, t) {
  return e.concat([t + "-" + Cr, t + "-" + Zr]);
}, []), tl = /* @__PURE__ */ [].concat(an, [xi]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Cr, t + "-" + Zr]);
}, []), Ru = "beforeRead", ku = "read", Pu = "afterRead", Au = "beforeMain", _u = "main", Mu = "afterMain", Du = "beforeWrite", Nu = "write", Lu = "afterWrite", ju = [Ru, ku, Pu, Au, _u, Mu, Du, Nu, Lu];
function bt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Xe(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function cr(e) {
  var t = Xe(e).Element;
  return e instanceof t || e instanceof Element;
}
function tt(e) {
  var t = Xe(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Ci(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Xe(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Vu(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, o = t.attributes[r] || {}, i = t.elements[r];
    !tt(i) || !bt(i) || (Object.assign(i.style, n), Object.keys(o).forEach(function(a) {
      var s = o[a];
      s === !1 ? i.removeAttribute(a) : i.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function Bu(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var o = t.elements[n], i = t.attributes[n] || {}, a = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), s = a.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !tt(o) || !bt(o) || (Object.assign(o.style, s), Object.keys(i).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const Fu = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Vu,
  effect: Bu,
  requires: ["computeStyles"]
};
function vt(e) {
  return e.split("-")[0];
}
var sr = Math.max, Nn = Math.min, Tr = Math.round;
function Ho() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function rl() {
  return !/^((?!chrome|android).)*safari/i.test(Ho());
}
function $r(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), o = 1, i = 1;
  t && tt(e) && (o = e.offsetWidth > 0 && Tr(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && Tr(n.height) / e.offsetHeight || 1);
  var a = cr(e) ? Xe(e) : window, s = a.visualViewport, l = !rl() && r, u = (n.left + (l && s ? s.offsetLeft : 0)) / o, f = (n.top + (l && s ? s.offsetTop : 0)) / i, h = n.width / o, g = n.height / i;
  return {
    width: h,
    height: g,
    top: f,
    right: u + h,
    bottom: f + g,
    left: u,
    x: u,
    y: f
  };
}
function Ti(e) {
  var t = $r(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function nl(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Ci(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function kt(e) {
  return Xe(e).getComputedStyle(e);
}
function zu(e) {
  return ["table", "td", "th"].indexOf(bt(e)) >= 0;
}
function Yt(e) {
  return ((cr(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Zn(e) {
  return bt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Ci(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Yt(e)
  );
}
function Ea(e) {
  return !tt(e) || // https://github.com/popperjs/popper-core/issues/837
  kt(e).position === "fixed" ? null : e.offsetParent;
}
function qu(e) {
  var t = /firefox/i.test(Ho()), r = /Trident/i.test(Ho());
  if (r && tt(e)) {
    var n = kt(e);
    if (n.position === "fixed")
      return null;
  }
  var o = Zn(e);
  for (Ci(o) && (o = o.host); tt(o) && ["html", "body"].indexOf(bt(o)) < 0; ) {
    var i = kt(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function sn(e) {
  for (var t = Xe(e), r = Ea(e); r && zu(r) && kt(r).position === "static"; )
    r = Ea(r);
  return r && (bt(r) === "html" || bt(r) === "body" && kt(r).position === "static") ? t : r || qu(e) || t;
}
function $i(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Yr(e, t, r) {
  return sr(e, Nn(t, r));
}
function Wu(e, t, r) {
  var n = Yr(e, t, r);
  return n > r ? r : n;
}
function ol() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function il(e) {
  return Object.assign({}, ol(), e);
}
function al(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var Uu = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, il(typeof t != "number" ? t : al(t, an));
};
function Hu(e) {
  var t, r = e.state, n = e.name, o = e.options, i = r.elements.arrow, a = r.modifiersData.popperOffsets, s = vt(r.placement), l = $i(s), u = [He, nt].indexOf(s) >= 0, f = u ? "height" : "width";
  if (!(!i || !a)) {
    var h = Uu(o.padding, r), g = Ti(i), m = l === "y" ? Ue : He, y = l === "y" ? rt : nt, p = r.rects.reference[f] + r.rects.reference[l] - a[l] - r.rects.popper[f], v = a[l] - r.rects.reference[l], w = sn(i), R = w ? l === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, x = p / 2 - v / 2, b = h[m], S = R - g[f] - h[y], P = R / 2 - g[f] / 2 + x, q = Yr(b, P, S), D = l;
    r.modifiersData[n] = (t = {}, t[D] = q, t.centerOffset = q - P, t);
  }
}
function Yu(e) {
  var t = e.state, r = e.options, n = r.element, o = n === void 0 ? "[data-popper-arrow]" : n;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || nl(t.elements.popper, o) && (t.elements.arrow = o));
}
const Qu = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Hu,
  effect: Yu,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ir(e) {
  return e.split("-")[1];
}
var Gu = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ku(e, t) {
  var r = e.x, n = e.y, o = t.devicePixelRatio || 1;
  return {
    x: Tr(r * o) / o || 0,
    y: Tr(n * o) / o || 0
  };
}
function xa(e) {
  var t, r = e.popper, n = e.popperRect, o = e.placement, i = e.variation, a = e.offsets, s = e.position, l = e.gpuAcceleration, u = e.adaptive, f = e.roundOffsets, h = e.isFixed, g = a.x, m = g === void 0 ? 0 : g, y = a.y, p = y === void 0 ? 0 : y, v = typeof f == "function" ? f({
    x: m,
    y: p
  }) : {
    x: m,
    y: p
  };
  m = v.x, p = v.y;
  var w = a.hasOwnProperty("x"), R = a.hasOwnProperty("y"), x = He, b = Ue, S = window;
  if (u) {
    var P = sn(r), q = "clientHeight", D = "clientWidth";
    if (P === Xe(r) && (P = Yt(r), kt(P).position !== "static" && s === "absolute" && (q = "scrollHeight", D = "scrollWidth")), P = P, o === Ue || (o === He || o === nt) && i === Zr) {
      b = rt;
      var z = h && P === S && S.visualViewport ? S.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        P[q]
      );
      p -= z - n.height, p *= l ? 1 : -1;
    }
    if (o === He || (o === Ue || o === rt) && i === Zr) {
      x = nt;
      var d = h && P === S && S.visualViewport ? S.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        P[D]
      );
      m -= d - n.width, m *= l ? 1 : -1;
    }
  }
  var T = Object.assign({
    position: s
  }, u && Gu), $ = f === !0 ? Ku({
    x: m,
    y: p
  }, Xe(r)) : {
    x: m,
    y: p
  };
  if (m = $.x, p = $.y, l) {
    var F;
    return Object.assign({}, T, (F = {}, F[b] = R ? "0" : "", F[x] = w ? "0" : "", F.transform = (S.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + p + "px)" : "translate3d(" + m + "px, " + p + "px, 0)", F));
  }
  return Object.assign({}, T, (t = {}, t[b] = R ? p + "px" : "", t[x] = w ? m + "px" : "", t.transform = "", t));
}
function Xu(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, o = n === void 0 ? !0 : n, i = r.adaptive, a = i === void 0 ? !0 : i, s = r.roundOffsets, l = s === void 0 ? !0 : s, u = {
    placement: vt(t.placement),
    variation: Ir(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, xa(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, xa(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Ju = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Xu,
  data: {}
};
var On = {
  passive: !0
};
function Zu(e) {
  var t = e.state, r = e.instance, n = e.options, o = n.scroll, i = o === void 0 ? !0 : o, a = n.resize, s = a === void 0 ? !0 : a, l = Xe(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(f) {
    f.addEventListener("scroll", r.update, On);
  }), s && l.addEventListener("resize", r.update, On), function() {
    i && u.forEach(function(f) {
      f.removeEventListener("scroll", r.update, On);
    }), s && l.removeEventListener("resize", r.update, On);
  };
}
const ef = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Zu,
  data: {}
};
var tf = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function kn(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return tf[t];
  });
}
var rf = {
  start: "end",
  end: "start"
};
function Ca(e) {
  return e.replace(/start|end/g, function(t) {
    return rf[t];
  });
}
function Ii(e) {
  var t = Xe(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function Ri(e) {
  return $r(Yt(e)).left + Ii(e).scrollLeft;
}
function nf(e, t) {
  var r = Xe(e), n = Yt(e), o = r.visualViewport, i = n.clientWidth, a = n.clientHeight, s = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    var u = rl();
    (u || !u && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s + Ri(e),
    y: l
  };
}
function of(e) {
  var t, r = Yt(e), n = Ii(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = sr(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = sr(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -n.scrollLeft + Ri(e), l = -n.scrollTop;
  return kt(o || r).direction === "rtl" && (s += sr(r.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: s,
    y: l
  };
}
function ki(e) {
  var t = kt(e), r = t.overflow, n = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + n);
}
function sl(e) {
  return ["html", "body", "#document"].indexOf(bt(e)) >= 0 ? e.ownerDocument.body : tt(e) && ki(e) ? e : sl(Zn(e));
}
function Qr(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = sl(e), o = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Xe(n), a = o ? [i].concat(i.visualViewport || [], ki(n) ? n : []) : n, s = t.concat(a);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Qr(Zn(a)))
  );
}
function Yo(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function af(e, t) {
  var r = $r(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function Ta(e, t, r) {
  return t === el ? Yo(nf(e, r)) : cr(t) ? af(t, r) : Yo(of(Yt(e)));
}
function sf(e) {
  var t = Qr(Zn(e)), r = ["absolute", "fixed"].indexOf(kt(e).position) >= 0, n = r && tt(e) ? sn(e) : e;
  return cr(n) ? t.filter(function(o) {
    return cr(o) && nl(o, n) && bt(o) !== "body";
  }) : [];
}
function lf(e, t, r, n) {
  var o = t === "clippingParents" ? sf(e) : [].concat(t), i = [].concat(o, [r]), a = i[0], s = i.reduce(function(l, u) {
    var f = Ta(e, u, n);
    return l.top = sr(f.top, l.top), l.right = Nn(f.right, l.right), l.bottom = Nn(f.bottom, l.bottom), l.left = sr(f.left, l.left), l;
  }, Ta(e, a, n));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function ll(e) {
  var t = e.reference, r = e.element, n = e.placement, o = n ? vt(n) : null, i = n ? Ir(n) : null, a = t.x + t.width / 2 - r.width / 2, s = t.y + t.height / 2 - r.height / 2, l;
  switch (o) {
    case Ue:
      l = {
        x: a,
        y: t.y - r.height
      };
      break;
    case rt:
      l = {
        x: a,
        y: t.y + t.height
      };
      break;
    case nt:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case He:
      l = {
        x: t.x - r.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = o ? $i(o) : null;
  if (u != null) {
    var f = u === "y" ? "height" : "width";
    switch (i) {
      case Cr:
        l[u] = l[u] - (t[f] / 2 - r[f] / 2);
        break;
      case Zr:
        l[u] = l[u] + (t[f] / 2 - r[f] / 2);
        break;
    }
  }
  return l;
}
function en(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = n === void 0 ? e.placement : n, i = r.strategy, a = i === void 0 ? e.strategy : i, s = r.boundary, l = s === void 0 ? $u : s, u = r.rootBoundary, f = u === void 0 ? el : u, h = r.elementContext, g = h === void 0 ? Br : h, m = r.altBoundary, y = m === void 0 ? !1 : m, p = r.padding, v = p === void 0 ? 0 : p, w = il(typeof v != "number" ? v : al(v, an)), R = g === Br ? Iu : Br, x = e.rects.popper, b = e.elements[y ? R : g], S = lf(cr(b) ? b : b.contextElement || Yt(e.elements.popper), l, f, a), P = $r(e.elements.reference), q = ll({
    reference: P,
    element: x,
    placement: o
  }), D = Yo(Object.assign({}, x, q)), z = g === Br ? D : P, d = {
    top: S.top - z.top + w.top,
    bottom: z.bottom - S.bottom + w.bottom,
    left: S.left - z.left + w.left,
    right: z.right - S.right + w.right
  }, T = e.modifiersData.offset;
  if (g === Br && T) {
    var $ = T[o];
    Object.keys(d).forEach(function(F) {
      var Q = [nt, rt].indexOf(F) >= 0 ? 1 : -1, ae = [Ue, rt].indexOf(F) >= 0 ? "y" : "x";
      d[F] += $[ae] * Q;
    });
  }
  return d;
}
function cf(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = r.boundary, i = r.rootBoundary, a = r.padding, s = r.flipVariations, l = r.allowedAutoPlacements, u = l === void 0 ? tl : l, f = Ir(n), h = f ? s ? Oa : Oa.filter(function(y) {
    return Ir(y) === f;
  }) : an, g = h.filter(function(y) {
    return u.indexOf(y) >= 0;
  });
  g.length === 0 && (g = h);
  var m = g.reduce(function(y, p) {
    return y[p] = en(e, {
      placement: p,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[vt(p)], y;
  }, {});
  return Object.keys(m).sort(function(y, p) {
    return m[y] - m[p];
  });
}
function uf(e) {
  if (vt(e) === xi)
    return [];
  var t = kn(e);
  return [Ca(e), t, Ca(t)];
}
function ff(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var o = r.mainAxis, i = o === void 0 ? !0 : o, a = r.altAxis, s = a === void 0 ? !0 : a, l = r.fallbackPlacements, u = r.padding, f = r.boundary, h = r.rootBoundary, g = r.altBoundary, m = r.flipVariations, y = m === void 0 ? !0 : m, p = r.allowedAutoPlacements, v = t.options.placement, w = vt(v), R = w === v, x = l || (R || !y ? [kn(v)] : uf(v)), b = [v].concat(x).reduce(function(M, N) {
      return M.concat(vt(N) === xi ? cf(t, {
        placement: N,
        boundary: f,
        rootBoundary: h,
        padding: u,
        flipVariations: y,
        allowedAutoPlacements: p
      }) : N);
    }, []), S = t.rects.reference, P = t.rects.popper, q = /* @__PURE__ */ new Map(), D = !0, z = b[0], d = 0; d < b.length; d++) {
      var T = b[d], $ = vt(T), F = Ir(T) === Cr, Q = [Ue, rt].indexOf($) >= 0, ae = Q ? "width" : "height", Y = en(t, {
        placement: T,
        boundary: f,
        rootBoundary: h,
        altBoundary: g,
        padding: u
      }), re = Q ? F ? nt : He : F ? rt : Ue;
      S[ae] > P[ae] && (re = kn(re));
      var oe = kn(re), Z = [];
      if (i && Z.push(Y[$] <= 0), s && Z.push(Y[re] <= 0, Y[oe] <= 0), Z.every(function(M) {
        return M;
      })) {
        z = T, D = !1;
        break;
      }
      q.set(T, Z);
    }
    if (D)
      for (var k = y ? 3 : 1, A = function(N) {
        var j = b.find(function(U) {
          var G = q.get(U);
          if (G)
            return G.slice(0, N).every(function(H) {
              return H;
            });
        });
        if (j)
          return z = j, "break";
      }, W = k; W > 0; W--) {
        var _ = A(W);
        if (_ === "break") break;
      }
    t.placement !== z && (t.modifiersData[n]._skip = !0, t.placement = z, t.reset = !0);
  }
}
const pf = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: ff,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function $a(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Ia(e) {
  return [Ue, nt, rt, He].some(function(t) {
    return e[t] >= 0;
  });
}
function df(e) {
  var t = e.state, r = e.name, n = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, a = en(t, {
    elementContext: "reference"
  }), s = en(t, {
    altBoundary: !0
  }), l = $a(a, n), u = $a(s, o, i), f = Ia(l), h = Ia(u);
  t.modifiersData[r] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: f,
    hasPopperEscaped: h
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": h
  });
}
const hf = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: df
};
function gf(e, t, r) {
  var n = vt(e), o = [He, Ue].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, a = i[0], s = i[1];
  return a = a || 0, s = (s || 0) * o, [He, nt].indexOf(n) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function yf(e) {
  var t = e.state, r = e.options, n = e.name, o = r.offset, i = o === void 0 ? [0, 0] : o, a = tl.reduce(function(f, h) {
    return f[h] = gf(h, t.rects, i), f;
  }, {}), s = a[t.placement], l = s.x, u = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[n] = a;
}
const mf = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: yf
};
function vf(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = ll({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const bf = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: vf,
  data: {}
};
function Sf(e) {
  return e === "x" ? "y" : "x";
}
function wf(e) {
  var t = e.state, r = e.options, n = e.name, o = r.mainAxis, i = o === void 0 ? !0 : o, a = r.altAxis, s = a === void 0 ? !1 : a, l = r.boundary, u = r.rootBoundary, f = r.altBoundary, h = r.padding, g = r.tether, m = g === void 0 ? !0 : g, y = r.tetherOffset, p = y === void 0 ? 0 : y, v = en(t, {
    boundary: l,
    rootBoundary: u,
    padding: h,
    altBoundary: f
  }), w = vt(t.placement), R = Ir(t.placement), x = !R, b = $i(w), S = Sf(b), P = t.modifiersData.popperOffsets, q = t.rects.reference, D = t.rects.popper, z = typeof p == "function" ? p(Object.assign({}, t.rects, {
    placement: t.placement
  })) : p, d = typeof z == "number" ? {
    mainAxis: z,
    altAxis: z
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, z), T = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, $ = {
    x: 0,
    y: 0
  };
  if (P) {
    if (i) {
      var F, Q = b === "y" ? Ue : He, ae = b === "y" ? rt : nt, Y = b === "y" ? "height" : "width", re = P[b], oe = re + v[Q], Z = re - v[ae], k = m ? -D[Y] / 2 : 0, A = R === Cr ? q[Y] : D[Y], W = R === Cr ? -D[Y] : -q[Y], _ = t.elements.arrow, M = m && _ ? Ti(_) : {
        width: 0,
        height: 0
      }, N = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : ol(), j = N[Q], U = N[ae], G = Yr(0, q[Y], M[Y]), H = x ? q[Y] / 2 - k - G - j - d.mainAxis : A - G - j - d.mainAxis, K = x ? -q[Y] / 2 + k + G + U + d.mainAxis : W + G + U + d.mainAxis, Se = t.elements.arrow && sn(t.elements.arrow), V = Se ? b === "y" ? Se.clientTop || 0 : Se.clientLeft || 0 : 0, de = (F = T == null ? void 0 : T[b]) != null ? F : 0, Le = re + H - de - V, ut = re + K - de, Ie = Yr(m ? Nn(oe, Le) : oe, re, m ? sr(Z, ut) : Z);
      P[b] = Ie, $[b] = Ie - re;
    }
    if (s) {
      var ft, X = b === "x" ? Ue : He, wt = b === "x" ? rt : nt, le = P[S], ze = S === "y" ? "height" : "width", ee = le + v[X], Gt = le - v[wt], pt = [Ue, He].indexOf(w) !== -1, Je = (ft = T == null ? void 0 : T[S]) != null ? ft : 0, _t = pt ? ee : le - q[ze] - D[ze] - Je + d.altAxis, Ar = pt ? le + q[ze] + D[ze] - Je - d.altAxis : Gt, Ot = m && pt ? Wu(_t, le, Ar) : Yr(m ? _t : ee, le, m ? Ar : Gt);
      P[S] = Ot, $[S] = Ot - le;
    }
    t.modifiersData[n] = $;
  }
}
const Of = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: wf,
  requiresIfExists: ["offset"]
};
function Ef(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function xf(e) {
  return e === Xe(e) || !tt(e) ? Ii(e) : Ef(e);
}
function Cf(e) {
  var t = e.getBoundingClientRect(), r = Tr(t.width) / e.offsetWidth || 1, n = Tr(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function Tf(e, t, r) {
  r === void 0 && (r = !1);
  var n = tt(t), o = tt(t) && Cf(t), i = Yt(t), a = $r(e, o, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((bt(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  ki(i)) && (s = xf(t)), tt(t) ? (l = $r(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = Ri(i))), {
    x: a.left + s.scrollLeft - l.x,
    y: a.top + s.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function $f(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    r.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(s) {
      if (!r.has(s)) {
        var l = t.get(s);
        l && o(l);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || o(i);
  }), n;
}
function If(e) {
  var t = $f(e);
  return ju.reduce(function(r, n) {
    return r.concat(t.filter(function(o) {
      return o.phase === n;
    }));
  }, []);
}
function Rf(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function kf(e) {
  var t = e.reduce(function(r, n) {
    var o = r[n.name];
    return r[n.name] = o ? Object.assign({}, o, n, {
      options: Object.assign({}, o.options, n.options),
      data: Object.assign({}, o.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Ra = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function ka() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Pf(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, o = t.defaultOptions, i = o === void 0 ? Ra : o;
  return function(s, l, u) {
    u === void 0 && (u = i);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ra, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, h = [], g = !1, m = {
      state: f,
      setOptions: function(w) {
        var R = typeof w == "function" ? w(f.options) : w;
        p(), f.options = Object.assign({}, i, f.options, R), f.scrollParents = {
          reference: cr(s) ? Qr(s) : s.contextElement ? Qr(s.contextElement) : [],
          popper: Qr(l)
        };
        var x = If(kf([].concat(n, f.options.modifiers)));
        return f.orderedModifiers = x.filter(function(b) {
          return b.enabled;
        }), y(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var w = f.elements, R = w.reference, x = w.popper;
          if (ka(R, x)) {
            f.rects = {
              reference: Tf(R, sn(x), f.options.strategy === "fixed"),
              popper: Ti(x)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(d) {
              return f.modifiersData[d.name] = Object.assign({}, d.data);
            });
            for (var b = 0; b < f.orderedModifiers.length; b++) {
              if (f.reset === !0) {
                f.reset = !1, b = -1;
                continue;
              }
              var S = f.orderedModifiers[b], P = S.fn, q = S.options, D = q === void 0 ? {} : q, z = S.name;
              typeof P == "function" && (f = P({
                state: f,
                options: D,
                name: z,
                instance: m
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Rf(function() {
        return new Promise(function(v) {
          m.forceUpdate(), v(f);
        });
      }),
      destroy: function() {
        p(), g = !0;
      }
    };
    if (!ka(s, l))
      return m;
    m.setOptions(u).then(function(v) {
      !g && u.onFirstUpdate && u.onFirstUpdate(v);
    });
    function y() {
      f.orderedModifiers.forEach(function(v) {
        var w = v.name, R = v.options, x = R === void 0 ? {} : R, b = v.effect;
        if (typeof b == "function") {
          var S = b({
            state: f,
            name: w,
            instance: m,
            options: x
          }), P = function() {
          };
          h.push(S || P);
        }
      });
    }
    function p() {
      h.forEach(function(v) {
        return v();
      }), h = [];
    }
    return m;
  };
}
var Af = [ef, bf, Ju, Fu, mf, pf, Of, Qu, hf], _f = /* @__PURE__ */ Pf({
  defaultModifiers: Af
});
function Mf(e) {
  return typeof e == "string";
}
function cl(e, t, r) {
  return e === void 0 || Mf(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...r
    }
  };
}
function Df(e, t = []) {
  if (e === void 0)
    return {};
  const r = {};
  return Object.keys(e).filter((n) => n.match(/^on[A-Z]/) && typeof e[n] == "function" && !t.includes(n)).forEach((n) => {
    r[n] = e[n];
  }), r;
}
function Pa(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((r) => !(r.match(/^on[A-Z]/) && typeof e[r] == "function")).forEach((r) => {
    t[r] = e[r];
  }), t;
}
function ul(e) {
  const {
    getSlotProps: t,
    additionalProps: r,
    externalSlotProps: n,
    externalForwardedProps: o,
    className: i
  } = e;
  if (!t) {
    const m = xe(r == null ? void 0 : r.className, i, o == null ? void 0 : o.className, n == null ? void 0 : n.className), y = {
      ...r == null ? void 0 : r.style,
      ...o == null ? void 0 : o.style,
      ...n == null ? void 0 : n.style
    }, p = {
      ...r,
      ...o,
      ...n
    };
    return m.length > 0 && (p.className = m), Object.keys(y).length > 0 && (p.style = y), {
      props: p,
      internalRef: void 0
    };
  }
  const a = Df({
    ...o,
    ...n
  }), s = Pa(n), l = Pa(o), u = t(a), f = xe(u == null ? void 0 : u.className, r == null ? void 0 : r.className, i, o == null ? void 0 : o.className, n == null ? void 0 : n.className), h = {
    ...u == null ? void 0 : u.style,
    ...r == null ? void 0 : r.style,
    ...o == null ? void 0 : o.style,
    ...n == null ? void 0 : n.style
  }, g = {
    ...u,
    ...r,
    ...l,
    ...s
  };
  return f.length > 0 && (g.className = f), Object.keys(h).length > 0 && (g.style = h), {
    props: g,
    internalRef: u.ref
  };
}
function fl(e, t, r) {
  return typeof e == "function" ? e(t, r) : e;
}
function Nf(e) {
  var h;
  const {
    elementType: t,
    externalSlotProps: r,
    ownerState: n,
    skipResolvingSlotProps: o = !1,
    ...i
  } = e, a = o ? {} : fl(r, n), {
    props: s,
    internalRef: l
  } = ul({
    ...i,
    externalSlotProps: a
  }), u = Ht(l, a == null ? void 0 : a.ref, (h = e.additionalProps) == null ? void 0 : h.ref);
  return cl(t, {
    ...s,
    ref: u
  }, n);
}
function Lf(e) {
  var t;
  return parseInt(I.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
const jf = "exact-prop: ​";
function Vf(e) {
  return process.env.NODE_ENV === "production" ? e : {
    ...e,
    [jf]: (t) => {
      const r = Object.keys(t).filter((n) => !e.hasOwnProperty(n));
      return r.length > 0 ? new Error(`The following props are not supported: ${r.map((n) => `\`${n}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function Bf(e) {
  return typeof e == "function" ? e() : e;
}
const Ln = /* @__PURE__ */ I.forwardRef(function(t, r) {
  const {
    children: n,
    container: o,
    disablePortal: i = !1
  } = t, [a, s] = I.useState(null), l = Ht(/* @__PURE__ */ I.isValidElement(n) ? Lf(n) : null, r);
  if (Xr(() => {
    i || s(Bf(o) || document.body);
  }, [o, i]), Xr(() => {
    if (a && !i)
      return Uo(r, a), () => {
        Uo(r, null);
      };
  }, [r, a, i]), i) {
    if (/* @__PURE__ */ I.isValidElement(n)) {
      const u = {
        ref: l
      };
      return /* @__PURE__ */ I.cloneElement(n, u);
    }
    return n;
  }
  return a && /* @__PURE__ */ Oc.createPortal(n, a);
});
process.env.NODE_ENV !== "production" && (Ln.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: c.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([Jr, c.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool
});
process.env.NODE_ENV !== "production" && (Ln.propTypes = Vf(Ln.propTypes));
const Aa = (e) => e, Ff = () => {
  let e = Aa;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = Aa;
    }
  };
}, zf = Ff(), qf = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function ct(e, t, r = "Mui") {
  const n = qf[t];
  return n ? `${r}-${n}` : `${zf.generate(e)}-${t}`;
}
function Qe(e, t, r = "Mui") {
  const n = {};
  return t.forEach((o) => {
    n[o] = ct(e, o, r);
  }), n;
}
function Wf(e) {
  return ct("MuiPopper", e);
}
Qe("MuiPopper", ["root"]);
function Uf(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function jn(e) {
  return typeof e == "function" ? e() : e;
}
function eo(e) {
  return e.nodeType !== void 0;
}
function Hf(e) {
  return !eo(e);
}
const Yf = (e) => {
  const {
    classes: t
  } = e;
  return At({
    root: ["root"]
  }, Wf, t);
}, Qf = {}, Gf = /* @__PURE__ */ I.forwardRef(function(t, r) {
  const {
    anchorEl: n,
    children: o,
    direction: i,
    disablePortal: a,
    modifiers: s,
    open: l,
    placement: u,
    popperOptions: f,
    popperRef: h,
    slotProps: g = {},
    slots: m = {},
    TransitionProps: y,
    // @ts-ignore internal logic
    ownerState: p,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...v
  } = t, w = I.useRef(null), R = Ht(w, r), x = I.useRef(null), b = Ht(x, h), S = I.useRef(b);
  Xr(() => {
    S.current = b;
  }, [b]), I.useImperativeHandle(h, () => x.current, []);
  const P = Uf(u, i), [q, D] = I.useState(P), [z, d] = I.useState(jn(n));
  I.useEffect(() => {
    x.current && x.current.forceUpdate();
  }), I.useEffect(() => {
    n && d(jn(n));
  }, [n]), Xr(() => {
    if (!z || !l)
      return;
    const ae = (oe) => {
      D(oe.placement);
    };
    if (process.env.NODE_ENV !== "production" && z && eo(z) && z.nodeType === 1) {
      const oe = z.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && oe.top === 0 && oe.left === 0 && oe.right === 0 && oe.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let Y = [{
      name: "preventOverflow",
      options: {
        altBoundary: a
      }
    }, {
      name: "flip",
      options: {
        altBoundary: a
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: oe
      }) => {
        ae(oe);
      }
    }];
    s != null && (Y = Y.concat(s)), f && f.modifiers != null && (Y = Y.concat(f.modifiers));
    const re = _f(z, w.current, {
      placement: P,
      ...f,
      modifiers: Y
    });
    return S.current(re), () => {
      re.destroy(), S.current(null);
    };
  }, [z, a, s, l, f, P]);
  const T = {
    placement: q
  };
  y !== null && (T.TransitionProps = y);
  const $ = Yf(t), F = m.root ?? "div", Q = Nf({
    elementType: F,
    externalSlotProps: g.root,
    externalForwardedProps: v,
    additionalProps: {
      role: "tooltip",
      ref: R
    },
    ownerState: t,
    className: $.root
  });
  return /* @__PURE__ */ L(F, {
    ...Q,
    children: typeof o == "function" ? o(T) : o
  });
}), pl = /* @__PURE__ */ I.forwardRef(function(t, r) {
  const {
    anchorEl: n,
    children: o,
    container: i,
    direction: a = "ltr",
    disablePortal: s = !1,
    keepMounted: l = !1,
    modifiers: u,
    open: f,
    placement: h = "bottom",
    popperOptions: g = Qf,
    popperRef: m,
    style: y,
    transition: p = !1,
    slotProps: v = {},
    slots: w = {},
    ...R
  } = t, [x, b] = I.useState(!0), S = () => {
    b(!1);
  }, P = () => {
    b(!0);
  };
  if (!l && !f && (!p || x))
    return null;
  let q;
  if (i)
    q = i;
  else if (n) {
    const d = jn(n);
    q = d && eo(d) ? wa(d).body : wa(null).body;
  }
  const D = !f && l && (!p || x) ? "none" : void 0, z = p ? {
    in: f,
    onEnter: S,
    onExited: P
  } : void 0;
  return /* @__PURE__ */ L(Ln, {
    disablePortal: s,
    container: q,
    children: /* @__PURE__ */ L(Gf, {
      anchorEl: n,
      direction: a,
      disablePortal: s,
      modifiers: u,
      ref: r,
      open: p ? !x : f,
      placement: h,
      popperOptions: g,
      popperRef: m,
      slotProps: v,
      slots: w,
      ...R,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: D,
        ...y
      },
      TransitionProps: z,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (pl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: lr(c.oneOfType([Jr, c.object, c.func]), (e) => {
    if (e.open) {
      const t = jn(e.anchorEl);
      if (t && eo(t) && t.nodeType === 1) {
        const r = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && r.top === 0 && r.left === 0 && r.right === 0 && r.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || Hf(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: c.oneOfType([c.node, c.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([Jr, c.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: c.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: c.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: c.arrayOf(c.shape({
    data: c.object,
    effect: c.func,
    enabled: c.bool,
    fn: c.func,
    name: c.any,
    options: c.object,
    phase: c.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: c.arrayOf(c.string),
    requiresIfExists: c.arrayOf(c.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: c.shape({
    modifiers: c.array,
    onFirstUpdate: c.func,
    placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: c.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Ei,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: c.shape({
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: c.shape({
    root: c.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: c.bool
});
function te(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Wt(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
var Qo = { exports: {} }, he = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _a;
function Kf() {
  if (_a) return he;
  _a = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), a = Symbol.for("react.context"), s = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.view_transition"), m = Symbol.for("react.client.reference");
  function y(p) {
    if (typeof p == "object" && p !== null) {
      var v = p.$$typeof;
      switch (v) {
        case e:
          switch (p = p.type, p) {
            case r:
            case o:
            case n:
            case l:
            case u:
            case g:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case a:
                case s:
                case h:
                case f:
                  return p;
                case i:
                  return p;
                default:
                  return v;
              }
          }
        case t:
          return v;
      }
    }
  }
  return he.ContextConsumer = i, he.ContextProvider = a, he.Element = e, he.ForwardRef = s, he.Fragment = r, he.Lazy = h, he.Memo = f, he.Portal = t, he.Profiler = o, he.StrictMode = n, he.Suspense = l, he.SuspenseList = u, he.isContextConsumer = function(p) {
    return y(p) === i;
  }, he.isContextProvider = function(p) {
    return y(p) === a;
  }, he.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === e;
  }, he.isForwardRef = function(p) {
    return y(p) === s;
  }, he.isFragment = function(p) {
    return y(p) === r;
  }, he.isLazy = function(p) {
    return y(p) === h;
  }, he.isMemo = function(p) {
    return y(p) === f;
  }, he.isPortal = function(p) {
    return y(p) === t;
  }, he.isProfiler = function(p) {
    return y(p) === o;
  }, he.isStrictMode = function(p) {
    return y(p) === n;
  }, he.isSuspense = function(p) {
    return y(p) === l;
  }, he.isSuspenseList = function(p) {
    return y(p) === u;
  }, he.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === r || p === o || p === n || p === l || p === u || typeof p == "object" && p !== null && (p.$$typeof === h || p.$$typeof === f || p.$$typeof === a || p.$$typeof === i || p.$$typeof === s || p.$$typeof === m || p.getModuleId !== void 0);
  }, he.typeOf = y, he;
}
var ge = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ma;
function Xf() {
  return Ma || (Ma = 1, process.env.NODE_ENV !== "production" && function() {
    function e(p) {
      if (typeof p == "object" && p !== null) {
        var v = p.$$typeof;
        switch (v) {
          case t:
            switch (p = p.type, p) {
              case n:
              case i:
              case o:
              case u:
              case f:
              case m:
                return p;
              default:
                switch (p = p && p.$$typeof, p) {
                  case s:
                  case l:
                  case g:
                  case h:
                    return p;
                  case a:
                    return p;
                  default:
                    return v;
                }
            }
          case r:
            return v;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), m = Symbol.for("react.view_transition"), y = Symbol.for("react.client.reference");
    ge.ContextConsumer = a, ge.ContextProvider = s, ge.Element = t, ge.ForwardRef = l, ge.Fragment = n, ge.Lazy = g, ge.Memo = h, ge.Portal = r, ge.Profiler = i, ge.StrictMode = o, ge.Suspense = u, ge.SuspenseList = f, ge.isContextConsumer = function(p) {
      return e(p) === a;
    }, ge.isContextProvider = function(p) {
      return e(p) === s;
    }, ge.isElement = function(p) {
      return typeof p == "object" && p !== null && p.$$typeof === t;
    }, ge.isForwardRef = function(p) {
      return e(p) === l;
    }, ge.isFragment = function(p) {
      return e(p) === n;
    }, ge.isLazy = function(p) {
      return e(p) === g;
    }, ge.isMemo = function(p) {
      return e(p) === h;
    }, ge.isPortal = function(p) {
      return e(p) === r;
    }, ge.isProfiler = function(p) {
      return e(p) === i;
    }, ge.isStrictMode = function(p) {
      return e(p) === o;
    }, ge.isSuspense = function(p) {
      return e(p) === u;
    }, ge.isSuspenseList = function(p) {
      return e(p) === f;
    }, ge.isValidElementType = function(p) {
      return typeof p == "string" || typeof p == "function" || p === n || p === i || p === o || p === u || p === f || typeof p == "object" && p !== null && (p.$$typeof === g || p.$$typeof === h || p.$$typeof === s || p.$$typeof === a || p.$$typeof === l || p.$$typeof === y || p.getModuleId !== void 0);
    }, ge.typeOf = e;
  }()), ge;
}
process.env.NODE_ENV === "production" ? Qo.exports = Kf() : Qo.exports = Xf();
var Vn = Qo.exports;
function It(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function dl(e) {
  if (/* @__PURE__ */ I.isValidElement(e) || Vn.isValidElementType(e) || !It(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((r) => {
    t[r] = dl(e[r]);
  }), t;
}
function Ke(e, t, r = {
  clone: !0
}) {
  const n = r.clone ? {
    ...e
  } : e;
  return It(e) && It(t) && Object.keys(t).forEach((o) => {
    /* @__PURE__ */ I.isValidElement(t[o]) || Vn.isValidElementType(t[o]) ? n[o] = t[o] : It(t[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && It(e[o]) ? n[o] = Ke(e[o], t[o], r) : r.clone ? n[o] = It(t[o]) ? dl(t[o]) : t[o] : n[o] = t[o];
  }), n;
}
function Gr(e, t) {
  return t ? Ke(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Qt = process.env.NODE_ENV !== "production" ? c.oneOfType([c.number, c.string, c.object, c.array]) : {};
function Jf(e, t) {
  if (!e.containerQueries)
    return t;
  const r = Object.keys(t).filter((n) => n.startsWith("@container")).sort((n, o) => {
    var a, s;
    const i = /min-width:\s*([0-9.]+)/;
    return +(((a = n.match(i)) == null ? void 0 : a[1]) || 0) - +(((s = o.match(i)) == null ? void 0 : s[1]) || 0);
  });
  return r.length ? r.reduce((n, o) => {
    const i = t[o];
    return delete n[o], n[o] = i, n;
  }, {
    ...t
  }) : t;
}
function Zf(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((r) => t.startsWith(`@${r}`)) || !!t.match(/^@\d/));
}
function ep(e, t) {
  const r = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!r) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : Wt(18, `(${t})`));
    return null;
  }
  const [, n, o] = r, i = Number.isNaN(+n) ? n || 0 : +n;
  return e.containerQueries(o).up(i);
}
function tp(e) {
  const t = (i, a) => i.replace("@media", a ? `@container ${a}` : "@container");
  function r(i, a) {
    i.up = (...s) => t(e.breakpoints.up(...s), a), i.down = (...s) => t(e.breakpoints.down(...s), a), i.between = (...s) => t(e.breakpoints.between(...s), a), i.only = (...s) => t(e.breakpoints.only(...s), a), i.not = (...s) => {
      const l = t(e.breakpoints.not(...s), a);
      return l.includes("not all and") ? l.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : l;
    };
  }
  const n = {}, o = (i) => (r(n, i), n);
  return r(o), {
    ...e,
    containerQueries: o
  };
}
const to = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, Da = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${to[e]}px)`
}, rp = {
  containerQueries: (e) => ({
    up: (t) => {
      let r = typeof t == "number" ? t : to[t] || t;
      return typeof r == "number" && (r = `${r}px`), e ? `@container ${e} (min-width:${r})` : `@container (min-width:${r})`;
    }
  })
};
function Pt(e, t, r) {
  const n = e.theme || {};
  if (Array.isArray(t)) {
    const i = n.breakpoints || Da;
    return t.reduce((a, s, l) => (a[i.up(i.keys[l])] = r(t[l]), a), {});
  }
  if (typeof t == "object") {
    const i = n.breakpoints || Da;
    return Object.keys(t).reduce((a, s) => {
      if (Zf(i.keys, s)) {
        const l = ep(n.containerQueries ? n : rp, s);
        l && (a[l] = r(t[s], s));
      } else if (Object.keys(i.values || to).includes(s)) {
        const l = i.up(s);
        a[l] = r(t[s], s);
      } else {
        const l = s;
        a[l] = t[l];
      }
      return a;
    }, {});
  }
  return r(t);
}
function np(e = {}) {
  var r;
  return ((r = e.keys) == null ? void 0 : r.reduce((n, o) => {
    const i = e.up(o);
    return n[i] = {}, n;
  }, {})) || {};
}
function op(e, t) {
  return e.reduce((r, n) => {
    const o = r[n];
    return (!o || Object.keys(o).length === 0) && delete r[n], r;
  }, t);
}
function ro(e, t, r = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && r) {
    const n = `vars.${t}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (n != null)
      return n;
  }
  return t.split(".").reduce((n, o) => n && n[o] != null ? n[o] : null, e);
}
function Bn(e, t, r, n = r) {
  let o;
  return typeof e == "function" ? o = e(r) : Array.isArray(e) ? o = e[r] || n : o = ro(e, r) || n, t && (o = t(o, n, e)), o;
}
function Pe(e) {
  const {
    prop: t,
    cssProperty: r = e.prop,
    themeKey: n,
    transform: o
  } = e, i = (a) => {
    if (a[t] == null)
      return null;
    const s = a[t], l = a.theme, u = ro(l, n) || {};
    return Pt(a, s, (h) => {
      let g = Bn(u, o, h);
      return h === g && typeof h == "string" && (g = Bn(u, o, `${t}${h === "default" ? "" : te(h)}`, h)), r === !1 ? g : {
        [r]: g
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: Qt
  } : {}, i.filterProps = [t], i;
}
function ip(e) {
  const t = {};
  return (r) => (t[r] === void 0 && (t[r] = e(r)), t[r]);
}
const ap = {
  m: "margin",
  p: "padding"
}, sp = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, Na = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, lp = ip((e) => {
  if (e.length > 2)
    if (Na[e])
      e = Na[e];
    else
      return [e];
  const [t, r] = e.split(""), n = ap[t], o = sp[r] || "";
  return Array.isArray(o) ? o.map((i) => n + i) : [n + o];
}), no = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], oo = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], cp = [...no, ...oo];
function ln(e, t, r, n) {
  const o = ro(e, t, !0) ?? r;
  return typeof o == "number" || typeof o == "string" ? (i) => typeof i == "string" ? i : (process.env.NODE_ENV !== "production" && typeof i != "number" && console.error(`MUI: Expected ${n} argument to be a number or a string, got ${i}.`), typeof o == "string" ? o.startsWith("var(") && i === 0 ? 0 : o.startsWith("var(") && i === 1 ? o : `calc(${i} * ${o})` : o * i) : Array.isArray(o) ? (i) => {
    if (typeof i == "string")
      return i;
    const a = Math.abs(i);
    process.env.NODE_ENV !== "production" && (Number.isInteger(a) ? a > o.length - 1 && console.error([`MUI: The value provided (${a}) overflows.`, `The supported values are: ${JSON.stringify(o)}.`, `${a} > ${o.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const s = o[a];
    return i >= 0 ? s : typeof s == "number" ? -s : typeof s == "string" && s.startsWith("var(") ? `calc(-1 * ${s})` : `-${s}`;
  } : typeof o == "function" ? o : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${o}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function Pi(e) {
  return ln(e, "spacing", 8, "spacing");
}
function cn(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function up(e, t) {
  return (r) => e.reduce((n, o) => (n[o] = cn(t, r), n), {});
}
function fp(e, t, r, n) {
  if (!t.includes(r))
    return null;
  const o = lp(r), i = up(o, n), a = e[r];
  return Pt(e, a, i);
}
function hl(e, t) {
  const r = Pi(e.theme);
  return Object.keys(e).map((n) => fp(e, t, n, r)).reduce(Gr, {});
}
function Re(e) {
  return hl(e, no);
}
Re.propTypes = process.env.NODE_ENV !== "production" ? no.reduce((e, t) => (e[t] = Qt, e), {}) : {};
Re.filterProps = no;
function ke(e) {
  return hl(e, oo);
}
ke.propTypes = process.env.NODE_ENV !== "production" ? oo.reduce((e, t) => (e[t] = Qt, e), {}) : {};
ke.filterProps = oo;
process.env.NODE_ENV !== "production" && cp.reduce((e, t) => (e[t] = Qt, e), {});
function io(...e) {
  const t = e.reduce((n, o) => (o.filterProps.forEach((i) => {
    n[i] = o;
  }), n), {}), r = (n) => Object.keys(n).reduce((o, i) => t[i] ? Gr(o, t[i](n)) : o, {});
  return r.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((n, o) => Object.assign(n, o.propTypes), {}) : {}, r.filterProps = e.reduce((n, o) => n.concat(o.filterProps), []), r;
}
function et(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function ot(e, t) {
  return Pe({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const pp = ot("border", et), dp = ot("borderTop", et), hp = ot("borderRight", et), gp = ot("borderBottom", et), yp = ot("borderLeft", et), mp = ot("borderColor"), vp = ot("borderTopColor"), bp = ot("borderRightColor"), Sp = ot("borderBottomColor"), wp = ot("borderLeftColor"), Op = ot("outline", et), Ep = ot("outlineColor"), ao = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = ln(e.theme, "shape.borderRadius", 4, "borderRadius"), r = (n) => ({
      borderRadius: cn(t, n)
    });
    return Pt(e, e.borderRadius, r);
  }
  return null;
};
ao.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Qt
} : {};
ao.filterProps = ["borderRadius"];
io(pp, dp, hp, gp, yp, mp, vp, bp, Sp, wp, ao, Op, Ep);
const so = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = ln(e.theme, "spacing", 8, "gap"), r = (n) => ({
      gap: cn(t, n)
    });
    return Pt(e, e.gap, r);
  }
  return null;
};
so.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Qt
} : {};
so.filterProps = ["gap"];
const lo = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = ln(e.theme, "spacing", 8, "columnGap"), r = (n) => ({
      columnGap: cn(t, n)
    });
    return Pt(e, e.columnGap, r);
  }
  return null;
};
lo.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Qt
} : {};
lo.filterProps = ["columnGap"];
const co = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = ln(e.theme, "spacing", 8, "rowGap"), r = (n) => ({
      rowGap: cn(t, n)
    });
    return Pt(e, e.rowGap, r);
  }
  return null;
};
co.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Qt
} : {};
co.filterProps = ["rowGap"];
const xp = Pe({
  prop: "gridColumn"
}), Cp = Pe({
  prop: "gridRow"
}), Tp = Pe({
  prop: "gridAutoFlow"
}), $p = Pe({
  prop: "gridAutoColumns"
}), Ip = Pe({
  prop: "gridAutoRows"
}), Rp = Pe({
  prop: "gridTemplateColumns"
}), kp = Pe({
  prop: "gridTemplateRows"
}), Pp = Pe({
  prop: "gridTemplateAreas"
}), Ap = Pe({
  prop: "gridArea"
});
io(so, lo, co, xp, Cp, Tp, $p, Ip, Rp, kp, Pp, Ap);
function Er(e, t) {
  return t === "grey" ? t : e;
}
const _p = Pe({
  prop: "color",
  themeKey: "palette",
  transform: Er
}), Mp = Pe({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Er
}), Dp = Pe({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Er
});
io(_p, Mp, Dp);
function Ge(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const Np = Pe({
  prop: "width",
  transform: Ge
}), Ai = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (r) => {
      var o, i, a, s, l;
      const n = ((a = (i = (o = e.theme) == null ? void 0 : o.breakpoints) == null ? void 0 : i.values) == null ? void 0 : a[r]) || to[r];
      return n ? ((l = (s = e.theme) == null ? void 0 : s.breakpoints) == null ? void 0 : l.unit) !== "px" ? {
        maxWidth: `${n}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: n
      } : {
        maxWidth: Ge(r)
      };
    };
    return Pt(e, e.maxWidth, t);
  }
  return null;
};
Ai.filterProps = ["maxWidth"];
const Lp = Pe({
  prop: "minWidth",
  transform: Ge
}), jp = Pe({
  prop: "height",
  transform: Ge
}), Vp = Pe({
  prop: "maxHeight",
  transform: Ge
}), Bp = Pe({
  prop: "minHeight",
  transform: Ge
});
Pe({
  prop: "size",
  cssProperty: "width",
  transform: Ge
});
Pe({
  prop: "size",
  cssProperty: "height",
  transform: Ge
});
const Fp = Pe({
  prop: "boxSizing"
});
io(Np, Ai, Lp, jp, Vp, Bp, Fp);
const uo = {
  // borders
  border: {
    themeKey: "borders",
    transform: et
  },
  borderTop: {
    themeKey: "borders",
    transform: et
  },
  borderRight: {
    themeKey: "borders",
    transform: et
  },
  borderBottom: {
    themeKey: "borders",
    transform: et
  },
  borderLeft: {
    themeKey: "borders",
    transform: et
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: et
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: ao
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Er
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Er
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Er
  },
  // spacing
  p: {
    style: ke
  },
  pt: {
    style: ke
  },
  pr: {
    style: ke
  },
  pb: {
    style: ke
  },
  pl: {
    style: ke
  },
  px: {
    style: ke
  },
  py: {
    style: ke
  },
  padding: {
    style: ke
  },
  paddingTop: {
    style: ke
  },
  paddingRight: {
    style: ke
  },
  paddingBottom: {
    style: ke
  },
  paddingLeft: {
    style: ke
  },
  paddingX: {
    style: ke
  },
  paddingY: {
    style: ke
  },
  paddingInline: {
    style: ke
  },
  paddingInlineStart: {
    style: ke
  },
  paddingInlineEnd: {
    style: ke
  },
  paddingBlock: {
    style: ke
  },
  paddingBlockStart: {
    style: ke
  },
  paddingBlockEnd: {
    style: ke
  },
  m: {
    style: Re
  },
  mt: {
    style: Re
  },
  mr: {
    style: Re
  },
  mb: {
    style: Re
  },
  ml: {
    style: Re
  },
  mx: {
    style: Re
  },
  my: {
    style: Re
  },
  margin: {
    style: Re
  },
  marginTop: {
    style: Re
  },
  marginRight: {
    style: Re
  },
  marginBottom: {
    style: Re
  },
  marginLeft: {
    style: Re
  },
  marginX: {
    style: Re
  },
  marginY: {
    style: Re
  },
  marginInline: {
    style: Re
  },
  marginInlineStart: {
    style: Re
  },
  marginInlineEnd: {
    style: Re
  },
  marginBlock: {
    style: Re
  },
  marginBlockStart: {
    style: Re
  },
  marginBlockEnd: {
    style: Re
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: so
  },
  rowGap: {
    style: co
  },
  columnGap: {
    style: lo
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Ge
  },
  maxWidth: {
    style: Ai
  },
  minWidth: {
    transform: Ge
  },
  height: {
    transform: Ge
  },
  maxHeight: {
    transform: Ge
  },
  minHeight: {
    transform: Ge
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function zp(...e) {
  const t = e.reduce((n, o) => n.concat(Object.keys(o)), []), r = new Set(t);
  return e.every((n) => r.size === Object.keys(n).length);
}
function qp(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Wp() {
  function e(r, n, o, i) {
    const a = {
      [r]: n,
      theme: o
    }, s = i[r];
    if (!s)
      return {
        [r]: n
      };
    const {
      cssProperty: l = r,
      themeKey: u,
      transform: f,
      style: h
    } = s;
    if (n == null)
      return null;
    if (u === "typography" && n === "inherit")
      return {
        [r]: n
      };
    const g = ro(o, u) || {};
    return h ? h(a) : Pt(a, n, (y) => {
      let p = Bn(g, f, y);
      return y === p && typeof y == "string" && (p = Bn(g, f, `${r}${y === "default" ? "" : te(y)}`, y)), l === !1 ? p : {
        [l]: p
      };
    });
  }
  function t(r) {
    const {
      sx: n,
      theme: o = {}
    } = r || {};
    if (!n)
      return null;
    const i = o.unstable_sxConfig ?? uo;
    function a(s) {
      let l = s;
      if (typeof s == "function")
        l = s(o);
      else if (typeof s != "object")
        return s;
      if (!l)
        return null;
      const u = np(o.breakpoints), f = Object.keys(u);
      let h = u;
      return Object.keys(l).forEach((g) => {
        const m = qp(l[g], o);
        if (m != null)
          if (typeof m == "object")
            if (i[g])
              h = Gr(h, e(g, m, o, i));
            else {
              const y = Pt({
                theme: o
              }, m, (p) => ({
                [g]: p
              }));
              zp(y, m) ? h[g] = t({
                sx: m,
                theme: o
              }) : h = Gr(h, y);
            }
          else
            h = Gr(h, e(g, m, o, i));
      }), Jf(o, op(f, h));
    }
    return Array.isArray(n) ? n.map(a) : a(n);
  }
  return t;
}
const Rr = Wp();
Rr.filterProps = ["sx"];
function Up(e) {
  for (var t = 0, r, n = 0, o = e.length; o >= 4; ++n, o -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Hp = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function Yp(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var Qp = /[A-Z]|^ms/g, Gp = /_EMO_([^_]+?)_([^]*?)_EMO_/g, gl = function(t) {
  return t.charCodeAt(1) === 45;
}, La = function(t) {
  return t != null && typeof t != "boolean";
}, Io = /* @__PURE__ */ Yp(function(e) {
  return gl(e) ? e : e.replace(Qp, "-$&").toLowerCase();
}), ja = function(t, r) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(Gp, function(n, o, i) {
          return Bt = {
            name: o,
            styles: i,
            next: Bt
          }, o;
        });
  }
  return Hp[t] !== 1 && !gl(t) && typeof r == "number" && r !== 0 ? r + "px" : r;
};
function Fn(e, t, r) {
  if (r == null)
    return "";
  var n = r;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      var o = r;
      if (o.anim === 1)
        return Bt = {
          name: o.name,
          styles: o.styles,
          next: Bt
        }, o.name;
      var i = r;
      if (i.styles !== void 0) {
        var a = i.next;
        if (a !== void 0)
          for (; a !== void 0; )
            Bt = {
              name: a.name,
              styles: a.styles,
              next: Bt
            }, a = a.next;
        var s = i.styles + ";";
        return s;
      }
      return Kp(e, t, r);
    }
  }
  var l = r;
  return l;
}
function Kp(e, t, r) {
  var n = "";
  if (Array.isArray(r))
    for (var o = 0; o < r.length; o++)
      n += Fn(e, t, r[o]) + ";";
  else
    for (var i in r) {
      var a = r[i];
      if (typeof a != "object") {
        var s = a;
        La(s) && (n += Io(i) + ":" + ja(i, s) + ";");
      } else if (Array.isArray(a) && typeof a[0] == "string" && t == null)
        for (var l = 0; l < a.length; l++)
          La(a[l]) && (n += Io(i) + ":" + ja(i, a[l]) + ";");
      else {
        var u = Fn(e, t, a);
        switch (i) {
          case "animation":
          case "animationName": {
            n += Io(i) + ":" + u + ";";
            break;
          }
          default:
            n += i + "{" + u + "}";
        }
      }
    }
  return n;
}
var Va = /label:\s*([^\s;{]+)\s*(;|$)/g, Bt;
function Xp(e, t, r) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var n = !0, o = "";
  Bt = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    n = !1, o += Fn(r, t, i);
  else {
    var a = i;
    o += a[0];
  }
  for (var s = 1; s < e.length; s++)
    if (o += Fn(r, t, e[s]), n) {
      var l = i;
      o += l[s];
    }
  Va.lastIndex = 0;
  for (var u = "", f; (f = Va.exec(o)) !== null; )
    u += "-" + f[1];
  var h = Up(o) + u;
  return {
    name: h,
    styles: o,
    next: Bt
  };
}
/**
 * @mui/styled-engine v7.1.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function Jp(e, t) {
  const r = bc(e, t);
  return process.env.NODE_ENV !== "production" ? (...n) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return n.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : n.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), r(...n);
  } : r;
}
function Zp(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const Ba = [];
function Fa(e) {
  return Ba[0] = e, Xp(Ba);
}
const ed = (e) => {
  const t = Object.keys(e).map((r) => ({
    key: r,
    val: e[r]
  })) || [];
  return t.sort((r, n) => r.val - n.val), t.reduce((r, n) => ({
    ...r,
    [n.key]: n.val
  }), {});
};
function td(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: r = "px",
    step: n = 5,
    ...o
  } = e, i = ed(t), a = Object.keys(i);
  function s(g) {
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${r})`;
  }
  function l(g) {
    return `@media (max-width:${(typeof t[g] == "number" ? t[g] : g) - n / 100}${r})`;
  }
  function u(g, m) {
    const y = a.indexOf(m);
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${r}) and (max-width:${(y !== -1 && typeof t[a[y]] == "number" ? t[a[y]] : m) - n / 100}${r})`;
  }
  function f(g) {
    return a.indexOf(g) + 1 < a.length ? u(g, a[a.indexOf(g) + 1]) : s(g);
  }
  function h(g) {
    const m = a.indexOf(g);
    return m === 0 ? s(a[1]) : m === a.length - 1 ? l(a[m]) : u(g, a[a.indexOf(g) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: a,
    values: i,
    up: s,
    down: l,
    between: u,
    only: f,
    not: h,
    unit: r,
    ...o
  };
}
const rd = {
  borderRadius: 4
};
function yl(e = 8, t = Pi({
  spacing: e
})) {
  if (e.mui)
    return e;
  const r = (...n) => (process.env.NODE_ENV !== "production" && (n.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${n.length}`)), (n.length === 0 ? [1] : n).map((i) => {
    const a = t(i);
    return typeof a == "number" ? `${a}px` : a;
  }).join(" "));
  return r.mui = !0, r;
}
function nd(e, t) {
  var n;
  const r = this;
  if (r.vars) {
    if (!((n = r.colorSchemes) != null && n[e]) || typeof r.getColorSchemeSelector != "function")
      return {};
    let o = r.getColorSchemeSelector(e);
    return o === "&" ? t : ((o.includes("data-") || o.includes(".")) && (o = `*:where(${o.replace(/\s*&$/, "")}) &`), {
      [o]: t
    });
  }
  return r.palette.mode === e ? t : {};
}
function _i(e = {}, ...t) {
  const {
    breakpoints: r = {},
    palette: n = {},
    spacing: o,
    shape: i = {},
    ...a
  } = e, s = td(r), l = yl(o);
  let u = Ke({
    breakpoints: s,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...n
    },
    spacing: l,
    shape: {
      ...rd,
      ...i
    }
  }, a);
  return u = tp(u), u.applyStyles = nd, u = t.reduce((f, h) => Ke(f, h), u), u.unstable_sxConfig = {
    ...uo,
    ...a == null ? void 0 : a.unstable_sxConfig
  }, u.unstable_sx = function(h) {
    return Rr({
      sx: h,
      theme: this
    });
  }, u;
}
function od(e) {
  return Object.keys(e).length === 0;
}
function id(e = null) {
  const t = I.useContext(Sc);
  return !t || od(t) ? e : t;
}
const ad = _i();
function sd(e = ad) {
  return id(e);
}
function ml(e, t = "") {
  return e.displayName || e.name || t;
}
function za(e, t, r) {
  const n = ml(t);
  return e.displayName || (n !== "" ? `${r}(${n})` : r);
}
function ld(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return ml(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case Vn.ForwardRef:
          return za(e, e.render, "ForwardRef");
        case Vn.Memo:
          return za(e, e.type, "memo");
        default:
          return;
      }
  }
}
function vl(e) {
  const {
    variants: t,
    ...r
  } = e, n = {
    variants: t,
    style: Fa(r),
    isProcessed: !0
  };
  return n.style === r || t && t.forEach((o) => {
    typeof o.style != "function" && (o.style = Fa(o.style));
  }), n;
}
const cd = _i();
function Ro(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function ud(e) {
  return e ? (t, r) => r[e] : null;
}
function fd(e, t, r) {
  e.theme = gd(e.theme) ? r : e.theme[t] || e.theme;
}
function Pn(e, t) {
  const r = typeof t == "function" ? t(e) : t;
  if (Array.isArray(r))
    return r.flatMap((n) => Pn(e, n));
  if (Array.isArray(r == null ? void 0 : r.variants)) {
    let n;
    if (r.isProcessed)
      n = r.style;
    else {
      const {
        variants: o,
        ...i
      } = r;
      n = i;
    }
    return bl(e, r.variants, [n]);
  }
  return r != null && r.isProcessed ? r.style : r;
}
function bl(e, t, r = []) {
  var o;
  let n;
  e: for (let i = 0; i < t.length; i += 1) {
    const a = t[i];
    if (typeof a.props == "function") {
      if (n ?? (n = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !a.props(n))
        continue;
    } else
      for (const s in a.props)
        if (e[s] !== a.props[s] && ((o = e.ownerState) == null ? void 0 : o[s]) !== a.props[s])
          continue e;
    typeof a.style == "function" ? (n ?? (n = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), r.push(a.style(n))) : r.push(a.style);
  }
  return r;
}
function pd(e = {}) {
  const {
    themeId: t,
    defaultTheme: r = cd,
    rootShouldForwardProp: n = Ro,
    slotShouldForwardProp: o = Ro
  } = e;
  function i(s) {
    fd(s, t, r);
  }
  return (s, l = {}) => {
    Zp(s, (S) => S.filter((P) => P !== Rr));
    const {
      name: u,
      slot: f,
      skipVariantsResolver: h,
      skipSx: g,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: m = ud(Sl(f)),
      ...y
    } = l, p = h !== void 0 ? h : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      f && f !== "Root" && f !== "root" || !1
    ), v = g || !1;
    let w = Ro;
    f === "Root" || f === "root" ? w = n : f ? w = o : yd(s) && (w = void 0);
    const R = Jp(s, {
      shouldForwardProp: w,
      label: hd(u, f),
      ...y
    }), x = (S) => {
      if (typeof S == "function" && S.__emotion_real !== S)
        return function(q) {
          return Pn(q, S);
        };
      if (It(S)) {
        const P = vl(S);
        return P.variants ? function(D) {
          return Pn(D, P);
        } : P.style;
      }
      return S;
    }, b = (...S) => {
      const P = [], q = S.map(x), D = [];
      if (P.push(i), u && m && D.push(function($) {
        var Y, re;
        const Q = (re = (Y = $.theme.components) == null ? void 0 : Y[u]) == null ? void 0 : re.styleOverrides;
        if (!Q)
          return null;
        const ae = {};
        for (const oe in Q)
          ae[oe] = Pn($, Q[oe]);
        return m($, ae);
      }), u && !p && D.push(function($) {
        var ae, Y;
        const F = $.theme, Q = (Y = (ae = F == null ? void 0 : F.components) == null ? void 0 : ae[u]) == null ? void 0 : Y.variants;
        return Q ? bl($, Q) : null;
      }), v || D.push(Rr), Array.isArray(q[0])) {
        const T = q.shift(), $ = new Array(P.length).fill(""), F = new Array(D.length).fill("");
        let Q;
        Q = [...$, ...T, ...F], Q.raw = [...$, ...T.raw, ...F], P.unshift(Q);
      }
      const z = [...P, ...q, ...D], d = R(...z);
      return s.muiName && (d.muiName = s.muiName), process.env.NODE_ENV !== "production" && (d.displayName = dd(u, f, s)), d;
    };
    return R.withConfig && (b.withConfig = R.withConfig), b;
  };
}
function dd(e, t, r) {
  return e ? `${e}${te(t || "")}` : `Styled(${ld(r)})`;
}
function hd(e, t) {
  let r;
  return process.env.NODE_ENV !== "production" && e && (r = `${e}-${Sl(t || "Root")}`), r;
}
function gd(e) {
  for (const t in e)
    return !1;
  return !0;
}
function yd(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function Sl(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
function Go(e, t) {
  const r = {
    ...t
  };
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      const o = n;
      if (o === "components" || o === "slots")
        r[o] = {
          ...e[o],
          ...r[o]
        };
      else if (o === "componentsProps" || o === "slotProps") {
        const i = e[o], a = t[o];
        if (!a)
          r[o] = i || {};
        else if (!i)
          r[o] = a;
        else {
          r[o] = {
            ...a
          };
          for (const s in i)
            if (Object.prototype.hasOwnProperty.call(i, s)) {
              const l = s;
              r[o][l] = Go(i[l], a[l]);
            }
        }
      } else r[o] === void 0 && (r[o] = e[o]);
    }
  return r;
}
const md = /* @__PURE__ */ I.createContext(void 0);
process.env.NODE_ENV !== "production" && (c.node, c.object);
function vd(e) {
  const {
    theme: t,
    name: r,
    props: n
  } = e;
  if (!t || !t.components || !t.components[r])
    return n;
  const o = t.components[r];
  return o.defaultProps ? Go(o.defaultProps, n) : !o.styleOverrides && !o.variants ? Go(o, n) : n;
}
function bd({
  props: e,
  name: t
}) {
  const r = I.useContext(md);
  return vd({
    props: e,
    name: t,
    theme: {
      components: r
    }
  });
}
const qa = {
  theme: void 0
};
function Sd(e) {
  let t, r;
  return function(o) {
    let i = t;
    return (i === void 0 || o.theme !== r) && (qa.theme = o.theme, i = vl(e(qa)), t = i, r = o.theme), i;
  };
}
function wd(e = "") {
  function t(...n) {
    if (!n.length)
      return "";
    const o = n[0];
    return typeof o == "string" && !o.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${o}${t(...n.slice(1))})` : `, ${o}`;
  }
  return (n, ...o) => `var(--${e ? `${e}-` : ""}${n}${t(...o)})`;
}
const Wa = (e, t, r, n = []) => {
  let o = e;
  t.forEach((i, a) => {
    a === t.length - 1 ? Array.isArray(o) ? o[Number(i)] = r : o && typeof o == "object" && (o[i] = r) : o && typeof o == "object" && (o[i] || (o[i] = n.includes(i) ? [] : {}), o = o[i]);
  });
}, Od = (e, t, r) => {
  function n(o, i = [], a = []) {
    Object.entries(o).forEach(([s, l]) => {
      (!r || r && !r([...i, s])) && l != null && (typeof l == "object" && Object.keys(l).length > 0 ? n(l, [...i, s], Array.isArray(l) ? [...a, s] : a) : t([...i, s], l, a));
    });
  }
  n(e);
}, Ed = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((n) => e.includes(n)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function ko(e, t) {
  const {
    prefix: r,
    shouldSkipGeneratingVar: n
  } = t || {}, o = {}, i = {}, a = {};
  return Od(
    e,
    (s, l, u) => {
      if ((typeof l == "string" || typeof l == "number") && (!n || !n(s, l))) {
        const f = `--${r ? `${r}-` : ""}${s.join("-")}`, h = Ed(s, l);
        Object.assign(o, {
          [f]: h
        }), Wa(i, s, `var(${f})`, u), Wa(a, s, `var(${f}, ${h})`, u);
      }
    },
    (s) => s[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: o,
    vars: i,
    varsWithDefaults: a
  };
}
function xd(e, t = {}) {
  const {
    getSelector: r = v,
    disableCssColorScheme: n,
    colorSchemeSelector: o
  } = t, {
    colorSchemes: i = {},
    components: a,
    defaultColorScheme: s = "light",
    ...l
  } = e, {
    vars: u,
    css: f,
    varsWithDefaults: h
  } = ko(l, t);
  let g = h;
  const m = {}, {
    [s]: y,
    ...p
  } = i;
  if (Object.entries(p || {}).forEach(([x, b]) => {
    const {
      vars: S,
      css: P,
      varsWithDefaults: q
    } = ko(b, t);
    g = Ke(g, q), m[x] = {
      css: P,
      vars: S
    };
  }), y) {
    const {
      css: x,
      vars: b,
      varsWithDefaults: S
    } = ko(y, t);
    g = Ke(g, S), m[s] = {
      css: x,
      vars: b
    };
  }
  function v(x, b) {
    var P, q;
    let S = o;
    if (o === "class" && (S = ".%s"), o === "data" && (S = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (S = `[${o}="%s"]`), x) {
      if (S === "media")
        return e.defaultColorScheme === x ? ":root" : {
          [`@media (prefers-color-scheme: ${((q = (P = i[x]) == null ? void 0 : P.palette) == null ? void 0 : q.mode) || x})`]: {
            ":root": b
          }
        };
      if (S)
        return e.defaultColorScheme === x ? `:root, ${S.replace("%s", String(x))}` : S.replace("%s", String(x));
    }
    return ":root";
  }
  return {
    vars: g,
    generateThemeVars: () => {
      let x = {
        ...u
      };
      return Object.entries(m).forEach(([, {
        vars: b
      }]) => {
        x = Ke(x, b);
      }), x;
    },
    generateStyleSheets: () => {
      var D, z;
      const x = [], b = e.defaultColorScheme || "light";
      function S(d, T) {
        Object.keys(T).length && x.push(typeof d == "string" ? {
          [d]: {
            ...T
          }
        } : d);
      }
      S(r(void 0, {
        ...f
      }), f);
      const {
        [b]: P,
        ...q
      } = m;
      if (P) {
        const {
          css: d
        } = P, T = (z = (D = i[b]) == null ? void 0 : D.palette) == null ? void 0 : z.mode, $ = !n && T ? {
          colorScheme: T,
          ...d
        } : {
          ...d
        };
        S(r(b, {
          ...$
        }), $);
      }
      return Object.entries(q).forEach(([d, {
        css: T
      }]) => {
        var Q, ae;
        const $ = (ae = (Q = i[d]) == null ? void 0 : Q.palette) == null ? void 0 : ae.mode, F = !n && $ ? {
          colorScheme: $,
          ...T
        } : {
          ...T
        };
        S(r(d, {
          ...F
        }), F);
      }), x;
    }
  };
}
function Cd(e) {
  return function(r) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && r !== "light" && r !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${r}'.`), `@media (prefers-color-scheme: ${r})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${r}"] &` : e === "class" ? `.${r} &` : e === "data" ? `[data-${r}] &` : `${e.replace("%s", r)} &` : "&";
  };
}
const tn = {
  black: "#000",
  white: "#fff"
}, Td = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, pr = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, dr = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, Fr = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, hr = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, gr = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, yr = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function wl() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: tn.white,
      default: tn.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const $d = wl();
function Ol() {
  return {
    text: {
      primary: tn.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: tn.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const Ua = Ol();
function Ha(e, t, r, n) {
  const o = n.light || n, i = n.dark || n * 1.5;
  e[t] || (e.hasOwnProperty(r) ? e[t] = e[r] : t === "light" ? e.light = Oi(e.main, o) : t === "dark" && (e.dark = wi(e.main, i)));
}
function Id(e = "light") {
  return e === "dark" ? {
    main: hr[200],
    light: hr[50],
    dark: hr[400]
  } : {
    main: hr[700],
    light: hr[400],
    dark: hr[800]
  };
}
function Rd(e = "light") {
  return e === "dark" ? {
    main: pr[200],
    light: pr[50],
    dark: pr[400]
  } : {
    main: pr[500],
    light: pr[300],
    dark: pr[700]
  };
}
function kd(e = "light") {
  return e === "dark" ? {
    main: dr[500],
    light: dr[300],
    dark: dr[700]
  } : {
    main: dr[700],
    light: dr[400],
    dark: dr[800]
  };
}
function Pd(e = "light") {
  return e === "dark" ? {
    main: gr[400],
    light: gr[300],
    dark: gr[700]
  } : {
    main: gr[700],
    light: gr[500],
    dark: gr[900]
  };
}
function Ad(e = "light") {
  return e === "dark" ? {
    main: yr[400],
    light: yr[300],
    dark: yr[700]
  } : {
    main: yr[800],
    light: yr[500],
    dark: yr[900]
  };
}
function _d(e = "light") {
  return e === "dark" ? {
    main: Fr[400],
    light: Fr[300],
    dark: Fr[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Fr[500],
    dark: Fr[900]
  };
}
function Mi(e) {
  const {
    mode: t = "light",
    contrastThreshold: r = 3,
    tonalOffset: n = 0.2,
    ...o
  } = e, i = e.primary || Id(t), a = e.secondary || Rd(t), s = e.error || kd(t), l = e.info || Pd(t), u = e.success || Ad(t), f = e.warning || _d(t);
  function h(p) {
    const v = ya(p, Ua.text.primary) >= r ? Ua.text.primary : $d.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const w = ya(p, v);
      w < 3 && console.error([`MUI: The contrast ratio of ${w}:1 for ${v} on ${p}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return v;
  }
  const g = ({
    color: p,
    name: v,
    mainShade: w = 500,
    lightShade: R = 300,
    darkShade: x = 700
  }) => {
    if (p = {
      ...p
    }, !p.main && p[w] && (p.main = p[w]), !p.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${v ? ` (${v})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${w}\` property.` : Wt(11, v ? ` (${v})` : "", w));
    if (typeof p.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${v ? ` (${v})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(p.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Wt(12, v ? ` (${v})` : "", JSON.stringify(p.main)));
    return Ha(p, "light", R, n), Ha(p, "dark", x, n), p.contrastText || (p.contrastText = h(p.main)), p;
  };
  let m;
  return t === "light" ? m = wl() : t === "dark" && (m = Ol()), process.env.NODE_ENV !== "production" && (m || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), Ke({
    // A collection of common colors.
    common: {
      ...tn
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: g({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: g({
      color: a,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: g({
      color: s,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: g({
      color: f,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: g({
      color: l,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: g({
      color: u,
      name: "success"
    }),
    // The grey colors.
    grey: Td,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: r,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: h,
    // Generate a rich color object.
    augmentColor: g,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n,
    // The light and dark mode object.
    ...m
  }, o);
}
function Md(e) {
  const t = {};
  return Object.entries(e).forEach((n) => {
    const [o, i] = n;
    typeof i == "object" && (t[o] = `${i.fontStyle ? `${i.fontStyle} ` : ""}${i.fontVariant ? `${i.fontVariant} ` : ""}${i.fontWeight ? `${i.fontWeight} ` : ""}${i.fontStretch ? `${i.fontStretch} ` : ""}${i.fontSize || ""}${i.lineHeight ? `/${i.lineHeight} ` : ""}${i.fontFamily || ""}`);
  }), t;
}
function Dd(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function Nd(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Ya = {
  textTransform: "uppercase"
}, Qa = '"Roboto", "Helvetica", "Arial", sans-serif';
function Ld(e, t) {
  const {
    fontFamily: r = Qa,
    // The default font size of the Material Specification.
    fontSize: n = 14,
    // px
    fontWeightLight: o = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: a = 500,
    fontWeightBold: s = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: l = 16,
    // Apply the CSS properties to all the variants.
    allVariants: u,
    pxToRem: f,
    ...h
  } = typeof t == "function" ? t(e) : t;
  process.env.NODE_ENV !== "production" && (typeof n != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof l != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const g = n / 14, m = f || ((v) => `${v / l * g}rem`), y = (v, w, R, x, b) => ({
    fontFamily: r,
    fontWeight: v,
    fontSize: m(w),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: R,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...r === Qa ? {
      letterSpacing: `${Nd(x / w)}em`
    } : {},
    ...b,
    ...u
  }), p = {
    h1: y(o, 96, 1.167, -1.5),
    h2: y(o, 60, 1.2, -0.5),
    h3: y(i, 48, 1.167, 0),
    h4: y(i, 34, 1.235, 0.25),
    h5: y(i, 24, 1.334, 0),
    h6: y(a, 20, 1.6, 0.15),
    subtitle1: y(i, 16, 1.75, 0.15),
    subtitle2: y(a, 14, 1.57, 0.1),
    body1: y(i, 16, 1.5, 0.15),
    body2: y(i, 14, 1.43, 0.15),
    button: y(a, 14, 1.75, 0.4, Ya),
    caption: y(i, 12, 1.66, 0.4),
    overline: y(i, 12, 2.66, 1, Ya),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Ke({
    htmlFontSize: l,
    pxToRem: m,
    fontFamily: r,
    fontSize: n,
    fontWeightLight: o,
    fontWeightRegular: i,
    fontWeightMedium: a,
    fontWeightBold: s,
    ...p
  }, h, {
    clone: !1
    // No need to clone deep
  });
}
const jd = 0.2, Vd = 0.14, Bd = 0.12;
function Oe(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${jd})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${Vd})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Bd})`].join(",");
}
const Fd = ["none", Oe(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Oe(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Oe(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Oe(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Oe(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Oe(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Oe(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Oe(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Oe(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Oe(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Oe(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Oe(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Oe(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Oe(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Oe(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Oe(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Oe(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Oe(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Oe(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Oe(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Oe(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Oe(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Oe(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Oe(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], zd = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, qd = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Ga(e) {
  return `${Math.round(e)}ms`;
}
function Wd(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function Ud(e) {
  const t = {
    ...zd,
    ...e.easing
  }, r = {
    ...qd,
    ...e.duration
  };
  return {
    getAutoHeightDuration: Wd,
    create: (o = ["all"], i = {}) => {
      const {
        duration: a = r.standard,
        easing: s = t.easeInOut,
        delay: l = 0,
        ...u
      } = i;
      if (process.env.NODE_ENV !== "production") {
        const f = (g) => typeof g == "string", h = (g) => !Number.isNaN(parseFloat(g));
        !f(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !h(a) && !f(a) && console.error(`MUI: Argument "duration" must be a number or a string but found ${a}.`), f(s) || console.error('MUI: Argument "easing" must be a string.'), !h(l) && !f(l) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(u).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(u).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((f) => `${f} ${typeof a == "string" ? a : Ga(a)} ${s} ${typeof l == "string" ? l : Ga(l)}`).join(",");
    },
    ...e,
    easing: t,
    duration: r
  };
}
const Hd = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function Yd(e) {
  return It(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function El(e = {}) {
  const t = {
    ...e
  };
  function r(n) {
    const o = Object.entries(n);
    for (let i = 0; i < o.length; i++) {
      const [a, s] = o[i];
      !Yd(s) || a.startsWith("unstable_") ? delete n[a] : It(s) && (n[a] = {
        ...s
      }, r(n[a]));
    }
  }
  return r(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function Ko(e = {}, ...t) {
  const {
    breakpoints: r,
    mixins: n = {},
    spacing: o,
    palette: i = {},
    transitions: a = {},
    typography: s = {},
    shape: l,
    ...u
  } = e;
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateThemeVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : Wt(20));
  const f = Mi(i), h = _i(e);
  let g = Ke(h, {
    mixins: Dd(h.breakpoints, n),
    palette: f,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: Fd.slice(),
    typography: Ld(f, s),
    transitions: Ud(a),
    zIndex: {
      ...Hd
    }
  });
  if (g = Ke(g, u), g = t.reduce((m, y) => Ke(m, y), g), process.env.NODE_ENV !== "production") {
    const m = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], y = (p, v) => {
      let w;
      for (w in p) {
        const R = p[w];
        if (m.includes(w) && Object.keys(R).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const x = ct("", w);
            console.error([`MUI: The \`${v}\` component increases the CSS specificity of the \`${w}\` internal state.`, "You can not override it like this: ", JSON.stringify(p, null, 2), "", `Instead, you need to use the '&.${x}' syntax:`, JSON.stringify({
              root: {
                [`&.${x}`]: R
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          p[w] = {};
        }
      }
    };
    Object.keys(g.components).forEach((p) => {
      const v = g.components[p].styleOverrides;
      v && p.startsWith("Mui") && y(v, p);
    });
  }
  return g.unstable_sxConfig = {
    ...uo,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, g.unstable_sx = function(y) {
    return Rr({
      sx: y,
      theme: this
    });
  }, g.toRuntimeSource = El, g;
}
function Xo(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const Qd = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const r = Xo(t);
  return `linear-gradient(rgba(255 255 255 / ${r}), rgba(255 255 255 / ${r}))`;
});
function xl(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function Cl(e) {
  return e === "dark" ? Qd : [];
}
function Gd(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: r,
    overlays: n,
    ...o
  } = e, i = Mi(t);
  return {
    palette: i,
    opacity: {
      ...xl(i.mode),
      ...r
    },
    overlays: n || Cl(i.mode),
    ...o
  };
}
function Kd(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const Xd = (e) => [...[...Array(25)].map((t, r) => `--${e ? `${e}-` : ""}overlays-${r}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], Jd = (e) => (t, r) => {
  const n = e.rootSelector || ":root", o = e.colorSchemeSelector;
  let i = o;
  if (o === "class" && (i = ".%s"), o === "data" && (i = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (i = `[${o}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const a = {};
      return Xd(e.cssVarPrefix).forEach((s) => {
        a[s] = r[s], delete r[s];
      }), i === "media" ? {
        [n]: r,
        "@media (prefers-color-scheme: dark)": {
          [n]: a
        }
      } : i ? {
        [i.replace("%s", t)]: a,
        [`${n}, ${i.replace("%s", t)}`]: r
      } : {
        [n]: {
          ...r,
          ...a
        }
      };
    }
    if (i && i !== "media")
      return `${n}, ${i.replace("%s", String(t))}`;
  } else if (t) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [n]: r
        }
      };
    if (i)
      return i.replace("%s", String(t));
  }
  return n;
};
function Zd(e, t) {
  t.forEach((r) => {
    e[r] || (e[r] = {});
  });
}
function E(e, t, r) {
  !e[t] && r && (e[t] = r);
}
function Hr(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : Js(e);
}
function Ct(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = Ur(Hr(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function eh(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const ht = (e) => {
  try {
    return e();
  } catch {
  }
}, th = (e = "mui") => wd(e);
function Po(e, t, r, n) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const o = n === "dark" ? "dark" : "light";
  if (!r) {
    e[n] = Gd({
      ...t,
      palette: {
        mode: o,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: i,
    ...a
  } = Ko({
    ...r,
    palette: {
      mode: o,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[n] = {
    ...t,
    palette: i,
    opacity: {
      ...xl(o),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || Cl(o)
  }, a;
}
function rh(e = {}, ...t) {
  const {
    colorSchemes: r = {
      light: !0
    },
    defaultColorScheme: n,
    disableCssColorScheme: o = !1,
    cssVarPrefix: i = "mui",
    shouldSkipGeneratingVar: a = Kd,
    colorSchemeSelector: s = r.light && r.dark ? "media" : void 0,
    rootSelector: l = ":root",
    ...u
  } = e, f = Object.keys(r)[0], h = n || (r.light && f !== "light" ? "light" : f), g = th(i), {
    [h]: m,
    light: y,
    dark: p,
    ...v
  } = r, w = {
    ...v
  };
  let R = m;
  if ((h === "dark" && !("dark" in r) || h === "light" && !("light" in r)) && (R = !0), !R)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${h}\` option is either missing or invalid.` : Wt(21, h));
  const x = Po(w, R, u, h);
  y && !w.light && Po(w, y, void 0, "light"), p && !w.dark && Po(w, p, void 0, "dark");
  let b = {
    defaultColorScheme: h,
    ...x,
    cssVarPrefix: i,
    colorSchemeSelector: s,
    rootSelector: l,
    getCssVar: g,
    colorSchemes: w,
    font: {
      ...Md(x.typography),
      ...x.font
    },
    spacing: eh(u.spacing)
  };
  Object.keys(b.colorSchemes).forEach((z) => {
    const d = b.colorSchemes[z].palette, T = ($) => {
      const F = $.split("-"), Q = F[1], ae = F[2];
      return g($, d[Q][ae]);
    };
    if (d.mode === "light" && (E(d.common, "background", "#fff"), E(d.common, "onBackground", "#000")), d.mode === "dark" && (E(d.common, "background", "#000"), E(d.common, "onBackground", "#fff")), Zd(d, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), d.mode === "light") {
      E(d.Alert, "errorColor", me(d.error.light, 0.6)), E(d.Alert, "infoColor", me(d.info.light, 0.6)), E(d.Alert, "successColor", me(d.success.light, 0.6)), E(d.Alert, "warningColor", me(d.warning.light, 0.6)), E(d.Alert, "errorFilledBg", T("palette-error-main")), E(d.Alert, "infoFilledBg", T("palette-info-main")), E(d.Alert, "successFilledBg", T("palette-success-main")), E(d.Alert, "warningFilledBg", T("palette-warning-main")), E(d.Alert, "errorFilledColor", ht(() => d.getContrastText(d.error.main))), E(d.Alert, "infoFilledColor", ht(() => d.getContrastText(d.info.main))), E(d.Alert, "successFilledColor", ht(() => d.getContrastText(d.success.main))), E(d.Alert, "warningFilledColor", ht(() => d.getContrastText(d.warning.main))), E(d.Alert, "errorStandardBg", ve(d.error.light, 0.9)), E(d.Alert, "infoStandardBg", ve(d.info.light, 0.9)), E(d.Alert, "successStandardBg", ve(d.success.light, 0.9)), E(d.Alert, "warningStandardBg", ve(d.warning.light, 0.9)), E(d.Alert, "errorIconColor", T("palette-error-main")), E(d.Alert, "infoIconColor", T("palette-info-main")), E(d.Alert, "successIconColor", T("palette-success-main")), E(d.Alert, "warningIconColor", T("palette-warning-main")), E(d.AppBar, "defaultBg", T("palette-grey-100")), E(d.Avatar, "defaultBg", T("palette-grey-400")), E(d.Button, "inheritContainedBg", T("palette-grey-300")), E(d.Button, "inheritContainedHoverBg", T("palette-grey-A100")), E(d.Chip, "defaultBorder", T("palette-grey-400")), E(d.Chip, "defaultAvatarColor", T("palette-grey-700")), E(d.Chip, "defaultIconColor", T("palette-grey-700")), E(d.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), E(d.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), E(d.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), E(d.LinearProgress, "primaryBg", ve(d.primary.main, 0.62)), E(d.LinearProgress, "secondaryBg", ve(d.secondary.main, 0.62)), E(d.LinearProgress, "errorBg", ve(d.error.main, 0.62)), E(d.LinearProgress, "infoBg", ve(d.info.main, 0.62)), E(d.LinearProgress, "successBg", ve(d.success.main, 0.62)), E(d.LinearProgress, "warningBg", ve(d.warning.main, 0.62)), E(d.Skeleton, "bg", `rgba(${T("palette-text-primaryChannel")} / 0.11)`), E(d.Slider, "primaryTrack", ve(d.primary.main, 0.62)), E(d.Slider, "secondaryTrack", ve(d.secondary.main, 0.62)), E(d.Slider, "errorTrack", ve(d.error.main, 0.62)), E(d.Slider, "infoTrack", ve(d.info.main, 0.62)), E(d.Slider, "successTrack", ve(d.success.main, 0.62)), E(d.Slider, "warningTrack", ve(d.warning.main, 0.62));
      const $ = wn(d.background.default, 0.8);
      E(d.SnackbarContent, "bg", $), E(d.SnackbarContent, "color", ht(() => d.getContrastText($))), E(d.SpeedDialAction, "fabHoverBg", wn(d.background.paper, 0.15)), E(d.StepConnector, "border", T("palette-grey-400")), E(d.StepContent, "border", T("palette-grey-400")), E(d.Switch, "defaultColor", T("palette-common-white")), E(d.Switch, "defaultDisabledColor", T("palette-grey-100")), E(d.Switch, "primaryDisabledColor", ve(d.primary.main, 0.62)), E(d.Switch, "secondaryDisabledColor", ve(d.secondary.main, 0.62)), E(d.Switch, "errorDisabledColor", ve(d.error.main, 0.62)), E(d.Switch, "infoDisabledColor", ve(d.info.main, 0.62)), E(d.Switch, "successDisabledColor", ve(d.success.main, 0.62)), E(d.Switch, "warningDisabledColor", ve(d.warning.main, 0.62)), E(d.TableCell, "border", ve(Sn(d.divider, 1), 0.88)), E(d.Tooltip, "bg", Sn(d.grey[700], 0.92));
    }
    if (d.mode === "dark") {
      E(d.Alert, "errorColor", ve(d.error.light, 0.6)), E(d.Alert, "infoColor", ve(d.info.light, 0.6)), E(d.Alert, "successColor", ve(d.success.light, 0.6)), E(d.Alert, "warningColor", ve(d.warning.light, 0.6)), E(d.Alert, "errorFilledBg", T("palette-error-dark")), E(d.Alert, "infoFilledBg", T("palette-info-dark")), E(d.Alert, "successFilledBg", T("palette-success-dark")), E(d.Alert, "warningFilledBg", T("palette-warning-dark")), E(d.Alert, "errorFilledColor", ht(() => d.getContrastText(d.error.dark))), E(d.Alert, "infoFilledColor", ht(() => d.getContrastText(d.info.dark))), E(d.Alert, "successFilledColor", ht(() => d.getContrastText(d.success.dark))), E(d.Alert, "warningFilledColor", ht(() => d.getContrastText(d.warning.dark))), E(d.Alert, "errorStandardBg", me(d.error.light, 0.9)), E(d.Alert, "infoStandardBg", me(d.info.light, 0.9)), E(d.Alert, "successStandardBg", me(d.success.light, 0.9)), E(d.Alert, "warningStandardBg", me(d.warning.light, 0.9)), E(d.Alert, "errorIconColor", T("palette-error-main")), E(d.Alert, "infoIconColor", T("palette-info-main")), E(d.Alert, "successIconColor", T("palette-success-main")), E(d.Alert, "warningIconColor", T("palette-warning-main")), E(d.AppBar, "defaultBg", T("palette-grey-900")), E(d.AppBar, "darkBg", T("palette-background-paper")), E(d.AppBar, "darkColor", T("palette-text-primary")), E(d.Avatar, "defaultBg", T("palette-grey-600")), E(d.Button, "inheritContainedBg", T("palette-grey-800")), E(d.Button, "inheritContainedHoverBg", T("palette-grey-700")), E(d.Chip, "defaultBorder", T("palette-grey-700")), E(d.Chip, "defaultAvatarColor", T("palette-grey-300")), E(d.Chip, "defaultIconColor", T("palette-grey-300")), E(d.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), E(d.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), E(d.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), E(d.LinearProgress, "primaryBg", me(d.primary.main, 0.5)), E(d.LinearProgress, "secondaryBg", me(d.secondary.main, 0.5)), E(d.LinearProgress, "errorBg", me(d.error.main, 0.5)), E(d.LinearProgress, "infoBg", me(d.info.main, 0.5)), E(d.LinearProgress, "successBg", me(d.success.main, 0.5)), E(d.LinearProgress, "warningBg", me(d.warning.main, 0.5)), E(d.Skeleton, "bg", `rgba(${T("palette-text-primaryChannel")} / 0.13)`), E(d.Slider, "primaryTrack", me(d.primary.main, 0.5)), E(d.Slider, "secondaryTrack", me(d.secondary.main, 0.5)), E(d.Slider, "errorTrack", me(d.error.main, 0.5)), E(d.Slider, "infoTrack", me(d.info.main, 0.5)), E(d.Slider, "successTrack", me(d.success.main, 0.5)), E(d.Slider, "warningTrack", me(d.warning.main, 0.5));
      const $ = wn(d.background.default, 0.98);
      E(d.SnackbarContent, "bg", $), E(d.SnackbarContent, "color", ht(() => d.getContrastText($))), E(d.SpeedDialAction, "fabHoverBg", wn(d.background.paper, 0.15)), E(d.StepConnector, "border", T("palette-grey-600")), E(d.StepContent, "border", T("palette-grey-600")), E(d.Switch, "defaultColor", T("palette-grey-300")), E(d.Switch, "defaultDisabledColor", T("palette-grey-600")), E(d.Switch, "primaryDisabledColor", me(d.primary.main, 0.55)), E(d.Switch, "secondaryDisabledColor", me(d.secondary.main, 0.55)), E(d.Switch, "errorDisabledColor", me(d.error.main, 0.55)), E(d.Switch, "infoDisabledColor", me(d.info.main, 0.55)), E(d.Switch, "successDisabledColor", me(d.success.main, 0.55)), E(d.Switch, "warningDisabledColor", me(d.warning.main, 0.55)), E(d.TableCell, "border", me(Sn(d.divider, 1), 0.68)), E(d.Tooltip, "bg", Sn(d.grey[700], 0.92));
    }
    Ct(d.background, "default"), Ct(d.background, "paper"), Ct(d.common, "background"), Ct(d.common, "onBackground"), Ct(d, "divider"), Object.keys(d).forEach(($) => {
      const F = d[$];
      $ !== "tonalOffset" && F && typeof F == "object" && (F.main && E(d[$], "mainChannel", Ur(Hr(F.main))), F.light && E(d[$], "lightChannel", Ur(Hr(F.light))), F.dark && E(d[$], "darkChannel", Ur(Hr(F.dark))), F.contrastText && E(d[$], "contrastTextChannel", Ur(Hr(F.contrastText))), $ === "text" && (Ct(d[$], "primary"), Ct(d[$], "secondary")), $ === "action" && (F.active && Ct(d[$], "active"), F.selected && Ct(d[$], "selected")));
    });
  }), b = t.reduce((z, d) => Ke(z, d), b);
  const S = {
    prefix: i,
    disableCssColorScheme: o,
    shouldSkipGeneratingVar: a,
    getSelector: Jd(b)
  }, {
    vars: P,
    generateThemeVars: q,
    generateStyleSheets: D
  } = xd(b, S);
  return b.vars = P, Object.entries(b.colorSchemes[b.defaultColorScheme]).forEach(([z, d]) => {
    b[z] = d;
  }), b.generateThemeVars = q, b.generateStyleSheets = D, b.generateSpacing = function() {
    return yl(u.spacing, Pi(this));
  }, b.getColorSchemeSelector = Cd(s), b.spacing = b.generateSpacing(), b.shouldSkipGeneratingVar = a, b.unstable_sxConfig = {
    ...uo,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, b.unstable_sx = function(d) {
    return Rr({
      sx: d,
      theme: this
    });
  }, b.toRuntimeSource = El, b;
}
function Ka(e, t, r) {
  e.colorSchemes && r && (e.colorSchemes[t] = {
    ...r !== !0 && r,
    palette: Mi({
      ...r === !0 ? {} : r.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function nh(e = {}, ...t) {
  const {
    palette: r,
    cssVariables: n = !1,
    colorSchemes: o = r ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = r == null ? void 0 : r.mode,
    ...a
  } = e, s = i || "light", l = o == null ? void 0 : o[s], u = {
    ...o,
    ...r ? {
      [s]: {
        ...typeof l != "boolean" && l,
        palette: r
      }
    } : void 0
  };
  if (n === !1) {
    if (!("colorSchemes" in e))
      return Ko(e, ...t);
    let f = r;
    "palette" in e || u[s] && (u[s] !== !0 ? f = u[s].palette : s === "dark" && (f = {
      mode: "dark"
    }));
    const h = Ko({
      ...e,
      palette: f
    }, ...t);
    return h.defaultColorScheme = s, h.colorSchemes = u, h.palette.mode === "light" && (h.colorSchemes.light = {
      ...u.light !== !0 && u.light,
      palette: h.palette
    }, Ka(h, "dark", u.dark)), h.palette.mode === "dark" && (h.colorSchemes.dark = {
      ...u.dark !== !0 && u.dark,
      palette: h.palette
    }, Ka(h, "light", u.light)), h;
  }
  return !r && !("light" in u) && s === "light" && (u.light = !0), rh({
    ...a,
    colorSchemes: u,
    defaultColorScheme: s,
    ...typeof n != "boolean" && n
  }, ...t);
}
const Tl = nh(), $l = "$$material";
function oh() {
  const e = sd(Tl);
  return process.env.NODE_ENV !== "production" && I.useDebugValue(e), e[$l] || e;
}
function ih(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const ah = (e) => ih(e) && e !== "classes", we = pd({
  themeId: $l,
  defaultTheme: Tl,
  rootShouldForwardProp: ah
});
process.env.NODE_ENV !== "production" && (c.node, c.object.isRequired);
function St(e) {
  return bd(e);
}
const sh = we(pl, {
  name: "MuiPopper",
  slot: "Root"
})({}), Di = /* @__PURE__ */ I.forwardRef(function(t, r) {
  const n = Tu(), o = St({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: i,
    component: a,
    components: s,
    componentsProps: l,
    container: u,
    disablePortal: f,
    keepMounted: h,
    modifiers: g,
    open: m,
    placement: y,
    popperOptions: p,
    popperRef: v,
    transition: w,
    slots: R,
    slotProps: x,
    ...b
  } = o, S = (R == null ? void 0 : R.root) ?? (s == null ? void 0 : s.Root), P = {
    anchorEl: i,
    container: u,
    disablePortal: f,
    keepMounted: h,
    modifiers: g,
    open: m,
    placement: y,
    popperOptions: p,
    popperRef: v,
    transition: w,
    ...b
  };
  return /* @__PURE__ */ L(sh, {
    as: a,
    direction: n ? "rtl" : "ltr",
    slots: {
      root: S
    },
    slotProps: x ?? l,
    ...P,
    ref: r
  });
});
process.env.NODE_ENV !== "production" && (Di.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: c.oneOfType([Jr, c.object, c.func]),
  /**
   * Popper render function or node.
   */
  children: c.oneOfType([c.node, c.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: c.shape({
    Root: c.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: c.shape({
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([Jr, c.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: c.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: c.arrayOf(c.shape({
    data: c.object,
    effect: c.func,
    enabled: c.bool,
    fn: c.func,
    name: c.any,
    options: c.object,
    phase: c.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: c.arrayOf(c.string),
    requiresIfExists: c.arrayOf(c.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: c.shape({
    modifiers: c.array,
    onFirstUpdate: c.func,
    placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: c.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Ei,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: c.shape({
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: c.shape({
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: c.bool
});
const Ye = Sd;
function lh(e) {
  return ct("MuiListSubheader", e);
}
Qe("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const ch = (e) => {
  const {
    classes: t,
    color: r,
    disableGutters: n,
    inset: o,
    disableSticky: i
  } = e, a = {
    root: ["root", r !== "default" && `color${te(r)}`, !n && "gutters", o && "inset", !i && "sticky"]
  };
  return At(a, lh, t);
}, uh = we("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.color !== "default" && t[`color${te(r.color)}`], !r.disableGutters && t.gutters, r.inset && t.inset, !r.disableSticky && t.sticky];
  }
})(Ye(({
  theme: e
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.inset,
    style: {
      paddingLeft: 72
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableSticky,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (e.vars || e).palette.background.paper
    }
  }]
}))), zn = /* @__PURE__ */ I.forwardRef(function(t, r) {
  const n = St({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: o,
    color: i = "default",
    component: a = "li",
    disableGutters: s = !1,
    disableSticky: l = !1,
    inset: u = !1,
    ...f
  } = n, h = {
    ...n,
    color: i,
    component: a,
    disableGutters: s,
    disableSticky: l,
    inset: u
  }, g = ch(h);
  return /* @__PURE__ */ L(uh, {
    as: a,
    className: xe(g.root, o),
    ref: r,
    ownerState: h,
    ...f
  });
});
zn && (zn.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (zn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: c.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: c.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: c.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function fh(e) {
  return ct("MuiPaper", e);
}
Qe("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const ph = (e) => {
  const {
    square: t,
    elevation: r,
    variant: n,
    classes: o
  } = e, i = {
    root: ["root", n, !t && "rounded", n === "elevation" && `elevation${r}`]
  };
  return At(i, fh, o);
}, dh = we("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], !r.square && t.rounded, r.variant === "elevation" && t[`elevation${r.elevation}`]];
  }
})(Ye(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), Ni = /* @__PURE__ */ I.forwardRef(function(t, r) {
  var m;
  const n = St({
    props: t,
    name: "MuiPaper"
  }), o = oh(), {
    className: i,
    component: a = "div",
    elevation: s = 1,
    square: l = !1,
    variant: u = "elevation",
    ...f
  } = n, h = {
    ...n,
    component: a,
    elevation: s,
    square: l,
    variant: u
  }, g = ph(h);
  return process.env.NODE_ENV !== "production" && o.shadows[s] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${s}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${s}]\` is defined.`].join(`
`)), /* @__PURE__ */ L(dh, {
    as: a,
    ownerState: h,
    className: xe(g.root, i),
    ref: r,
    ...f,
    style: {
      ...u === "elevation" && {
        "--Paper-shadow": (o.vars || o).shadows[s],
        ...o.vars && {
          "--Paper-overlay": (m = o.vars.overlays) == null ? void 0 : m[s]
        },
        ...!o.vars && o.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${Me("#fff", Xo(s))}, ${Me("#fff", Xo(s))})`
        }
      },
      ...f.style
    }
  });
});
process.env.NODE_ENV !== "production" && (Ni.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: lr(Xs, (e) => {
    const {
      elevation: t,
      variant: r
    } = e;
    return t > 0 && r === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${r}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: c.bool,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: c.oneOfType([c.oneOf(["elevation", "outlined"]), c.string])
});
function hh(e) {
  return ct("MuiSvgIcon", e);
}
Qe("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const gh = (e) => {
  const {
    color: t,
    fontSize: r,
    classes: n
  } = e, o = {
    root: ["root", t !== "inherit" && `color${te(t)}`, `fontSize${te(r)}`]
  };
  return At(o, hh, n);
}, yh = we("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.color !== "inherit" && t[`color${te(r.color)}`], t[`fontSize${te(r.fontSize)}`]];
  }
})(Ye(({
  theme: e
}) => {
  var t, r, n, o, i, a, s, l, u, f, h, g, m, y;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (o = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : o.call(t, "fill", {
      duration: (n = (r = (e.vars ?? e).transitions) == null ? void 0 : r.duration) == null ? void 0 : n.shorter
    }),
    variants: [
      {
        props: (p) => !p.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((a = (i = e.typography) == null ? void 0 : i.pxToRem) == null ? void 0 : a.call(i, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((l = (s = e.typography) == null ? void 0 : s.pxToRem) == null ? void 0 : l.call(s, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((f = (u = e.typography) == null ? void 0 : u.pxToRem) == null ? void 0 : f.call(u, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, p]) => p && p.main).map(([p]) => {
        var v, w;
        return {
          props: {
            color: p
          },
          style: {
            color: (w = (v = (e.vars ?? e).palette) == null ? void 0 : v[p]) == null ? void 0 : w.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (g = (h = (e.vars ?? e).palette) == null ? void 0 : h.action) == null ? void 0 : g.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (y = (m = (e.vars ?? e).palette) == null ? void 0 : m.action) == null ? void 0 : y.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), qn = /* @__PURE__ */ I.forwardRef(function(t, r) {
  const n = St({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: o,
    className: i,
    color: a = "inherit",
    component: s = "svg",
    fontSize: l = "medium",
    htmlColor: u,
    inheritViewBox: f = !1,
    titleAccess: h,
    viewBox: g = "0 0 24 24",
    ...m
  } = n, y = /* @__PURE__ */ I.isValidElement(o) && o.type === "svg", p = {
    ...n,
    color: a,
    component: s,
    fontSize: l,
    instanceFontSize: t.fontSize,
    inheritViewBox: f,
    viewBox: g,
    hasSvgAsChild: y
  }, v = {};
  f || (v.viewBox = g);
  const w = gh(p);
  return /* @__PURE__ */ Fe(yh, {
    as: s,
    className: xe(w.root, i),
    focusable: "false",
    color: u,
    "aria-hidden": h ? void 0 : !0,
    role: h ? "img" : void 0,
    ref: r,
    ...v,
    ...m,
    ...y && o.props,
    ownerState: p,
    children: [y ? o.props.children : o, h ? /* @__PURE__ */ L("title", {
      children: h
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (qn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: c.oneOfType([c.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: c.oneOfType([c.oneOf(["inherit", "large", "medium", "small"]), c.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: c.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: c.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Reference/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: c.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: c.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: c.string
});
qn.muiName = "SvgIcon";
function un(e, t) {
  function r(n, o) {
    return /* @__PURE__ */ L(qn, {
      "data-testid": process.env.NODE_ENV !== "production" ? `${t}Icon` : void 0,
      ref: o,
      ...n,
      children: e
    });
  }
  return process.env.NODE_ENV !== "production" && (r.displayName = `${t}Icon`), r.muiName = qn.muiName, /* @__PURE__ */ I.memo(/* @__PURE__ */ I.forwardRef(r));
}
function mh(e, t, r, n, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = o || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${i}\` is not supported. Please remove it.`) : null;
}
function vh(e) {
  return typeof e.main == "string";
}
function bh(e, t = []) {
  if (!vh(e))
    return !1;
  for (const r of t)
    if (!e.hasOwnProperty(r) || typeof e[r] != "string")
      return !1;
  return !0;
}
function tr(e = []) {
  return ([, t]) => t && bh(t, e);
}
function Sh(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function wh(e, t, r, n, o) {
  const i = e[t], a = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let s;
  return typeof i == "function" && !Sh(i) && (s = "Did you accidentally provide a plain function component instead?"), s !== void 0 ? new Error(`Invalid ${n} \`${a}\` supplied to \`${r}\`. Expected an element type that can hold a ref. ${s} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Oh = lr(c.elementType, wh);
function Xa(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
const Ja = {};
function Il(e, t) {
  const r = I.useRef(Ja);
  return r.current === Ja && (r.current = e(t)), r;
}
class Wn {
  constructor() {
    Vr(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new Wn();
  }
  static use() {
    const t = Il(Wn.create).current, [r, n] = I.useState(!1);
    return t.shouldMount = r, t.setShouldMount = n, I.useEffect(t.mountEffect, [r]), t;
  }
  mount() {
    return this.mounted || (this.mounted = xh(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var r;
      return (r = this.ref.current) == null ? void 0 : r.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var r;
      return (r = this.ref.current) == null ? void 0 : r.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var r;
      return (r = this.ref.current) == null ? void 0 : r.pulsate(...t);
    });
  }
}
function Eh() {
  return Wn.use();
}
function xh() {
  let e, t;
  const r = new Promise((n, o) => {
    e = n, t = o;
  });
  return r.resolve = e, r.reject = t, r;
}
function Jo() {
  return Jo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jo.apply(null, arguments);
}
function Ch(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function Zo(e, t) {
  return Zo = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Zo(e, t);
}
function Th(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Zo(e, t);
}
const Za = Sr.createContext(null);
function $h(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Li(e, t) {
  var r = function(i) {
    return t && $n(i) ? t(i) : i;
  }, n = /* @__PURE__ */ Object.create(null);
  return e && fc.map(e, function(o) {
    return o;
  }).forEach(function(o) {
    n[o.key] = r(o);
  }), n;
}
function Ih(e, t) {
  e = e || {}, t = t || {};
  function r(f) {
    return f in t ? t[f] : e[f];
  }
  var n = /* @__PURE__ */ Object.create(null), o = [];
  for (var i in e)
    i in t ? o.length && (n[i] = o, o = []) : o.push(i);
  var a, s = {};
  for (var l in t) {
    if (n[l])
      for (a = 0; a < n[l].length; a++) {
        var u = n[l][a];
        s[n[l][a]] = r(u);
      }
    s[l] = r(l);
  }
  for (a = 0; a < o.length; a++)
    s[o[a]] = r(o[a]);
  return s;
}
function rr(e, t, r) {
  return r[t] != null ? r[t] : e.props[t];
}
function Rh(e, t) {
  return Li(e.children, function(r) {
    return In(r, {
      onExited: t.bind(null, r),
      in: !0,
      appear: rr(r, "appear", e),
      enter: rr(r, "enter", e),
      exit: rr(r, "exit", e)
    });
  });
}
function kh(e, t, r) {
  var n = Li(e.children), o = Ih(t, n);
  return Object.keys(o).forEach(function(i) {
    var a = o[i];
    if ($n(a)) {
      var s = i in t, l = i in n, u = t[i], f = $n(u) && !u.props.in;
      l && (!s || f) ? o[i] = In(a, {
        onExited: r.bind(null, a),
        in: !0,
        exit: rr(a, "exit", e),
        enter: rr(a, "enter", e)
      }) : !l && s && !f ? o[i] = In(a, {
        in: !1
      }) : l && s && $n(u) && (o[i] = In(a, {
        onExited: r.bind(null, a),
        in: u.props.in,
        exit: rr(a, "exit", e),
        enter: rr(a, "enter", e)
      }));
    }
  }), o;
}
var Ph = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, Ah = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, ji = /* @__PURE__ */ function(e) {
  Th(t, e);
  function t(n, o) {
    var i;
    i = e.call(this, n, o) || this;
    var a = i.handleExited.bind($h(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: a,
      firstRender: !0
    }, i;
  }
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, r.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(o, i) {
    var a = i.children, s = i.handleExited, l = i.firstRender;
    return {
      children: l ? Rh(o, s) : kh(o, a, s),
      firstRender: !1
    };
  }, r.handleExited = function(o, i) {
    var a = Li(this.props.children);
    o.key in a || (o.props.onExited && o.props.onExited(i), this.mounted && this.setState(function(s) {
      var l = Jo({}, s.children);
      return delete l[o.key], {
        children: l
      };
    }));
  }, r.render = function() {
    var o = this.props, i = o.component, a = o.childFactory, s = Ch(o, ["component", "childFactory"]), l = this.state.contextValue, u = Ph(this.state.children).map(a);
    return delete s.appear, delete s.enter, delete s.exit, i === null ? /* @__PURE__ */ Sr.createElement(Za.Provider, {
      value: l
    }, u) : /* @__PURE__ */ Sr.createElement(Za.Provider, {
      value: l
    }, /* @__PURE__ */ Sr.createElement(i, s, u));
  }, t;
}(Sr.Component);
ji.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: c.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: c.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: c.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: c.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: c.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: c.func
} : {};
ji.defaultProps = Ah;
const _h = [];
function Mh(e) {
  I.useEffect(e, _h);
}
class Vi {
  constructor() {
    Vr(this, "currentId", null);
    Vr(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    Vr(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new Vi();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, r) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, r();
    }, t);
  }
}
function Dh() {
  const e = Il(Vi.create).current;
  return Mh(e.disposeEffect), e;
}
function Rl(e) {
  const {
    className: t,
    classes: r,
    pulsate: n = !1,
    rippleX: o,
    rippleY: i,
    rippleSize: a,
    in: s,
    onExited: l,
    timeout: u
  } = e, [f, h] = I.useState(!1), g = xe(t, r.ripple, r.rippleVisible, n && r.ripplePulsate), m = {
    width: a,
    height: a,
    top: -(a / 2) + i,
    left: -(a / 2) + o
  }, y = xe(r.child, f && r.childLeaving, n && r.childPulsate);
  return !s && !f && h(!0), I.useEffect(() => {
    if (!s && l != null) {
      const p = setTimeout(l, u);
      return () => {
        clearTimeout(p);
      };
    }
  }, [l, s, u]), /* @__PURE__ */ L("span", {
    className: g,
    style: m,
    children: /* @__PURE__ */ L("span", {
      className: y
    })
  });
}
process.env.NODE_ENV !== "production" && (Rl.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object.isRequired,
  className: c.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: c.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: c.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: c.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: c.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: c.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: c.number,
  /**
   * exit delay
   */
  timeout: c.number.isRequired
});
const Ze = Qe("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), ei = 550, Nh = 80, Lh = nn`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, jh = nn`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, Vh = nn`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, Bh = we("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), Fh = we(Rl, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${Ze.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${Lh};
    animation-duration: ${ei}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${Ze.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${Ze.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${Ze.childLeaving} {
    opacity: 0;
    animation-name: ${jh};
    animation-duration: ${ei}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${Ze.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${Vh};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, kl = /* @__PURE__ */ I.forwardRef(function(t, r) {
  const n = St({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: i = {},
    className: a,
    ...s
  } = n, [l, u] = I.useState([]), f = I.useRef(0), h = I.useRef(null);
  I.useEffect(() => {
    h.current && (h.current(), h.current = null);
  }, [l]);
  const g = I.useRef(!1), m = Dh(), y = I.useRef(null), p = I.useRef(null), v = I.useCallback((b) => {
    const {
      pulsate: S,
      rippleX: P,
      rippleY: q,
      rippleSize: D,
      cb: z
    } = b;
    u((d) => [...d, /* @__PURE__ */ L(Fh, {
      classes: {
        ripple: xe(i.ripple, Ze.ripple),
        rippleVisible: xe(i.rippleVisible, Ze.rippleVisible),
        ripplePulsate: xe(i.ripplePulsate, Ze.ripplePulsate),
        child: xe(i.child, Ze.child),
        childLeaving: xe(i.childLeaving, Ze.childLeaving),
        childPulsate: xe(i.childPulsate, Ze.childPulsate)
      },
      timeout: ei,
      pulsate: S,
      rippleX: P,
      rippleY: q,
      rippleSize: D
    }, f.current)]), f.current += 1, h.current = z;
  }, [i]), w = I.useCallback((b = {}, S = {}, P = () => {
  }) => {
    const {
      pulsate: q = !1,
      center: D = o || S.pulsate,
      fakeElement: z = !1
      // For test purposes
    } = S;
    if ((b == null ? void 0 : b.type) === "mousedown" && g.current) {
      g.current = !1;
      return;
    }
    (b == null ? void 0 : b.type) === "touchstart" && (g.current = !0);
    const d = z ? null : p.current, T = d ? d.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let $, F, Q;
    if (D || b === void 0 || b.clientX === 0 && b.clientY === 0 || !b.clientX && !b.touches)
      $ = Math.round(T.width / 2), F = Math.round(T.height / 2);
    else {
      const {
        clientX: ae,
        clientY: Y
      } = b.touches && b.touches.length > 0 ? b.touches[0] : b;
      $ = Math.round(ae - T.left), F = Math.round(Y - T.top);
    }
    if (D)
      Q = Math.sqrt((2 * T.width ** 2 + T.height ** 2) / 3), Q % 2 === 0 && (Q += 1);
    else {
      const ae = Math.max(Math.abs((d ? d.clientWidth : 0) - $), $) * 2 + 2, Y = Math.max(Math.abs((d ? d.clientHeight : 0) - F), F) * 2 + 2;
      Q = Math.sqrt(ae ** 2 + Y ** 2);
    }
    b != null && b.touches ? y.current === null && (y.current = () => {
      v({
        pulsate: q,
        rippleX: $,
        rippleY: F,
        rippleSize: Q,
        cb: P
      });
    }, m.start(Nh, () => {
      y.current && (y.current(), y.current = null);
    })) : v({
      pulsate: q,
      rippleX: $,
      rippleY: F,
      rippleSize: Q,
      cb: P
    });
  }, [o, v, m]), R = I.useCallback(() => {
    w({}, {
      pulsate: !0
    });
  }, [w]), x = I.useCallback((b, S) => {
    if (m.clear(), (b == null ? void 0 : b.type) === "touchend" && y.current) {
      y.current(), y.current = null, m.start(0, () => {
        x(b, S);
      });
      return;
    }
    y.current = null, u((P) => P.length > 0 ? P.slice(1) : P), h.current = S;
  }, [m]);
  return I.useImperativeHandle(r, () => ({
    pulsate: R,
    start: w,
    stop: x
  }), [R, w, x]), /* @__PURE__ */ L(Bh, {
    className: xe(Ze.root, i.root, a),
    ref: p,
    ...s,
    children: /* @__PURE__ */ L(ji, {
      component: null,
      exit: !0,
      children: l
    })
  });
});
process.env.NODE_ENV !== "production" && (kl.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string
});
function zh(e) {
  return ct("MuiButtonBase", e);
}
const qh = Qe("MuiButtonBase", ["root", "disabled", "focusVisible"]), Wh = (e) => {
  const {
    disabled: t,
    focusVisible: r,
    focusVisibleClassName: n,
    classes: o
  } = e, a = At({
    root: ["root", t && "disabled", r && "focusVisible"]
  }, zh, o);
  return r && n && (a.root += ` ${n}`), a;
}, Uh = we("button", {
  name: "MuiButtonBase",
  slot: "Root"
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${qh.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), Un = /* @__PURE__ */ I.forwardRef(function(t, r) {
  const n = St({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: o,
    centerRipple: i = !1,
    children: a,
    className: s,
    component: l = "button",
    disabled: u = !1,
    disableRipple: f = !1,
    disableTouchRipple: h = !1,
    focusRipple: g = !1,
    focusVisibleClassName: m,
    LinkComponent: y = "a",
    onBlur: p,
    onClick: v,
    onContextMenu: w,
    onDragLeave: R,
    onFocus: x,
    onFocusVisible: b,
    onKeyDown: S,
    onKeyUp: P,
    onMouseDown: q,
    onMouseLeave: D,
    onMouseUp: z,
    onTouchEnd: d,
    onTouchMove: T,
    onTouchStart: $,
    tabIndex: F = 0,
    TouchRippleProps: Q,
    touchRippleRef: ae,
    type: Y,
    ...re
  } = n, oe = I.useRef(null), Z = Eh(), k = Ht(Z.ref, ae), [A, W] = I.useState(!1);
  u && A && W(!1), I.useImperativeHandle(o, () => ({
    focusVisible: () => {
      W(!0), oe.current.focus();
    }
  }), []);
  const _ = Z.shouldMount && !f && !u;
  I.useEffect(() => {
    A && g && !f && Z.pulsate();
  }, [f, g, A, Z]);
  const M = Tt(Z, "start", q, h), N = Tt(Z, "stop", w, h), j = Tt(Z, "stop", R, h), U = Tt(Z, "stop", z, h), G = Tt(Z, "stop", (ee) => {
    A && ee.preventDefault(), D && D(ee);
  }, h), H = Tt(Z, "start", $, h), K = Tt(Z, "stop", d, h), Se = Tt(Z, "stop", T, h), V = Tt(Z, "stop", (ee) => {
    Xa(ee.target) || W(!1), p && p(ee);
  }, !1), de = Vt((ee) => {
    oe.current || (oe.current = ee.currentTarget), Xa(ee.target) && (W(!0), b && b(ee)), x && x(ee);
  }), Le = () => {
    const ee = oe.current;
    return l && l !== "button" && !(ee.tagName === "A" && ee.href);
  }, ut = Vt((ee) => {
    g && !ee.repeat && A && ee.key === " " && Z.stop(ee, () => {
      Z.start(ee);
    }), ee.target === ee.currentTarget && Le() && ee.key === " " && ee.preventDefault(), S && S(ee), ee.target === ee.currentTarget && Le() && ee.key === "Enter" && !u && (ee.preventDefault(), v && v(ee));
  }), Ie = Vt((ee) => {
    g && ee.key === " " && A && !ee.defaultPrevented && Z.stop(ee, () => {
      Z.pulsate(ee);
    }), P && P(ee), v && ee.target === ee.currentTarget && Le() && ee.key === " " && !ee.defaultPrevented && v(ee);
  });
  let ft = l;
  ft === "button" && (re.href || re.to) && (ft = y);
  const X = {};
  ft === "button" ? (X.type = Y === void 0 ? "button" : Y, X.disabled = u) : (!re.href && !re.to && (X.role = "button"), u && (X["aria-disabled"] = u));
  const wt = Ht(r, oe), le = {
    ...n,
    centerRipple: i,
    component: l,
    disabled: u,
    disableRipple: f,
    disableTouchRipple: h,
    focusRipple: g,
    tabIndex: F,
    focusVisible: A
  }, ze = Wh(le);
  return /* @__PURE__ */ Fe(Uh, {
    as: ft,
    className: xe(ze.root, s),
    ownerState: le,
    onBlur: V,
    onClick: v,
    onContextMenu: N,
    onFocus: de,
    onKeyDown: ut,
    onKeyUp: Ie,
    onMouseDown: M,
    onMouseLeave: G,
    onMouseUp: U,
    onDragLeave: j,
    onTouchEnd: K,
    onTouchMove: Se,
    onTouchStart: H,
    ref: wt,
    tabIndex: u ? -1 : F,
    type: Y,
    ...X,
    ...re,
    children: [a, _ ? /* @__PURE__ */ L(kl, {
      ref: k,
      center: i,
      ...Q
    }) : null]
  });
});
function Tt(e, t, r, n = !1) {
  return Vt((o) => (r && r(o), n || e[t](o), !0));
}
process.env.NODE_ENV !== "production" && (Un.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: Ei,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: c.bool,
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Oh,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: c.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: c.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: c.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: c.string,
  /**
   * @ignore
   */
  href: c.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: c.elementType,
  /**
   * @ignore
   */
  onBlur: c.func,
  /**
   * @ignore
   */
  onClick: c.func,
  /**
   * @ignore
   */
  onContextMenu: c.func,
  /**
   * @ignore
   */
  onDragLeave: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: c.func,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * @ignore
   */
  onKeyUp: c.func,
  /**
   * @ignore
   */
  onMouseDown: c.func,
  /**
   * @ignore
   */
  onMouseLeave: c.func,
  /**
   * @ignore
   */
  onMouseUp: c.func,
  /**
   * @ignore
   */
  onTouchEnd: c.func,
  /**
   * @ignore
   */
  onTouchMove: c.func,
  /**
   * @ignore
   */
  onTouchStart: c.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * @default 0
   */
  tabIndex: c.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: c.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: c.oneOfType([c.func, c.shape({
    current: c.shape({
      pulsate: c.func.isRequired,
      start: c.func.isRequired,
      stop: c.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: c.oneOfType([c.oneOf(["button", "reset", "submit"]), c.string])
});
function Hh(e) {
  return ct("MuiCircularProgress", e);
}
Qe("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const Lt = 44, ti = nn`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, ri = nn`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, Yh = typeof ti != "string" ? Ms`
        animation: ${ti} 1.4s linear infinite;
      ` : null, Qh = typeof ri != "string" ? Ms`
        animation: ${ri} 1.4s ease-in-out infinite;
      ` : null, Gh = (e) => {
  const {
    classes: t,
    variant: r,
    color: n,
    disableShrink: o
  } = e, i = {
    root: ["root", r, `color${te(n)}`],
    svg: ["svg"],
    circle: ["circle", `circle${te(r)}`, o && "circleDisableShrink"]
  };
  return At(i, Hh, t);
}, Kh = we("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], t[`color${te(r.color)}`]];
  }
})(Ye(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: Yh || {
      animation: `${ti} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(tr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), Xh = we("svg", {
  name: "MuiCircularProgress",
  slot: "Svg"
})({
  display: "block"
  // Keeps the progress centered
}), Jh = we("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.circle, t[`circle${te(r.variant)}`], r.disableShrink && t.circleDisableShrink];
  }
})(Ye(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: Qh || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${ri} 1.4s ease-in-out infinite`
    }
  }]
}))), Pl = /* @__PURE__ */ I.forwardRef(function(t, r) {
  const n = St({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: o,
    color: i = "primary",
    disableShrink: a = !1,
    size: s = 40,
    style: l,
    thickness: u = 3.6,
    value: f = 0,
    variant: h = "indeterminate",
    ...g
  } = n, m = {
    ...n,
    color: i,
    disableShrink: a,
    size: s,
    thickness: u,
    value: f,
    variant: h
  }, y = Gh(m), p = {}, v = {}, w = {};
  if (h === "determinate") {
    const R = 2 * Math.PI * ((Lt - u) / 2);
    p.strokeDasharray = R.toFixed(3), w["aria-valuenow"] = Math.round(f), p.strokeDashoffset = `${((100 - f) / 100 * R).toFixed(3)}px`, v.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ L(Kh, {
    className: xe(y.root, o),
    style: {
      width: s,
      height: s,
      ...v,
      ...l
    },
    ownerState: m,
    ref: r,
    role: "progressbar",
    ...w,
    ...g,
    children: /* @__PURE__ */ L(Xh, {
      className: y.svg,
      ownerState: m,
      viewBox: `${Lt / 2} ${Lt / 2} ${Lt} ${Lt}`,
      children: /* @__PURE__ */ L(Jh, {
        className: y.circle,
        style: p,
        ownerState: m,
        cx: Lt,
        cy: Lt,
        r: (Lt - u) / 2,
        fill: "none",
        strokeWidth: u
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Pl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: lr(c.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: c.oneOfType([c.number, c.string]),
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: c.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: c.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: c.oneOf(["determinate", "indeterminate"])
});
function Zh(e) {
  return ct("MuiIconButton", e);
}
const es = Qe("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]), eg = (e) => {
  const {
    classes: t,
    disabled: r,
    color: n,
    edge: o,
    size: i,
    loading: a
  } = e, s = {
    root: ["root", a && "loading", r && "disabled", n !== "default" && `color${te(n)}`, o && `edge${te(o)}`, `size${te(i)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return At(s, Zh, t);
}, tg = we(Un, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.loading && t.loading, r.color !== "default" && t[`color${te(r.color)}`], r.edge && t[`edge${te(r.edge)}`], t[`size${te(r.size)}`]];
  }
})(Ye(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Me(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), Ye(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(tr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(tr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Me((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${es.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  },
  [`&.${es.loading}`]: {
    color: "transparent"
  }
}))), rg = we("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator"
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (e.vars || e).palette.action.disabled,
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }]
})), Bi = /* @__PURE__ */ I.forwardRef(function(t, r) {
  const n = St({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: o = !1,
    children: i,
    className: a,
    color: s = "default",
    disabled: l = !1,
    disableFocusRipple: u = !1,
    size: f = "medium",
    id: h,
    loading: g = null,
    loadingIndicator: m,
    ...y
  } = n, p = Zs(h), v = m ?? /* @__PURE__ */ L(Pl, {
    "aria-labelledby": p,
    color: "inherit",
    size: 16
  }), w = {
    ...n,
    edge: o,
    color: s,
    disabled: l,
    disableFocusRipple: u,
    loading: g,
    loadingIndicator: v,
    size: f
  }, R = eg(w);
  return /* @__PURE__ */ Fe(tg, {
    id: g ? p : h,
    className: xe(R.root, a),
    centerRipple: !0,
    focusRipple: !u,
    disabled: l || g,
    ref: r,
    ...y,
    ownerState: w,
    children: [typeof g == "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ L("span", {
      className: R.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ L(rg, {
        className: R.loadingIndicator,
        ownerState: w,
        children: g && v
      })
    }), i]
  });
});
process.env.NODE_ENV !== "production" && (Bi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: lr(c.node, (e) => I.Children.toArray(e.children).some((r) => /* @__PURE__ */ I.isValidElement(r) && r.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: c.oneOfType([c.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: c.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: c.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: c.oneOf(["end", "start", !1]),
  /**
   * @ignore
   */
  id: c.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: c.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: c.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium", "large"]), c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const ng = un(/* @__PURE__ */ L("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function og(e) {
  return ct("MuiChip", e);
}
const ce = Qe("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), ig = (e) => {
  const {
    classes: t,
    disabled: r,
    size: n,
    color: o,
    iconColor: i,
    onDelete: a,
    clickable: s,
    variant: l
  } = e, u = {
    root: ["root", l, r && "disabled", `size${te(n)}`, `color${te(o)}`, s && "clickable", s && `clickableColor${te(o)}`, a && "deletable", a && `deletableColor${te(o)}`, `${l}${te(o)}`],
    label: ["label", `label${te(n)}`],
    avatar: ["avatar", `avatar${te(n)}`, `avatarColor${te(o)}`],
    icon: ["icon", `icon${te(n)}`, `iconColor${te(i)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${te(n)}`, `deleteIconColor${te(o)}`, `deleteIcon${te(l)}Color${te(o)}`]
  };
  return At(u, og, t);
}, ag = we("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e, {
      color: n,
      iconColor: o,
      clickable: i,
      onDelete: a,
      size: s,
      variant: l
    } = r;
    return [{
      [`& .${ce.avatar}`]: t.avatar
    }, {
      [`& .${ce.avatar}`]: t[`avatar${te(s)}`]
    }, {
      [`& .${ce.avatar}`]: t[`avatarColor${te(n)}`]
    }, {
      [`& .${ce.icon}`]: t.icon
    }, {
      [`& .${ce.icon}`]: t[`icon${te(s)}`]
    }, {
      [`& .${ce.icon}`]: t[`iconColor${te(o)}`]
    }, {
      [`& .${ce.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${ce.deleteIcon}`]: t[`deleteIcon${te(s)}`]
    }, {
      [`& .${ce.deleteIcon}`]: t[`deleteIconColor${te(n)}`]
    }, {
      [`& .${ce.deleteIcon}`]: t[`deleteIcon${te(l)}Color${te(n)}`]
    }, t.root, t[`size${te(s)}`], t[`color${te(n)}`], i && t.clickable, i && n !== "default" && t[`clickableColor${te(n)})`], a && t.deletable, a && n !== "default" && t[`deletableColor${te(n)}`], t[l], t[`${l}${te(n)}`]];
  }
})(Ye(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${ce.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${ce.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${ce.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${ce.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${ce.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${ce.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${ce.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : Me(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : Me(e.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${ce.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${ce.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter(tr(["contrastText"])).map(([r]) => ({
      props: {
        color: r
      },
      style: {
        backgroundColor: (e.vars || e).palette[r].main,
        color: (e.vars || e).palette[r].contrastText,
        [`& .${ce.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[r].contrastTextChannel} / 0.7)` : Me(e.palette[r].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[r].contrastText
          }
        }
      }
    })), {
      props: (r) => r.iconColor === r.color,
      style: {
        [`& .${ce.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
        }
      }
    }, {
      props: (r) => r.iconColor === r.color && r.color !== "default",
      style: {
        [`& .${ce.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${ce.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Me(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(e.palette).filter(tr(["dark"])).map(([r]) => ({
      props: {
        color: r,
        onDelete: !0
      },
      style: {
        [`&.${ce.focusVisible}`]: {
          background: (e.vars || e).palette[r].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Me(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
        },
        [`&.${ce.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Me(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter(tr(["dark"])).map(([r]) => ({
      props: {
        color: r,
        clickable: !0
      },
      style: {
        [`&:hover, &.${ce.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[r].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${ce.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${ce.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${ce.avatar}`]: {
          marginLeft: 4
        },
        [`& .${ce.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${ce.icon}`]: {
          marginLeft: 4
        },
        [`& .${ce.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${ce.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${ce.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter(tr()).map(([r]) => ({
      props: {
        variant: "outlined",
        color: r
      },
      style: {
        color: (e.vars || e).palette[r].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.7)` : Me(e.palette[r].main, 0.7)}`,
        [`&.${ce.clickable}:hover`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Me(e.palette[r].main, e.palette.action.hoverOpacity)
        },
        [`&.${ce.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.focusOpacity})` : Me(e.palette[r].main, e.palette.action.focusOpacity)
        },
        [`& .${ce.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.7)` : Me(e.palette[r].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[r].main
          }
        }
      }
    }))]
  };
})), sg = we("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e, {
      size: n
    } = r;
    return [t.label, t[`label${te(n)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function ts(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const Al = /* @__PURE__ */ I.forwardRef(function(t, r) {
  const n = St({
    props: t,
    name: "MuiChip"
  }), {
    avatar: o,
    className: i,
    clickable: a,
    color: s = "default",
    component: l,
    deleteIcon: u,
    disabled: f = !1,
    icon: h,
    label: g,
    onClick: m,
    onDelete: y,
    onKeyDown: p,
    onKeyUp: v,
    size: w = "medium",
    variant: R = "filled",
    tabIndex: x,
    skipFocusWhenDisabled: b = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    ...S
  } = n, P = I.useRef(null), q = Ht(P, r), D = (Z) => {
    Z.stopPropagation(), y && y(Z);
  }, z = (Z) => {
    Z.currentTarget === Z.target && ts(Z) && Z.preventDefault(), p && p(Z);
  }, d = (Z) => {
    Z.currentTarget === Z.target && y && ts(Z) && y(Z), v && v(Z);
  }, T = a !== !1 && m ? !0 : a, $ = T || y ? Un : l || "div", F = {
    ...n,
    component: $,
    disabled: f,
    size: w,
    color: s,
    iconColor: /* @__PURE__ */ I.isValidElement(h) && h.props.color || s,
    onDelete: !!y,
    clickable: T,
    variant: R
  }, Q = ig(F), ae = $ === Un ? {
    component: l || "div",
    focusVisibleClassName: Q.focusVisible,
    ...y && {
      disableRipple: !0
    }
  } : {};
  let Y = null;
  y && (Y = u && /* @__PURE__ */ I.isValidElement(u) ? /* @__PURE__ */ I.cloneElement(u, {
    className: xe(u.props.className, Q.deleteIcon),
    onClick: D
  }) : /* @__PURE__ */ L(ng, {
    className: Q.deleteIcon,
    onClick: D
  }));
  let re = null;
  o && /* @__PURE__ */ I.isValidElement(o) && (re = /* @__PURE__ */ I.cloneElement(o, {
    className: xe(Q.avatar, o.props.className)
  }));
  let oe = null;
  return h && /* @__PURE__ */ I.isValidElement(h) && (oe = /* @__PURE__ */ I.cloneElement(h, {
    className: xe(Q.icon, h.props.className)
  })), process.env.NODE_ENV !== "production" && re && oe && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ Fe(ag, {
    as: $,
    className: xe(Q.root, i),
    disabled: T && f ? !0 : void 0,
    onClick: m,
    onKeyDown: z,
    onKeyUp: d,
    ref: q,
    tabIndex: b && f ? -1 : x,
    ownerState: F,
    ...ae,
    ...S,
    children: [re || oe, /* @__PURE__ */ L(sg, {
      className: Q.label,
      ownerState: F,
      children: g
    }), Y]
  });
});
process.env.NODE_ENV !== "production" && (Al.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: c.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: mh,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: c.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: c.oneOfType([c.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: c.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * Icon element.
   */
  icon: c.element,
  /**
   * The content of the component.
   */
  label: c.node,
  /**
   * @ignore
   */
  onClick: c.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: c.func,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * @ignore
   */
  onKeyUp: c.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["medium", "small"]), c.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * @ignore
   */
  tabIndex: c.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: c.oneOfType([c.oneOf(["filled", "outlined"]), c.string])
});
const gt = Qe("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), Ao = {
  ...gt,
  ...Qe("MuiInput", ["root", "underline", "input"])
}, rs = {
  ...gt,
  ...Qe("MuiOutlinedInput", ["root", "notchedOutline", "input"])
}, mr = {
  ...gt,
  ...Qe("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, lg = un(/* @__PURE__ */ L("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), cg = un(/* @__PURE__ */ L("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function ug(e) {
  return ct("MuiAutocomplete", e);
}
const ie = Qe("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
function _o(e, t) {
  const {
    className: r,
    elementType: n,
    ownerState: o,
    externalForwardedProps: i,
    internalForwardedProps: a,
    shouldForwardComponentProp: s = !1,
    ...l
  } = t, {
    component: u,
    slots: f = {
      [e]: void 0
    },
    slotProps: h = {
      [e]: void 0
    },
    ...g
  } = i, m = f[e] || n, y = fl(h[e], o), {
    props: {
      component: p,
      ...v
    },
    internalRef: w
  } = ul({
    className: r,
    ...l,
    externalForwardedProps: e === "root" ? g : void 0,
    externalSlotProps: y
  }), R = Ht(w, y == null ? void 0 : y.ref, t.ref), x = e === "root" ? p || u : p, b = cl(m, {
    ...e === "root" && !u && !f[e] && a,
    ...e !== "root" && !f[e] && a,
    ...v,
    ...x && !s && {
      as: x
    },
    ...x && s && {
      component: x
    },
    ref: R
  }, o);
  return [m, b];
}
var ns, os;
const fg = (e) => {
  const {
    classes: t,
    disablePortal: r,
    expanded: n,
    focused: o,
    fullWidth: i,
    hasClearIcon: a,
    hasPopupIcon: s,
    inputFocused: l,
    popupOpen: u,
    size: f
  } = e, h = {
    root: ["root", n && "expanded", o && "focused", i && "fullWidth", a && "hasClearIcon", s && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", l && "inputFocused"],
    tag: ["tag", `tagSize${te(f)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", u && "popupIndicatorOpen"],
    popper: ["popper", r && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return At(h, ug, t);
}, pg = we("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e, {
      fullWidth: n,
      hasClearIcon: o,
      hasPopupIcon: i,
      inputFocused: a,
      size: s
    } = r;
    return [{
      [`& .${ie.tag}`]: t.tag
    }, {
      [`& .${ie.tag}`]: t[`tagSize${te(s)}`]
    }, {
      [`& .${ie.inputRoot}`]: t.inputRoot
    }, {
      [`& .${ie.input}`]: t.input
    }, {
      [`& .${ie.input}`]: a && t.inputFocused
    }, t.root, n && t.fullWidth, i && t.hasPopupIcon, o && t.hasClearIcon];
  }
})({
  [`&.${ie.focused} .${ie.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${ie.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${ie.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${ie.inputRoot}`]: {
    [`.${ie.hasPopupIcon}&, .${ie.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${ie.hasPopupIcon}.${ie.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${ie.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${Ao.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${Ao.root}.${gt.sizeSmall}`]: {
    [`& .${Ao.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${rs.root}`]: {
    padding: 9,
    [`.${ie.hasPopupIcon}&, .${ie.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${ie.hasPopupIcon}.${ie.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${ie.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${ie.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${rs.root}.${gt.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${ie.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${mr.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${ie.hasPopupIcon}&, .${ie.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${ie.hasPopupIcon}.${ie.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${mr.input}`]: {
      padding: "7px 4px"
    },
    [`& .${ie.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${mr.root}.${gt.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${mr.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${gt.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${mr.root}.${gt.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${ie.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${mr.root}.${gt.hiddenLabel}.${gt.sizeSmall}`]: {
    [`& .${ie.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${ie.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${ie.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${ie.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${ie.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), dg = we("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment"
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), hg = we(Bi, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator"
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), gg = we(Bi, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.popupIndicator, r.popupOpen && t.popupIndicatorOpen];
  }
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), yg = we(Di, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${ie.option}`]: t.option
    }, t.popper, r.disablePortal && t.popperDisablePortal];
  }
})(Ye(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
}))), mg = we(Ni, {
  name: "MuiAutocomplete",
  slot: "Paper"
})(Ye(({
  theme: e
}) => ({
  ...e.typography.body1,
  overflow: "auto"
}))), vg = we("div", {
  name: "MuiAutocomplete",
  slot: "Loading"
})(Ye(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), bg = we("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions"
})(Ye(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), Sg = we("ul", {
  name: "MuiAutocomplete",
  slot: "Listbox"
})(Ye(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${ie.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${ie.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${ie.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Me(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${ie.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Me(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${ie.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Me(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
}))), wg = we(zn, {
  name: "MuiAutocomplete",
  slot: "GroupLabel"
})(Ye(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
}))), Og = we("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl"
})({
  padding: 0,
  [`& .${ie.option}`]: {
    paddingLeft: 24
  }
}), _l = /* @__PURE__ */ I.forwardRef(function(t, r) {
  const n = St({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: o = !1,
    autoHighlight: i = !1,
    autoSelect: a = !1,
    blurOnSelect: s = !1,
    ChipProps: l,
    className: u,
    clearIcon: f = ns || (ns = /* @__PURE__ */ L(lg, {
      fontSize: "small"
    })),
    clearOnBlur: h = !n.freeSolo,
    clearOnEscape: g = !1,
    clearText: m = "Clear",
    closeText: y = "Close",
    componentsProps: p,
    defaultValue: v = n.multiple ? [] : null,
    disableClearable: w = !1,
    disableCloseOnSelect: R = !1,
    disabled: x = !1,
    disabledItemsFocusable: b = !1,
    disableListWrap: S = !1,
    disablePortal: P = !1,
    filterOptions: q,
    filterSelectedOptions: D = !1,
    forcePopupIcon: z = "auto",
    freeSolo: d = !1,
    fullWidth: T = !1,
    getLimitTagsText: $ = (ue) => `+${ue}`,
    getOptionDisabled: F,
    getOptionKey: Q,
    getOptionLabel: ae,
    isOptionEqualToValue: Y,
    groupBy: re,
    handleHomeEndKeys: oe = !n.freeSolo,
    id: Z,
    includeInputInList: k = !1,
    inputValue: A,
    limitTags: W = -1,
    ListboxComponent: _,
    ListboxProps: M,
    loading: N = !1,
    loadingText: j = "Loading…",
    multiple: U = !1,
    noOptionsText: G = "No options",
    onChange: H,
    onClose: K,
    onHighlightChange: Se,
    onInputChange: V,
    onOpen: de,
    open: Le,
    openOnFocus: ut = !1,
    openText: Ie = "Open",
    options: ft,
    PaperComponent: X,
    PopperComponent: wt,
    popupIcon: le = os || (os = /* @__PURE__ */ L(cg, {})),
    readOnly: ze = !1,
    renderGroup: ee,
    renderInput: Gt,
    renderOption: pt,
    renderTags: Je,
    renderValue: _t,
    selectOnFocus: Ar = !n.freeSolo,
    size: Ot = "medium",
    slots: fn = {},
    slotProps: qe = {},
    value: Ce,
    ...it
  } = n, {
    getRootProps: pn,
    getInputProps: at,
    getInputLabelProps: po,
    getPopupIndicatorProps: Et,
    getClearProps: st,
    getItemProps: ho,
    getListboxProps: _r,
    getOptionProps: go,
    value: We,
    dirty: Kt,
    expanded: xt,
    id: ur,
    popupOpen: dt,
    focused: dn,
    focusedItem: hn,
    anchorEl: Xt,
    setAnchorEl: yo,
    inputValue: mo,
    groupedOptions: Jt
  } = xu({
    ...n,
    componentName: "Autocomplete"
  }), Mr = !w && !x && Kt && !ze, Dr = (!d || z === !0) && z !== !1, {
    onMouseDown: vo
  } = at(), {
    ref: bo,
    ...gn
  } = _r(), fr = ae || ((ue) => ue.label ?? ue), De = {
    ...n,
    disablePortal: P,
    expanded: xt,
    focused: dn,
    fullWidth: T,
    getOptionLabel: fr,
    hasClearIcon: Mr,
    hasPopupIcon: Dr,
    inputFocused: hn === -1,
    popupOpen: dt,
    size: Ot
  }, _e = fg(De), Mt = {
    slots: {
      paper: X,
      popper: wt,
      ...fn
    },
    slotProps: {
      chip: l,
      listbox: M,
      ...p,
      ...qe
    }
  }, [Nr, yn] = _o("listbox", {
    elementType: Sg,
    externalForwardedProps: Mt,
    ownerState: De,
    className: _e.listbox,
    additionalProps: gn,
    ref: bo
  }), [C, O] = _o("paper", {
    elementType: Ni,
    externalForwardedProps: Mt,
    ownerState: De,
    className: _e.paper
  }), [B, se] = _o("popper", {
    elementType: Di,
    externalForwardedProps: Mt,
    ownerState: De,
    className: _e.popper,
    additionalProps: {
      disablePortal: P,
      style: {
        width: Xt ? Xt.clientWidth : null
      },
      role: "presentation",
      anchorEl: Xt,
      open: dt
    }
  });
  let J;
  const ye = (ue) => ({
    className: _e.tag,
    disabled: x,
    ...ho(ue)
  });
  if (Je && U && We.length > 0 ? J = Je(We, ye, De) : _t && We ? J = _t(We, ye, De) : U && We.length > 0 && (J = We.map((ue, Dt) => {
    const {
      key: Nt,
      ...jr
    } = ye({
      index: Dt
    });
    return /* @__PURE__ */ L(Al, {
      label: fr(ue),
      size: Ot,
      ...jr,
      ...Mt.slotProps.chip
    }, Nt);
  })), W > -1 && Array.isArray(J)) {
    const ue = J.length - W;
    !dn && ue > 0 && (J = J.splice(0, W), J.push(/* @__PURE__ */ L("span", {
      className: _e.tag,
      children: $(ue)
    }, J.length)));
  }
  const je = ee || ((ue) => /* @__PURE__ */ Fe("li", {
    children: [/* @__PURE__ */ L(wg, {
      className: _e.groupLabel,
      ownerState: De,
      component: "div",
      children: ue.group
    }), /* @__PURE__ */ L(Og, {
      className: _e.groupUl,
      ownerState: De,
      children: ue.children
    })]
  }, ue.key)), lc = pt || ((ue, Dt) => {
    const {
      key: Nt,
      ...jr
    } = ue;
    return /* @__PURE__ */ L("li", {
      ...jr,
      children: fr(Dt)
    }, Nt);
  }), Ji = (ue, Dt) => {
    const Nt = go({
      option: ue,
      index: Dt
    });
    return lc({
      ...Nt,
      className: _e.option
    }, ue, {
      selected: Nt["aria-selected"],
      index: Dt,
      inputValue: mo
    }, De);
  }, mn = Mt.slotProps.clearIndicator, vn = Mt.slotProps.popupIndicator;
  return /* @__PURE__ */ Fe(I.Fragment, {
    children: [/* @__PURE__ */ L(pg, {
      ref: r,
      className: xe(_e.root, u),
      ownerState: De,
      ...pn(it),
      children: Gt({
        id: ur,
        disabled: x,
        fullWidth: !0,
        size: Ot === "small" ? "small" : void 0,
        InputLabelProps: po(),
        InputProps: {
          ref: yo,
          className: _e.inputRoot,
          startAdornment: J,
          onMouseDown: (ue) => {
            ue.target === ue.currentTarget && vo(ue);
          },
          ...(Mr || Dr) && {
            endAdornment: /* @__PURE__ */ Fe(dg, {
              className: _e.endAdornment,
              ownerState: De,
              children: [Mr ? /* @__PURE__ */ L(hg, {
                ...st(),
                "aria-label": m,
                title: m,
                ownerState: De,
                ...mn,
                className: xe(_e.clearIndicator, mn == null ? void 0 : mn.className),
                children: f
              }) : null, Dr ? /* @__PURE__ */ L(gg, {
                ...Et(),
                disabled: x,
                "aria-label": dt ? y : Ie,
                title: dt ? y : Ie,
                ownerState: De,
                ...vn,
                className: xe(_e.popupIndicator, vn == null ? void 0 : vn.className),
                children: le
              }) : null]
            })
          }
        },
        inputProps: {
          className: _e.input,
          disabled: x,
          readOnly: ze,
          ...at()
        }
      })
    }), Xt ? /* @__PURE__ */ L(yg, {
      as: B,
      ...se,
      children: /* @__PURE__ */ Fe(mg, {
        as: C,
        ...O,
        children: [N && Jt.length === 0 ? /* @__PURE__ */ L(vg, {
          className: _e.loading,
          ownerState: De,
          children: j
        }) : null, Jt.length === 0 && !d && !N ? /* @__PURE__ */ L(bg, {
          className: _e.noOptions,
          ownerState: De,
          role: "presentation",
          onMouseDown: (ue) => {
            ue.preventDefault();
          },
          children: G
        }) : null, Jt.length > 0 ? /* @__PURE__ */ L(Nr, {
          as: _,
          ...yn,
          children: Jt.map((ue, Dt) => re ? je({
            key: ue.key,
            group: ue.group,
            children: ue.options.map((Nt, jr) => Ji(Nt, ue.index + jr))
          }) : Ji(ue, Dt))
        }) : null]
      })
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (_l.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: c.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: c.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: c.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: c.oneOfType([c.oneOf(["mouse", "touch"]), c.bool]),
  /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ChipProps: c.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: c.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: c.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: c.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: c.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: c.string,
  /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: c.shape({
    clearIndicator: c.object,
    paper: c.object,
    popper: c.object,
    popupIndicator: c.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: lr(c.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: c.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: c.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: c.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: c.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: c.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: c.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: c.oneOfType([c.oneOf(["auto"]), c.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: c.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: c.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: c.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: c.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: c.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} option The Autocomplete option.
   * @returns {string}
   */
  groupBy: c.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: c.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: c.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: c.bool,
  /**
   * The input value.
   */
  inputValue: c.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: c.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: Xs,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxComponent: c.elementType,
  /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxProps: c.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: c.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: c.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: c.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: c.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: c.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: c.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: c.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */
  onInputChange: c.func,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: c.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: c.string,
  /**
   * A list of options that will be shown in the Autocomplete.
   */
  options: c.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperComponent: c.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: c.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: c.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: c.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: c.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: c.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: c.func,
  /**
   * Render the selected value when doing multiple selections.
   *
   * @deprecated Use `renderValue` prop instead
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: c.func,
  /**
   * Renders the selected value(s) as rich content in the input for both single and multiple selections.
   *
   * @param {AutocompleteRenderValue<Value, Multiple, FreeSolo>} value The `value` provided to the component.
   * @param {function} getItemProps The value item props.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderValue: c.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: c.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium"]), c.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    chip: c.oneOfType([c.func, c.object]),
    clearIndicator: c.oneOfType([c.func, c.object]),
    listbox: c.oneOfType([c.func, c.object]),
    paper: c.oneOfType([c.func, c.object]),
    popper: c.oneOfType([c.func, c.object]),
    popupIndicator: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    listbox: c.elementType,
    paper: c.elementType,
    popper: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: lr(c.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const Ml = un(/* @__PURE__ */ L("path", {
  d: "M19 5v14H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
}), "CheckBoxOutlineBlank"), Dl = un(/* @__PURE__ */ L("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2m-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckBox"), Eg = pc((e, t) => {
  const { onSelectAll: r, allSelected: n, ...o } = e;
  return Fe("ul", { ...o, ref: t, role: "listbox", children: [L("li", { role: "option", "data-option-index": "-1", id: ":r0:-option--1", className: "MuiAutocomplete-option", style: { padding: "6px 16px", listStyle: "none" }, onClick: r, children: Fe(yi, { direction: "row", gap: 1, sx: { backgroundColor: "transparent", height: 1 }, alignItems: "center", children: [L(Ps, { size: "small", checked: n, icon: L(Ml, { fontSize: "small" }), checkedIcon: L(Dl, { fontSize: "small" }), sx: { padding: "0 4px" }, "data-testid": "autocomplete-select-all-checkbox" }), L(wr, { children: "Select all" })] }) }), L(As, {}), e.children] });
}), Mo = 5, xg = (e, t) => ({ children: r, group: n, key: o }) => n === "unchecked" ? Fe("li", { children: [L(As, { sx: { my: 0 } }), L("ul", { style: { padding: 0 }, children: r })] }, o) : n === "checked" && Array.isArray(r) && r.length > Mo ? Fe(gi, { children: [r.slice(0, Mo).concat(L(Zi, { in: !e, children: L(_s, { sx: (i) => ({
  cursor: "pointer",
  "&:hover": {
    backgroundColor: dc(i.palette.primary.main, i.palette.action.selectedOpacity + i.palette.action.hoverOpacity)
  }
}), onClick: () => t(!0), children: L(yi, { sx: { width: 1 }, direction: "row", justifyContent: "center", alignItems: "center", children: L(wc, {}) }) }, "show-more") })), L(Zi, { in: e, children: r.slice(Mo) })] }) : r;
var ni = function(e, t) {
  return ni = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
  }, ni(e, t);
};
function Fi(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  ni(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var ne = function() {
  return ne = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, ne.apply(this, arguments);
};
function Hn(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function xr(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, o = t.length, i; n < o; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Do = "Invariant Violation", is = Object.setPrototypeOf, Cg = is === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : is, Nl = (
  /** @class */
  function(e) {
    Fi(t, e);
    function t(r) {
      r === void 0 && (r = Do);
      var n = e.call(this, typeof r == "number" ? Do + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return n.framesToPop = 1, n.name = Do, Cg(n, t.prototype), n;
    }
    return t;
  }(Error)
);
function Zt(e, t) {
  if (!e)
    throw new Nl(t);
}
var Ll = ["debug", "log", "warn", "error", "silent"], Tg = Ll.indexOf("log");
function En(e) {
  return function() {
    if (Ll.indexOf(e) >= Tg) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = En("debug"), e.log = En("log"), e.warn = En("warn"), e.error = En("error");
})(Zt || (Zt = {}));
var jl = "3.13.8";
function $t(e) {
  try {
    return e();
  } catch {
  }
}
const oi = $t(function() {
  return globalThis;
}) || $t(function() {
  return window;
}) || $t(function() {
  return self;
}) || $t(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
$t(function() {
  return $t.constructor("return this")();
});
var as = /* @__PURE__ */ new Map();
function $g(e) {
  var t = as.get(e) || 1;
  return as.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function Ig(e, t) {
  var r = $g("stringifyForDisplay");
  return JSON.stringify(e, function(n, o) {
    return o === void 0 ? r : o;
  }, t).split(JSON.stringify(r)).join("<undefined>");
}
function xn(e) {
  return function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    if (typeof t == "number") {
      var o = t;
      t = zi(o), t || (t = qi(o, r), r = []);
    }
    e.apply(void 0, [t].concat(r));
  };
}
var $e = Object.assign(function(t, r) {
  for (var n = [], o = 2; o < arguments.length; o++)
    n[o - 2] = arguments[o];
  t || Zt(t, zi(r, n) || qi(r, n));
}, {
  debug: xn(Zt.debug),
  log: xn(Zt.log),
  warn: xn(Zt.warn),
  error: xn(Zt.error)
});
function Vl(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return new Nl(zi(e, t) || qi(e, t));
}
var ss = Symbol.for("ApolloErrorMessageHandler_" + jl);
function Bl(e) {
  if (typeof e == "string")
    return e;
  try {
    return Ig(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function zi(e, t) {
  if (t === void 0 && (t = []), !!e)
    return oi[ss] && oi[ss](e, t.map(Bl));
}
function qi(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: jl,
      message: e,
      args: t.map(Bl)
    })));
}
function Rg(e, t) {
  var r = e.directives;
  return !r || !r.length ? !0 : Pg(r).every(function(n) {
    var o = n.directive, i = n.ifArgument, a = !1;
    return i.value.kind === "Variable" ? (a = t && t[i.value.name.value], $e(a !== void 0, 78, o.name.value)) : a = i.value.value, o.name.value === "skip" ? !a : a;
  });
}
function kg(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function Pg(e) {
  var t = [];
  return e && e.length && e.forEach(function(r) {
    if (kg(r)) {
      var n = r.arguments, o = r.name.value;
      $e(n && n.length === 1, 79, o);
      var i = n[0];
      $e(i.name && i.name.value === "if", 80, o);
      var a = i.value;
      $e(a && (a.kind === "Variable" || a.kind === "BooleanValue"), 81, o), t.push({ directive: r, ifArgument: i });
    }
  }), t;
}
var Ag = $t(function() {
  return navigator.product;
}) == "ReactNative", Fl = typeof Symbol == "function" && typeof Symbol.for == "function", zl = typeof $t(function() {
  return window.document.createElement;
}) == "function", _g = (
  // Following advice found in this comment from @domenic (maintainer of jsdom):
  // https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
  //
  // Since we control the version of Jest and jsdom used when running Apollo
  // Client tests, and that version is recent enought to include " jsdom/x.y.z"
  // at the end of the user agent string, I believe this case is all we need to
  // check. Testing for "Node.js" was recommended for backwards compatibility
  // with older version of jsdom, but we don't have that problem.
  $t(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
  }) || !1
), Mg = (zl || Ag) && !_g;
function ii(e) {
  return e !== null && typeof e == "object";
}
function Dg(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(r) {
    t[r.name.value] = r;
  }), t;
}
function Ng(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var r = e.name.value;
      if (typeof t == "function")
        return t(r);
      var n = t && t[r];
      return $e(n, 87, r), n || null;
    }
    default:
      return null;
  }
}
function Lg() {
}
class ls {
  constructor(t = 1 / 0, r = Lg) {
    this.max = t, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: o } = r;
      o && (o.older = n), n && (n.newer = o), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = o);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(t, n), n.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(t), this.dispose(r.value, t), !0) : !1;
  }
}
function ai() {
}
const jg = ai, Vg = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, Bg = typeof WeakMap < "u" ? WeakMap : Map, Fg = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: ai,
    unregister: ai
  };
}, zg = 10024;
class cs {
  constructor(t = 1 / 0, r = jg) {
    this.max = t, this.dispose = r, this.map = new Bg(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const n = this.unfinalizedNodes.values();
      for (let o = 0; o < zg; o++) {
        const i = n.next().value;
        if (!i)
          break;
        this.unfinalizedNodes.delete(i);
        const a = i.key;
        delete i.key, i.keyRef = new Vg(a), this.registry.register(a, i, i);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new Fg(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: o } = r;
      o && (o.older = n), n && (n.newer = o), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = o);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(t, n), this.size++, n.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const r = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, r), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), r && this.map.delete(r);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (this.deleteNode(r), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var No = /* @__PURE__ */ new WeakSet();
function ql(e) {
  e.size <= (e.max || -1) || No.has(e) || (No.add(e), setTimeout(function() {
    e.clean(), No.delete(e);
  }, 100));
}
var qg = function(e, t) {
  var r = new cs(e, t);
  return r.set = function(n, o) {
    var i = cs.prototype.set.call(this, n, o);
    return ql(this), i;
  }, r;
}, Wg = function(e, t) {
  var r = new ls(e, t);
  return r.set = function(n, o) {
    var i = ls.prototype.set.call(this, n, o);
    return ql(this), i;
  }, r;
}, Ug = Symbol.for("apollo.cacheSize"), Wl = ne({}, oi[Ug]), Hg = {};
function Ul(e, t) {
  Hg[e] = t;
}
var Hl = Object.assign(function(t) {
  return JSON.stringify(t, Yg);
}, {
  reset: function() {
    Or = new Wg(
      Wl.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && Ul("canonicalStringify", function() {
  return Or.size;
});
var Or;
Hl.reset();
function Yg(e, t) {
  if (t && typeof t == "object") {
    var r = Object.getPrototypeOf(t);
    if (r === Object.prototype || r === null) {
      var n = Object.keys(t);
      if (n.every(Qg))
        return t;
      var o = JSON.stringify(n), i = Or.get(o);
      if (!i) {
        n.sort();
        var a = JSON.stringify(n);
        i = Or.get(a) || n, Or.set(o, i), Or.set(a, i);
      }
      var s = Object.create(r);
      return i.forEach(function(l) {
        s[l] = t[l];
      }), s;
    }
  }
  return t;
}
function Qg(e, t, r) {
  return t === 0 || r[t - 1] <= e;
}
var Gg = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], zr = Hl;
Object.assign(function(e, t, r) {
  if (t && r && r.connection && r.connection.key)
    if (r.connection.filter && r.connection.filter.length > 0) {
      var n = r.connection.filter ? r.connection.filter : [];
      n.sort();
      var o = {};
      return n.forEach(function(s) {
        o[s] = t[s];
      }), "".concat(r.connection.key, "(").concat(zr(o), ")");
    } else
      return r.connection.key;
  var i = e;
  if (t) {
    var a = zr(t);
    i += "(".concat(a, ")");
  }
  return r && Object.keys(r).forEach(function(s) {
    Gg.indexOf(s) === -1 && (r[s] && Object.keys(r[s]).length ? i += "@".concat(s, "(").concat(zr(r[s]), ")") : i += "@".concat(s));
  }), i;
}, {
  setStringify: function(e) {
    var t = zr;
    return zr = e, t;
  }
});
function Kg(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function Xg(e) {
  return e.kind === "Field";
}
function Yl(e) {
  $e(e && e.kind === "Document", 88);
  var t = e.definitions.filter(function(r) {
    return r.kind !== "FragmentDefinition";
  }).map(function(r) {
    if (r.kind !== "OperationDefinition")
      throw Vl(89, r.kind);
    return r;
  });
  return $e(t.length <= 1, 90, t.length), e;
}
function Ql(e) {
  return Yl(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function Jg(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function Zg(e) {
  var t = Ql(e);
  return $e(t && t.operation === "query", 91), t;
}
function ey(e) {
  Yl(e);
  for (var t, r = 0, n = e.definitions; r < n.length; r++) {
    var o = n[r];
    if (o.kind === "OperationDefinition") {
      var i = o.operation;
      if (i === "query" || i === "mutation" || i === "subscription")
        return o;
    }
    o.kind === "FragmentDefinition" && !t && (t = o);
  }
  if (t)
    return t;
  throw Vl(95);
}
let Ne = null;
const us = {};
let ty = 1;
const ry = () => class {
  constructor() {
    this.id = [
      "slot",
      ty++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let t = Ne; t; t = t.parent)
      if (this.id in t.slots) {
        const r = t.slots[this.id];
        if (r === us)
          break;
        return t !== Ne && (Ne.slots[this.id] = r), !0;
      }
    return Ne && (Ne.slots[this.id] = us), !1;
  }
  getValue() {
    if (this.hasValue())
      return Ne.slots[this.id];
  }
  withValue(t, r, n, o) {
    const i = {
      __proto__: null,
      [this.id]: t
    }, a = Ne;
    Ne = { parent: a, slots: i };
    try {
      return r.apply(o, n);
    } finally {
      Ne = a;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(t) {
    const r = Ne;
    return function() {
      const n = Ne;
      try {
        return Ne = r, t.apply(this, arguments);
      } finally {
        Ne = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(t, r, n) {
    if (Ne) {
      const o = Ne;
      try {
        return Ne = null, t.apply(n, r);
      } finally {
        Ne = o;
      }
    } else
      return t.apply(n, r);
  }
};
function fs(e) {
  try {
    return e();
  } catch {
  }
}
const Lo = "@wry/context:Slot", ny = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  fs(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  fs(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), ps = ny, Wi = ps[Lo] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Lo] || function(e) {
  try {
    Object.defineProperty(ps, Lo, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
}(ry()), { bind: gm, noContext: ym } = Wi;
new Wi();
function Gl(e) {
  return Array.isArray(e) && e.length > 0;
}
function oy(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = iy(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iy(e, t) {
  if (e) {
    if (typeof e == "string") return ds(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ds(e, t);
  }
}
function ds(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function hs(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Ui(e, t, r) {
  return t && hs(e.prototype, t), r && hs(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Hi = function() {
  return typeof Symbol == "function";
}, Yi = function(e) {
  return Hi() && !!Symbol[e];
}, Qi = function(e) {
  return Yi(e) ? Symbol[e] : "@@" + e;
};
Hi() && !Yi("observable") && (Symbol.observable = Symbol("observable"));
var ay = Qi("iterator"), si = Qi("observable"), Kl = Qi("species");
function Yn(e, t) {
  var r = e[t];
  if (r != null) {
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    return r;
  }
}
function qr(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[Kl], t === null && (t = void 0)), t !== void 0 ? t : Pr;
}
function sy(e) {
  return e instanceof Pr;
}
function kr(e) {
  kr.log ? kr.log(e) : setTimeout(function() {
    throw e;
  });
}
function An(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      kr(t);
    }
  });
}
function Xl(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var r = Yn(t, "unsubscribe");
        r && r.call(t);
      }
    } catch (n) {
      kr(n);
    }
}
function li(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function ly(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var r = 0; r < t.length && (Jl(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
      ;
  }
}
function Jl(e, t, r) {
  e._state = "running";
  var n = e._observer;
  try {
    var o = Yn(n, t);
    switch (t) {
      case "next":
        o && o.call(n, r);
        break;
      case "error":
        if (li(e), o) o.call(n, r);
        else throw r;
        break;
      case "complete":
        li(e), o && o.call(n);
        break;
    }
  } catch (i) {
    kr(i);
  }
  e._state === "closed" ? Xl(e) : e._state === "running" && (e._state = "ready");
}
function jo(e, t, r) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: r
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: r
      }], An(function() {
        return ly(e);
      });
      return;
    }
    Jl(e, t, r);
  }
}
var cy = /* @__PURE__ */ function() {
  function e(r, n) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var o = new uy(this);
    try {
      this._cleanup = n.call(void 0, o);
    } catch (i) {
      o.error(i);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (li(this), Xl(this));
  }, Ui(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
}(), uy = /* @__PURE__ */ function() {
  function e(r) {
    this._subscription = r;
  }
  var t = e.prototype;
  return t.next = function(n) {
    jo(this._subscription, "next", n);
  }, t.error = function(n) {
    jo(this._subscription, "error", n);
  }, t.complete = function() {
    jo(this._subscription, "complete");
  }, Ui(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
}(), Pr = /* @__PURE__ */ function() {
  function e(r) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var t = e.prototype;
  return t.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new cy(n, this._subscriber);
  }, t.forEach = function(n) {
    var o = this;
    return new Promise(function(i, a) {
      if (typeof n != "function") {
        a(new TypeError(n + " is not a function"));
        return;
      }
      function s() {
        l.unsubscribe(), i();
      }
      var l = o.subscribe({
        next: function(u) {
          try {
            n(u, s);
          } catch (f) {
            a(f), l.unsubscribe();
          }
        },
        error: a,
        complete: i
      });
    });
  }, t.map = function(n) {
    var o = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = qr(this);
    return new i(function(a) {
      return o.subscribe({
        next: function(s) {
          try {
            s = n(s);
          } catch (l) {
            return a.error(l);
          }
          a.next(s);
        },
        error: function(s) {
          a.error(s);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.filter = function(n) {
    var o = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = qr(this);
    return new i(function(a) {
      return o.subscribe({
        next: function(s) {
          try {
            if (!n(s)) return;
          } catch (l) {
            return a.error(l);
          }
          a.next(s);
        },
        error: function(s) {
          a.error(s);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.reduce = function(n) {
    var o = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = qr(this), a = arguments.length > 1, s = !1, l = arguments[1], u = l;
    return new i(function(f) {
      return o.subscribe({
        next: function(h) {
          var g = !s;
          if (s = !0, !g || a)
            try {
              u = n(u, h);
            } catch (m) {
              return f.error(m);
            }
          else
            u = h;
        },
        error: function(h) {
          f.error(h);
        },
        complete: function() {
          if (!s && !a) return f.error(new TypeError("Cannot reduce an empty sequence"));
          f.next(u), f.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var n = this, o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    var s = qr(this);
    return new s(function(l) {
      var u, f = 0;
      function h(g) {
        u = g.subscribe({
          next: function(m) {
            l.next(m);
          },
          error: function(m) {
            l.error(m);
          },
          complete: function() {
            f === i.length ? (u = void 0, l.complete()) : h(s.from(i[f++]));
          }
        });
      }
      return h(n), function() {
        u && (u.unsubscribe(), u = void 0);
      };
    });
  }, t.flatMap = function(n) {
    var o = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = qr(this);
    return new i(function(a) {
      var s = [], l = o.subscribe({
        next: function(f) {
          if (n)
            try {
              f = n(f);
            } catch (g) {
              return a.error(g);
            }
          var h = i.from(f).subscribe({
            next: function(g) {
              a.next(g);
            },
            error: function(g) {
              a.error(g);
            },
            complete: function() {
              var g = s.indexOf(h);
              g >= 0 && s.splice(g, 1), u();
            }
          });
          s.push(h);
        },
        error: function(f) {
          a.error(f);
        },
        complete: function() {
          u();
        }
      });
      function u() {
        l.closed && s.length === 0 && a.complete();
      }
      return function() {
        s.forEach(function(f) {
          return f.unsubscribe();
        }), l.unsubscribe();
      };
    });
  }, t[si] = function() {
    return this;
  }, e.from = function(n) {
    var o = typeof this == "function" ? this : e;
    if (n == null) throw new TypeError(n + " is not an object");
    var i = Yn(n, si);
    if (i) {
      var a = i.call(n);
      if (Object(a) !== a) throw new TypeError(a + " is not an object");
      return sy(a) && a.constructor === o ? a : new o(function(s) {
        return a.subscribe(s);
      });
    }
    if (Yi("iterator") && (i = Yn(n, ay), i))
      return new o(function(s) {
        An(function() {
          if (!s.closed) {
            for (var l = oy(i.call(n)), u; !(u = l()).done; ) {
              var f = u.value;
              if (s.next(f), s.closed) return;
            }
            s.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new o(function(s) {
        An(function() {
          if (!s.closed) {
            for (var l = 0; l < n.length; ++l)
              if (s.next(n[l]), s.closed) return;
            s.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, e.of = function() {
    for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++)
      o[i] = arguments[i];
    var a = typeof this == "function" ? this : e;
    return new a(function(s) {
      An(function() {
        if (!s.closed) {
          for (var l = 0; l < o.length; ++l)
            if (s.next(o[l]), s.closed) return;
          s.complete();
        }
      });
    });
  }, Ui(e, null, [{
    key: Kl,
    get: function() {
      return this;
    }
  }]), e;
}();
Hi() && Object.defineProperty(Pr, Symbol("extensions"), {
  value: {
    symbol: si,
    hostReportError: kr
  },
  configurable: !0
});
function fy(e) {
  var t, r = e.Symbol;
  if (typeof r == "function")
    if (r.observable)
      t = r.observable;
    else {
      typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var br;
typeof self < "u" ? br = self : typeof window < "u" ? br = window : typeof global < "u" ? br = global : typeof module < "u" ? br = module : br = Function("return this")();
fy(br);
var gs = Pr.prototype, ys = "@@observable";
gs[ys] || (gs[ys] = function() {
  return this;
});
function py(e) {
  return e.catch(function() {
  }), e;
}
var dy = Object.prototype.toString;
function hy(e) {
  return ci(e);
}
function ci(e, t) {
  switch (dy.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = e.slice(0);
      return t.set(e, r), r.forEach(function(o, i) {
        r[i] = ci(o, t);
      }), r;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = Object.create(Object.getPrototypeOf(e));
      return t.set(e, n), Object.keys(e).forEach(function(o) {
        n[o] = ci(e[o], t);
      }), n;
    }
    default:
      return e;
  }
}
function gy(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(r) {
    ii(r) && yy(r) === r && Object.getOwnPropertyNames(r).forEach(function(n) {
      ii(r[n]) && t.add(r[n]);
    });
  }), e;
}
function yy(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function Zl(e) {
  return globalThis.__DEV__ !== !1 && gy(e), e;
}
function ms(e, t, r) {
  var n = [];
  e.forEach(function(o) {
    return o[t] && n.push(o);
  }), n.forEach(function(o) {
    return o[t](r);
  });
}
function my(e) {
  function t(r) {
    Object.defineProperty(e, r, { value: Pr });
  }
  return Fl && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function rn() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(n) {
    n && Object.keys(n).forEach(function(o) {
      var i = n[o];
      i !== void 0 && (r[o] = i);
    });
  }), r;
}
function ui(e, t) {
  return rn(e, t, t.variables && {
    variables: rn(ne(ne({}, e && e.variables), t.variables))
  });
}
function vy(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var by = function(e) {
  var t = xr(xr(xr([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(r) {
    return ii(r) && r.message || "Error message not found.";
  }).join(`
`);
}, Gi = (
  /** @class */
  function(e) {
    Fi(t, e);
    function t(r) {
      var n = r.graphQLErrors, o = r.protocolErrors, i = r.clientErrors, a = r.networkError, s = r.errorMessage, l = r.extraInfo, u = e.call(this, s) || this;
      return u.name = "ApolloError", u.graphQLErrors = n || [], u.protocolErrors = o || [], u.clientErrors = i || [], u.networkError = a || null, u.message = s || by(u), u.extraInfo = l, u.cause = xr(xr(xr([
        a
      ], n || [], !0), o || [], !0), i || [], !0).find(function(f) {
        return !!f;
      }) || null, u.__proto__ = t.prototype, u;
    }
    return t;
  }(Error)
);
const { toString: vs, hasOwnProperty: Sy } = Object.prototype, bs = Function.prototype.toString, fi = /* @__PURE__ */ new Map();
function Be(e, t) {
  try {
    return pi(e, t);
  } finally {
    fi.clear();
  }
}
function pi(e, t) {
  if (e === t)
    return !0;
  const r = vs.call(e), n = vs.call(t);
  if (r !== n)
    return !1;
  switch (r) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    case "[object Object]": {
      if (ws(e, t))
        return !0;
      const o = Ss(e), i = Ss(t), a = o.length;
      if (a !== i.length)
        return !1;
      for (let s = 0; s < a; ++s)
        if (!Sy.call(t, o[s]))
          return !1;
      for (let s = 0; s < a; ++s) {
        const l = o[s];
        if (!pi(e[l], t[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (ws(e, t))
        return !0;
      const o = e.entries(), i = r === "[object Map]";
      for (; ; ) {
        const a = o.next();
        if (a.done)
          break;
        const [s, l] = a.value;
        if (!t.has(s) || i && !pi(l, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    case "[object DataView]": {
      let o = e.byteLength;
      if (o === t.byteLength)
        for (; o-- && e[o] === t[o]; )
          ;
      return o === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const o = bs.call(e);
      return o !== bs.call(t) ? !1 : !Ey(o, Oy);
    }
  }
  return !1;
}
function Ss(e) {
  return Object.keys(e).filter(wy, e);
}
function wy(e) {
  return this[e] !== void 0;
}
const Oy = "{ [native code] }";
function Ey(e, t) {
  const r = e.length - t.length;
  return r >= 0 && e.indexOf(t, r) === r;
}
function ws(e, t) {
  let r = fi.get(e);
  if (r) {
    if (r.has(t))
      return !0;
  } else
    fi.set(e, r = /* @__PURE__ */ new Set());
  return r.add(t), !1;
}
function xy(e, t, r, n) {
  var o = t.data, i = Hn(t, ["data"]), a = r.data, s = Hn(r, ["data"]);
  return Be(i, s) && _n(ey(e).selectionSet, o, a, {
    fragmentMap: Dg(Jg(e)),
    variables: n
  });
}
function _n(e, t, r, n) {
  if (t === r)
    return !0;
  var o = /* @__PURE__ */ new Set();
  return e.selections.every(function(i) {
    if (o.has(i) || (o.add(i), !Rg(i, n.variables)) || Os(i))
      return !0;
    if (Xg(i)) {
      var a = Kg(i), s = t && t[a], l = r && r[a], u = i.selectionSet;
      if (!u)
        return Be(s, l);
      var f = Array.isArray(s), h = Array.isArray(l);
      if (f !== h)
        return !1;
      if (f && h) {
        var g = s.length;
        if (l.length !== g)
          return !1;
        for (var m = 0; m < g; ++m)
          if (!_n(u, s[m], l[m], n))
            return !1;
        return !0;
      }
      return _n(u, s, l, n);
    } else {
      var y = Ng(i, n.fragmentMap);
      if (y)
        return Os(y) ? !0 : _n(
          y.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          r,
          n
        );
    }
  });
}
function Os(e) {
  return !!e.directives && e.directives.some(Cy);
}
function Cy(e) {
  return e.name.value === "nonreactive";
}
var Te;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(Te || (Te = {}));
function Cn(e) {
  return e ? e < 7 : !1;
}
var Es = Object.assign, Ty = Object.hasOwnProperty, ec = (
  /** @class */
  function(e) {
    Fi(t, e);
    function t(r) {
      var n = r.queryManager, o = r.queryInfo, i = r.options, a = this, s = t.inactiveOnCreation.getValue();
      a = e.call(this, function(w) {
        s && (n.queries.set(a.queryId, o), s = !1);
        try {
          var R = w._subscription._observer;
          R && !R.error && (R.error = $y);
        } catch {
        }
        var x = !a.observers.size;
        a.observers.add(w);
        var b = a.last;
        return b && b.error ? w.error && w.error(b.error) : b && b.result && w.next && w.next(a.maskResult(b.result)), x && a.reobserve().catch(function() {
        }), function() {
          a.observers.delete(w) && !a.observers.size && a.tearDownQuery();
        };
      }) || this, a.observers = /* @__PURE__ */ new Set(), a.subscriptions = /* @__PURE__ */ new Set(), a.dirty = !1, a.queryInfo = o, a.queryManager = n, a.waitForOwnResult = Vo(i.fetchPolicy), a.isTornDown = !1, a.subscribeToMore = a.subscribeToMore.bind(a), a.maskResult = a.maskResult.bind(a);
      var l = n.defaultOptions.watchQuery, u = l === void 0 ? {} : l, f = u.fetchPolicy, h = f === void 0 ? "cache-first" : f, g = i.fetchPolicy, m = g === void 0 ? h : g, y = i.initialFetchPolicy, p = y === void 0 ? m === "standby" ? h : m : y;
      a.options = ne(ne({}, i), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: p,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: m
      }), a.queryId = o.queryId || n.generateQueryId();
      var v = Ql(a.query);
      return a.queryName = v && v.name && v.name.value, a;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var r = this;
      return new Promise(function(n, o) {
        var i = {
          next: function(s) {
            n(s), r.observers.delete(i), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
              a.unsubscribe();
            }, 0);
          },
          error: o
        }, a = r.subscribe(i);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(r) {
      r === void 0 && (r = !0);
      var n = this.getLastResult(!0), o = this.queryInfo.networkStatus || n && n.networkStatus || Te.ready, i = ne(ne({}, n), { loading: Cn(o), networkStatus: o }), a = this.options.fetchPolicy, s = a === void 0 ? "cache-first" : a;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(Vo(s) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var l = this.queryInfo.getDiff();
        (l.complete || this.options.returnPartialData) && (i.data = l.result), Be(i.data, {}) && (i.data = void 0), l.complete ? (delete i.partial, l.complete && i.networkStatus === Te.loading && (s === "cache-first" || s === "cache-only") && (i.networkStatus = Te.ready, i.loading = !1)) : i.partial = !0, i.networkStatus === Te.ready && (i.error || i.errors) && (i.networkStatus = Te.error), globalThis.__DEV__ !== !1 && !l.complete && !this.options.partialRefetch && !i.loading && !i.data && !i.error && Iy(l.missing);
      }
      return r && this.updateLastResult(i), i;
    }, t.prototype.getCurrentResult = function(r) {
      return r === void 0 && (r = !0), this.maskResult(this.getCurrentFullResult(r));
    }, t.prototype.isDifferentFromLastResult = function(r, n) {
      if (!this.last)
        return !0;
      var o = this.queryManager.getDocumentInfo(this.query), i = this.queryManager.dataMasking, a = i ? o.nonReactiveQuery : this.query, s = i || o.hasNonreactiveDirective ? !xy(a, this.last.result, r, this.variables) : !Be(this.last.result, r);
      return s || n && !Be(this.last.variables, n);
    }, t.prototype.getLast = function(r, n) {
      var o = this.last;
      if (o && o[r] && (!n || Be(o.variables, this.variables)))
        return o[r];
    }, t.prototype.getLastResult = function(r) {
      return this.getLast("result", r);
    }, t.prototype.getLastError = function(r) {
      return this.getLast("error", r);
    }, t.prototype.resetLastResults = function() {
      delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(r) {
      var n, o = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, i = this.options.fetchPolicy;
      if (i === "no-cache" ? o.fetchPolicy = "no-cache" : o.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && r && Ty.call(r, "variables")) {
        var a = Zg(this.query), s = a.variableDefinitions;
        (!s || !s.some(function(l) {
          return l.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && $e.warn(
          21,
          r,
          ((n = a.name) === null || n === void 0 ? void 0 : n.value) || a
        );
      }
      return r && !Be(this.options.variables, r) && (o.variables = this.options.variables = ne(ne({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(o, Te.refetch);
    }, t.prototype.fetchMore = function(r) {
      var n = this, o = ne(ne({}, r.query ? r : ne(ne(ne(ne({}, this.options), { query: this.options.query }), r), { variables: ne(ne({}, this.options.variables), r.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      o.query = this.transformDocument(o.query);
      var i = this.queryManager.generateQueryId();
      this.lastQuery = r.query ? this.transformDocument(this.options.query) : o.query;
      var a = this.queryInfo, s = a.networkStatus;
      a.networkStatus = Te.fetchMore, o.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set(), u = r == null ? void 0 : r.updateQuery, f = this.options.fetchPolicy !== "no-cache";
      return f || $e(u, 22), this.queryManager.fetchQuery(i, o, Te.fetchMore).then(function(h) {
        if (n.queryManager.removeQuery(i), a.networkStatus === Te.fetchMore && (a.networkStatus = s), f)
          n.queryManager.cache.batch({
            update: function(y) {
              var p = r.updateQuery;
              p ? y.updateQuery({
                query: n.query,
                variables: n.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(v) {
                return p(v, {
                  fetchMoreResult: h.data,
                  variables: o.variables
                });
              }) : y.writeQuery({
                query: o.query,
                variables: o.variables,
                data: h.data
              });
            },
            onWatchUpdated: function(y) {
              l.add(y.query);
            }
          });
        else {
          var g = n.getLast("result"), m = u(g.data, {
            fetchMoreResult: h.data,
            variables: o.variables
          });
          n.reportResult(ne(ne({}, g), { networkStatus: s, loading: Cn(s), data: m }), n.variables);
        }
        return n.maskResult(h);
      }).finally(function() {
        f && !l.has(n.query) && n.reobserveCacheFirst();
      });
    }, t.prototype.subscribeToMore = function(r) {
      var n = this, o = this.queryManager.startGraphQLSubscription({
        query: r.document,
        variables: r.variables,
        context: r.context
      }).subscribe({
        next: function(i) {
          var a = r.updateQuery;
          a && n.updateQuery(function(s, l) {
            return a(s, ne({ subscriptionData: i }, l));
          });
        },
        error: function(i) {
          if (r.onError) {
            r.onError(i);
            return;
          }
          globalThis.__DEV__ !== !1 && $e.error(23, i);
        }
      });
      return this.subscriptions.add(o), function() {
        n.subscriptions.delete(o) && o.unsubscribe();
      };
    }, t.prototype.setOptions = function(r) {
      return this.reobserve(r);
    }, t.prototype.silentSetOptions = function(r) {
      var n = rn(this.options, r || {});
      Es(this.options, n);
    }, t.prototype.setVariables = function(r) {
      return Be(this.variables, r) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: r
      }, Te.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(r) {
      var n = this.queryManager, o = n.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), i = o.result, a = o.complete, s = r(i, {
        variables: this.variables,
        complete: !!a,
        previousData: i
      });
      s && (n.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), n.broadcastQueries());
    }, t.prototype.startPolling = function(r) {
      this.options.pollInterval = r, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(r, n) {
      if (n.nextFetchPolicy) {
        var o = n.fetchPolicy, i = o === void 0 ? "cache-first" : o, a = n.initialFetchPolicy, s = a === void 0 ? i : a;
        i === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(i, {
          reason: r,
          options: n,
          observable: this,
          initialFetchPolicy: s
        }) : r === "variables-changed" ? n.fetchPolicy = s : n.fetchPolicy = n.nextFetchPolicy);
      }
      return n.fetchPolicy;
    }, t.prototype.fetch = function(r, n, o) {
      var i = this.queryManager.getOrCreateQuery(this.queryId);
      return i.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(i, r, n, o);
    }, t.prototype.updatePolling = function() {
      var r = this;
      if (!this.queryManager.ssrMode) {
        var n = this, o = n.pollingInfo, i = n.options.pollInterval;
        if (!i || !this.hasObservers()) {
          o && (clearTimeout(o.timeout), delete this.pollingInfo);
          return;
        }
        if (!(o && o.interval === i)) {
          $e(i, 24);
          var a = o || (this.pollingInfo = {});
          a.interval = i;
          var s = function() {
            var u, f;
            r.pollingInfo && (!Cn(r.queryInfo.networkStatus) && !(!((f = (u = r.options).skipPollAttempt) === null || f === void 0) && f.call(u)) ? r.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, Te.poll).then(l, l) : l());
          }, l = function() {
            var u = r.pollingInfo;
            u && (clearTimeout(u.timeout), u.timeout = setTimeout(s, u.interval));
          };
          l();
        }
      }
    }, t.prototype.updateLastResult = function(r, n) {
      n === void 0 && (n = this.variables);
      var o = this.getLastError();
      return o && this.last && !Be(n, this.last.variables) && (o = void 0), this.last = ne({ result: this.queryManager.assumeImmutableResults ? r : hy(r), variables: n }, o ? { error: o } : null);
    }, t.prototype.reobserveAsConcast = function(r, n) {
      var o = this;
      this.isTornDown = !1;
      var i = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        n === Te.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        n === Te.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        n === Te.poll
      ), a = this.options.variables, s = this.options.fetchPolicy, l = rn(this.options, r || {}), u = i ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : Es(this.options, l), f = this.transformDocument(u.query);
      this.lastQuery = f, i || (this.updatePolling(), r && r.variables && !Be(r.variables, a) && // Don't mess with the fetchPolicy if it's currently "standby".
      u.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (u.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof u.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", u), n === void 0 && (n = Te.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = Vo(u.fetchPolicy));
      var h = function() {
        o.concast === y && (o.waitForOwnResult = !1);
      }, g = u.variables && ne({}, u.variables), m = this.fetch(u, n, f), y = m.concast, p = m.fromLink, v = {
        next: function(w) {
          Be(o.variables, g) && (h(), o.reportResult(w, g));
        },
        error: function(w) {
          Be(o.variables, g) && (vy(w) || (w = new Gi({ networkError: w })), h(), o.reportError(w, g));
        }
      };
      return !i && (p || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = y, this.observer = v), y.addObserver(v), y;
    }, t.prototype.reobserve = function(r, n) {
      return py(this.reobserveAsConcast(r, n).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      var o = this.last;
      this.resetLastResults();
      var i = this.subscribe.apply(this, r);
      return this.last = o, i;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(r, n) {
      var o = this.getLastError(), i = this.isDifferentFromLastResult(r, n);
      (o || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, n), (o || i) && ms(this.observers, "next", this.maskResult(r));
    }, t.prototype.reportError = function(r, n) {
      var o = ne(ne({}, this.getLastResult()), { error: r, errors: r.graphQLErrors, networkStatus: Te.error, loading: !1 });
      this.updateLastResult(o, n), ms(this.observers, "error", this.last.error = r);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
        return r.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(r) {
      return this.queryManager.transform(r);
    }, t.prototype.maskResult = function(r) {
      return r && "data" in r ? ne(ne({}, r), { data: this.queryManager.maskOperation({
        document: this.query,
        data: r.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : r;
    }, t.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, t.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, t.prototype.scheduleNotify = function() {
      var r = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return r.notify();
      }, 0)));
    }, t.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !Cn(this.queryInfo.networkStatus))) {
        var r = this.queryInfo.getDiff();
        r.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, t.prototype.reobserveCacheFirst = function() {
      var r = this.options, n = r.fetchPolicy, o = r.nextFetchPolicy;
      return n === "cache-and-network" || n === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(i, a) {
          return this.nextFetchPolicy = o, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(i, a) : n;
        }
      }) : this.reobserve();
    }, t.inactiveOnCreation = new Wi(), t;
  }(Pr)
);
my(ec);
function $y(e) {
  globalThis.__DEV__ !== !1 && $e.error(25, e.message, e.stack);
}
function Iy(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && $e.debug(26, e);
}
function Vo(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var tc = { exports: {} };
(function(e) {
  e.exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = void 0, e.exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = void 0, e.exports.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = void 0, Object.assign(e.exports, Sr);
})(tc);
var be = tc.exports;
const Ry = /* @__PURE__ */ Us(be), rc = /* @__PURE__ */ Ec({
  __proto__: null,
  default: Ry
}, [be]);
var xs = Fl ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function nc() {
  $e("createContext" in rc, 54);
  var e = be.createContext[xs];
  return e || (Object.defineProperty(be.createContext, xs, {
    value: e = be.createContext({}),
    enumerable: !1,
    writable: !1,
    configurable: !0
  }), e.displayName = "ApolloContext"), e;
}
function ky(e) {
  var t = be.useContext(nc()), r = e || t.client;
  return $e(!!r, 58), r;
}
var Cs = !1, Py = "useSyncExternalStore", Ay = rc[Py], _y = Ay || function(e, t, r) {
  var n = t();
  // DEVIATION: Using __DEV__
  globalThis.__DEV__ !== !1 && !Cs && // DEVIATION: Not using Object.is because we know our snapshots will never
  // be exotic primitive values like NaN, which is !== itself.
  n !== t() && (Cs = !0, globalThis.__DEV__ !== !1 && $e.error(68));
  var o = be.useState({
    inst: { value: n, getSnapshot: t }
  }), i = o[0].inst, a = o[1];
  return Mg ? be.useLayoutEffect(function() {
    Object.assign(i, { value: n, getSnapshot: t }), Bo(i) && a({ inst: i });
  }, [e, n, t]) : Object.assign(i, { value: n, getSnapshot: t }), be.useEffect(function() {
    return Bo(i) && a({ inst: i }), e(function() {
      Bo(i) && a({ inst: i });
    });
  }, [e]), n;
};
function Bo(e) {
  var t = e.value, r = e.getSnapshot;
  try {
    return t !== r();
  } catch {
    return !0;
  }
}
var Rt;
(function(e) {
  e[e.Query = 0] = "Query", e[e.Mutation = 1] = "Mutation", e[e.Subscription = 2] = "Subscription";
})(Rt || (Rt = {}));
var nr;
function Ts(e) {
  var t;
  switch (e) {
    case Rt.Query:
      t = "Query";
      break;
    case Rt.Mutation:
      t = "Mutation";
      break;
    case Rt.Subscription:
      t = "Subscription";
      break;
  }
  return t;
}
function oc(e) {
  nr || (nr = new qg(
    Wl.parser || 1e3
    /* defaultCacheSizes.parser */
  ));
  var t = nr.get(e);
  if (t)
    return t;
  var r, n, o;
  $e(!!e && !!e.kind, 70, e);
  for (var i = [], a = [], s = [], l = [], u = 0, f = e.definitions; u < f.length; u++) {
    var h = f[u];
    if (h.kind === "FragmentDefinition") {
      i.push(h);
      continue;
    }
    if (h.kind === "OperationDefinition")
      switch (h.operation) {
        case "query":
          a.push(h);
          break;
        case "mutation":
          s.push(h);
          break;
        case "subscription":
          l.push(h);
          break;
      }
  }
  $e(!i.length || a.length || s.length || l.length, 71), $e(
    a.length + s.length + l.length <= 1,
    72,
    e,
    a.length,
    l.length,
    s.length
  ), n = a.length ? Rt.Query : Rt.Mutation, !a.length && !s.length && (n = Rt.Subscription);
  var g = a.length ? a : s.length ? s : l;
  $e(g.length === 1, 73, e, g.length);
  var m = g[0];
  r = m.variableDefinitions || [], m.name && m.name.kind === "Name" ? o = m.name.value : o = "data";
  var y = { name: o, type: n, variables: r };
  return nr.set(e, y), y;
}
oc.resetCache = function() {
  nr = void 0;
};
globalThis.__DEV__ !== !1 && Ul("parser", function() {
  return nr ? nr.size : 0;
});
function My(e, t) {
  var r = oc(e), n = Ts(t), o = Ts(r.type);
  $e(
    r.type === t,
    74,
    n,
    n,
    o
  );
}
var Dy = zl ? be.useLayoutEffect : be.useEffect, Ny = Object.prototype.hasOwnProperty;
function $s() {
}
var Mn = Symbol();
function Ly(e, t, r, n, o) {
  function i(h) {
    var g;
    My(t, Rt.Query);
    var m = {
      client: e,
      query: t,
      observable: (
        // See if there is an existing observable that was used to fetch the same
        // data and if so, use it instead since it will contain the proper queryId
        // to fetch the result set. This is used during SSR.
        n && n.getSSRObservable(o()) || ec.inactiveOnCreation.withValue(!n, function() {
          return e.watchQuery(Ki(void 0, e, r, o()));
        })
      ),
      resultData: {
        // Reuse previousData from previous InternalState (if any) to provide
        // continuity of previousData even if/when the query or client changes.
        previousData: (g = h == null ? void 0 : h.resultData.current) === null || g === void 0 ? void 0 : g.data
      }
    };
    return m;
  }
  var a = be.useState(i), s = a[0], l = a[1];
  function u(h) {
    var g, m;
    Object.assign(s.observable, (g = {}, g[Mn] = h, g));
    var y = s.resultData;
    l(ne(ne({}, s), {
      // might be a different query
      query: h.query,
      resultData: Object.assign(y, {
        // We need to modify the previous `resultData` object as we rely on the
        // object reference in other places
        previousData: ((m = y.current) === null || m === void 0 ? void 0 : m.data) || y.previousData,
        current: void 0
      })
    }));
  }
  if (e !== s.client || t !== s.query) {
    var f = i(s);
    return l(f), [f, u];
  }
  return [s, u];
}
function jy(e, t) {
  var r = ky(t.client), n = be.useContext(nc()).renderPromises, o = !!n, i = r.disableNetworkFetches, a = t.ssr !== !1 && !t.skip, s = t.partialRefetch, l = ic(r, e, t, o), u = Ly(r, e, t, n, l), f = u[0], h = f.observable, g = f.resultData, m = u[1], y = l(h);
  Fy(
    g,
    // might get mutated during render
    h,
    // might get mutated during render
    r,
    t,
    y
  );
  var p = be.useMemo(function() {
    return Uy(h);
  }, [h]);
  By(h, n, a);
  var v = Vy(g, h, r, t, y, i, s, o, {
    onCompleted: t.onCompleted || $s,
    onError: t.onError || $s
  });
  return {
    result: v,
    obsQueryFields: p,
    observable: h,
    resultData: g,
    client: r,
    onQueryExecuted: m
  };
}
function Vy(e, t, r, n, o, i, a, s, l) {
  var u = be.useRef(l);
  be.useEffect(function() {
    u.current = l;
  });
  var f = (s || i) && n.ssr === !1 && !n.skip ? (
    // If SSR has been explicitly disabled, and this function has been called
    // on the server side, return the default loading state.
    ac
  ) : n.skip || o.fetchPolicy === "standby" ? (
    // When skipping a query (ie. we're not querying for data but still want to
    // render children), make sure the `data` is cleared out and `loading` is
    // set to `false` (since we aren't loading anything).
    //
    // NOTE: We no longer think this is the correct behavior. Skipping should
    // not automatically set `data` to `undefined`, but instead leave the
    // previous data in place. In other words, skipping should not mandate that
    // previously received data is all of a sudden removed. Unfortunately,
    // changing this is breaking, so we'll have to wait until Apollo Client 4.0
    // to address this.
    sc
  ) : void 0, h = e.previousData, g = be.useMemo(function() {
    return f && Qn(f, h, t, r);
  }, [r, t, f, h]);
  return _y(be.useCallback(function(m) {
    if (s)
      return function() {
      };
    var y = function() {
      var w = e.current, R = t.getCurrentResult();
      w && w.loading === R.loading && w.networkStatus === R.networkStatus && Be(w.data, R.data) || di(R, e, t, r, a, m, u.current);
    }, p = function(w) {
      if (v.current.unsubscribe(), v.current = t.resubscribeAfterError(y, p), !Ny.call(w, "graphQLErrors"))
        throw w;
      var R = e.current;
      (!R || R && R.loading || !Be(w, R.error)) && di({
        data: R && R.data,
        error: w,
        loading: !1,
        networkStatus: Te.error
      }, e, t, r, a, m, u.current);
    }, v = { current: t.subscribe(y, p) };
    return function() {
      setTimeout(function() {
        return v.current.unsubscribe();
      });
    };
  }, [
    i,
    s,
    t,
    e,
    a,
    r
  ]), function() {
    return g || Is(e, t, u.current, a, r);
  }, function() {
    return g || Is(e, t, u.current, a, r);
  });
}
function By(e, t, r) {
  t && r && (t.registerSSRObservable(e), e.getCurrentResult().loading && t.addObservableQueryPromise(e));
}
function Fy(e, t, r, n, o) {
  var i;
  t[Mn] && !Be(t[Mn], o) && (t.reobserve(Ki(t, r, n, o)), e.previousData = ((i = e.current) === null || i === void 0 ? void 0 : i.data) || e.previousData, e.current = void 0), t[Mn] = o;
}
function ic(e, t, r, n) {
  r === void 0 && (r = {});
  var o = r.skip;
  r.ssr, r.onCompleted, r.onError;
  var i = r.defaultOptions, a = Hn(r, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]);
  return function(s) {
    var l = Object.assign(a, { query: t });
    return n && (l.fetchPolicy === "network-only" || l.fetchPolicy === "cache-and-network") && (l.fetchPolicy = "cache-first"), l.variables || (l.variables = {}), o ? (l.initialFetchPolicy = l.initialFetchPolicy || l.fetchPolicy || hi(i, e.defaultOptions), l.fetchPolicy = "standby") : l.fetchPolicy || (l.fetchPolicy = (s == null ? void 0 : s.options.initialFetchPolicy) || hi(i, e.defaultOptions)), l;
  };
}
function Ki(e, t, r, n) {
  var o = [], i = t.defaultOptions.watchQuery;
  return i && o.push(i), r.defaultOptions && o.push(r.defaultOptions), o.push(rn(e && e.options, n)), o.reduce(ui);
}
function di(e, t, r, n, o, i, a) {
  var s = t.current;
  s && s.data && (t.previousData = s.data), !e.error && Gl(e.errors) && (e.error = new Gi({ graphQLErrors: e.errors })), t.current = Qn(Wy(e, r, o), t.previousData, r, n), i(), zy(e, s == null ? void 0 : s.networkStatus, a);
}
function zy(e, t, r) {
  if (!e.loading) {
    var n = qy(e);
    Promise.resolve().then(function() {
      n ? r.onError(n) : e.data && t !== e.networkStatus && e.networkStatus === Te.ready && r.onCompleted(e.data);
    }).catch(function(o) {
      globalThis.__DEV__ !== !1 && $e.warn(o);
    });
  }
}
function Is(e, t, r, n, o) {
  return e.current || di(t.getCurrentResult(), e, t, o, n, function() {
  }, r), e.current;
}
function hi(e, t) {
  var r;
  return (e == null ? void 0 : e.fetchPolicy) || ((r = t == null ? void 0 : t.watchQuery) === null || r === void 0 ? void 0 : r.fetchPolicy) || "cache-first";
}
function qy(e) {
  return Gl(e.errors) ? new Gi({ graphQLErrors: e.errors }) : e.error;
}
function Qn(e, t, r, n) {
  var o = e.data;
  e.partial;
  var i = Hn(e, ["data", "partial"]), a = ne(ne({ data: o }, i), { client: n, observable: r, variables: r.variables, called: e !== ac && e !== sc, previousData: t });
  return a;
}
function Wy(e, t, r) {
  return e.partial && r && !e.loading && (!e.data || Object.keys(e.data).length === 0) && t.options.fetchPolicy !== "cache-only" ? (t.refetch(), ne(ne({}, e), { loading: !0, networkStatus: Te.refetch })) : e;
}
var ac = Zl({
  loading: !0,
  data: void 0,
  error: void 0,
  networkStatus: Te.loading
}), sc = Zl({
  loading: !1,
  data: void 0,
  error: void 0,
  networkStatus: Te.ready
});
function Uy(e) {
  return {
    refetch: e.refetch.bind(e),
    reobserve: e.reobserve.bind(e),
    fetchMore: e.fetchMore.bind(e),
    updateQuery: e.updateQuery.bind(e),
    startPolling: e.startPolling.bind(e),
    stopPolling: e.stopPolling.bind(e),
    subscribeToMore: e.subscribeToMore.bind(e)
  };
}
var Hy = [
  "refetch",
  "reobserve",
  "fetchMore",
  "updateQuery",
  "startPolling",
  "stopPolling",
  "subscribeToMore"
];
function Yy(e, t) {
  var r, n = be.useRef(void 0), o = be.useRef(void 0), i = be.useRef(void 0), a = ui(t, n.current || {}), s = (r = a == null ? void 0 : a.query) !== null && r !== void 0 ? r : e;
  o.current = t, i.current = s;
  var l = ne(ne({}, a), { skip: !n.current }), u = jy(s, l), f = u.obsQueryFields, h = u.result, g = u.client, m = u.resultData, y = u.observable, p = u.onQueryExecuted, v = y.options.initialFetchPolicy || hi(l.defaultOptions, g.defaultOptions), w = be.useReducer(function(D) {
    return D + 1;
  }, 0)[1], R = be.useMemo(function() {
    for (var D = {}, z = function(F) {
      var Q = f[F];
      D[F] = function() {
        return n.current || (n.current = /* @__PURE__ */ Object.create(null), w()), Q.apply(this, arguments);
      };
    }, d = 0, T = Hy; d < T.length; d++) {
      var $ = T[d];
      z($);
    }
    return D;
  }, [w, f]), x = !!n.current, b = be.useMemo(function() {
    return ne(ne(ne({}, h), R), { called: x });
  }, [h, R, x]), S = be.useCallback(function(D) {
    n.current = D ? ne(ne({}, D), { fetchPolicy: D.fetchPolicy || v }) : {
      fetchPolicy: v
    };
    var z = ui(o.current, ne({ query: i.current }, n.current)), d = Qy(m, y, g, s, ne(ne({}, z), { skip: !1 }), p).then(function(T) {
      return Object.assign(T, R);
    });
    return d.catch(function() {
    }), d;
  }, [
    g,
    s,
    R,
    v,
    y,
    m,
    p
  ]), P = be.useRef(S);
  Dy(function() {
    P.current = S;
  });
  var q = be.useCallback(function() {
    for (var D = [], z = 0; z < arguments.length; z++)
      D[z] = arguments[z];
    return P.current.apply(P, D);
  }, []);
  return [q, b];
}
function Qy(e, t, r, n, o, i) {
  var a = o.query || n, s = ic(r, a, o, !1)(t), l = t.reobserveAsConcast(Ki(t, r, o, s));
  return i(s), new Promise(function(u) {
    var f;
    l.subscribe({
      next: function(h) {
        f = h;
      },
      error: function() {
        u(Qn(t.getCurrentResult(), e.previousData, t, r));
      },
      complete: function() {
        u(Qn(t.maskResult(f), e.previousData, t, r));
      }
    });
  });
}
const Gy = (e, t) => {
  const r = er(void 0), n = er(void 0), o = ir(() => {
    const i = r.current;
    return r.current = void 0, e(...i ?? []);
  }, [e]);
  return or(() => {
    !t && r.current && o();
  }, [t, o]), (...i) => t ? (r.current = i, n.current) : (r.current = i, n.current = o(), n.current);
}, Fo = (e) => typeof e == "object" && e != null && "id" in e && e.id != null, Tn = (e, t) => e[t].data, fo = ({ useLazyFetchQuery: e, itemsKey: t, autocompleteProps: r, defaultFilters: n = {}, searchFilterName: o, excludedResourceIdentifierObjects: i = [], inputFieldProps: a, primaryFilterKey: s, onChange: l, enableSelectAll: u, value: f, onFetched: h }) => {
  const [g, { called: m, loading: y, data: p }] = Yy(e), [v, w] = vr(""), R = er(!1), x = er(!1), [b, S] = vr(!1), [P, q] = vr(!1), [D, z] = vr({}), [d, T] = vr(r != null && r.multiple ? Array.isArray(f) && (f != null && f[0]) && Fo(f == null ? void 0 : f[0]) ? f : [] : []), $ = er(d), F = er(!1), Q = yt(() => Ve.keyBy(i, (_) => _.type + "-" + _.id), [i]), ae = Math.max(100, (Array.isArray(f) ? f.length : 1) + 50), Y = (() => {
    if (F.current || Array.isArray(f) && f.length === 0 || r != null && r.multiple && !f)
      return !1;
    if (r != null && r.multiple && Array.isArray(f) && f.length > 0 && Array.isArray($.current) && $.current.length === 0)
      return !0;
    const _ = Ve.keyBy($.current, "id");
    return (Array.isArray(f) ? f : [f]).map((N) => _[N]).some((N) => !N);
  })(), re = yt(() => {
    if (r != null && r.multiple)
      if (Array.isArray(f) && (f != null && f[0])) {
        if (Fo(f[0]))
          return f;
        {
          const _ = Ve.keyBy(d, "id");
          return f.map((N) => _[N]).filter((N) => !!N);
        }
      } else
        return d ?? [];
    else
      return Fo(f) ? f : d[0] ?? null;
  }, [r == null ? void 0 : r.multiple, f, d]), oe = Gy((_, M, N, j) => {
    F.current = !0;
    const U = Ve.assign({
      pageSize: ae,
      page: 1
    }, Ve.mapValues(_, (G) => G == null ? void 0 : G.value), N && { [M]: `%${N}%` });
    return new Promise((G, H) => {
      j({
        variables: { ...U }
      }).then((K) => {
        G(K), Ve.defer(() => {
          K.data && (h == null || h(Tn(K.data, t)));
        });
      }).catch((K) => {
        console.log(K), H(K);
      });
    });
  }, y);
  or(() => {
    r != null && r.multiple && Array.isArray(d) && d[0] && !R.current && (R.current = !0, z(Ve.keyBy(d, (_) => _.id)));
  }, [d, r == null ? void 0 : r.multiple]);
  const Z = ir(() => {
    var _, M;
    if (r != null && r.multiple && Array.isArray(f)) {
      if (f[0] && typeof f[0] == "number") {
        const N = {
          ...n,
          [s]: { field: s, operator: "in", value: f }
        };
        (_ = oe(N, o, "", g)) == null || _.then((j) => {
          if (j.data) {
            const U = Tn(j.data, t).map((G) => Ve.cloneDeep(G));
            $.current = U, T(U);
          }
        });
        return;
      }
    } else if (typeof f == "number") {
      const N = {
        ...n,
        [s]: { field: s, operator: "=", value: f }
      };
      (M = oe(N, o, "", g)) == null || M.then((j) => {
        if (Tn(j.data, t)[0]) {
          const U = [...Tn(j.data, t)];
          $.current = U, T(U);
        }
      });
      return;
    }
  }, [
    r == null ? void 0 : r.multiple,
    // missingValueData,
    s,
    oe,
    o,
    g,
    f
  ]);
  or(() => {
    Array.isArray(f) && Ve.differenceBy(f.map((M) => typeof M == "number" ? M : M.id), $.current.map((M) => M.id)).length && Z();
  }, [f]), or(() => {
    f && Y && !y && m && Z();
  }, [Y, y, m, Z, f]);
  const k = yt(() => Ve.chain(p == null ? void 0 : p[t].data).keyBy("id").merge(D).values().value(), [p, t, D]), A = yt(() => k.sort((_, M) => {
    var N, j;
    return D != null && D[_.id] && !(D != null && D[M.id]) ? -1 : !(D != null && D[_.id]) && (D != null && D[M.id]) ? 1 : (((N = r == null ? void 0 : r.getOptionLabel) == null ? void 0 : N.call(r, _)) ?? "").localeCompare(((j = r == null ? void 0 : r.getOptionLabel) == null ? void 0 : j.call(r, M)) ?? "");
  }), [r, k, D]), W = yt(() => r != null && r.multiple && re ? re.length === A.length && !y : !1, [r == null ? void 0 : r.multiple, re, A, y]);
  return L(_l, { inputValue: v, open: b, filterOptions: (_) => Object.keys(Q).length === 0 ? _ : _.filter((M) => !Q[M.id]), onOpen: () => {
    S(!0), x.current || (oe(n, o, "", g), x.current = !0);
  }, onClose: () => {
    S(!1);
  }, loading: y, options: A, onInputChange: (_, M) => {
    w(M), (_ == null ? void 0 : _.type) == "change" && oe(n, o, M, g);
  }, isOptionEqualToValue: (_, M) => _.__typename == M.__typename && _.id == M.id, disableCloseOnSelect: (r == null ? void 0 : r.disableCloseOnSelect) ?? (r == null ? void 0 : r.multiple) ?? !0, groupBy: (_) => r != null && r.multiple ? D != null && D[_.id] ? "checked" : "unchecked" : "none", renderGroup: xg(P, q), renderInput: (_) => L(hc, { ..._, slotProps: {
    input: {
      ..._.InputProps,
      endAdornment: Fe(gi, { children: [y ? L(ks, { size: 20 }) : null, _.InputProps.endAdornment] })
    }
  }, ...a, label: y ? "Loading..." : (a == null ? void 0 : a.label) ?? "Search items..." }), limitTags: 3, size: "small", slotProps: {
    listbox: {
      ...r != null && r.multiple && u ? {
        allSelected: W,
        onSelectAll: () => {
          W ? ($.current = [], T([]), l([])) : ($.current = A, T(A), l(A));
        },
        component: r != null && r.multiple && u ? Eg : void 0
      } : {}
    }
  }, ...r ?? {}, value: re, onChange: (_, M, N, j) => {
    const U = M ? Array.isArray(M) ? M : [M] : [];
    T(U), l(M, N, _, j), $.current = U;
  }, getOptionKey: (_) => _.id, renderOption: (_, M, N, j) => {
    var H;
    const { key: U, ...G } = _;
    return L(_s, { ...G, sx: { width: 1 }, children: Fe(yi, { direction: "row", gap: 1, sx: { backgroundColor: "transparent", height: 1, flex: 1 }, alignItems: "center", children: [r != null && r.multiple ? L(Ps, { size: "small", checked: N.selected, icon: L(Ml, { fontSize: "small" }), checkedIcon: L(Dl, { fontSize: "small" }), sx: { padding: "0 4px" } }) : null, (H = r == null ? void 0 : r.renderOption) == null ? void 0 : H.call(r, _, M, N, j)] }) }, U);
  } });
}, mm = ({ multiple: e, onChange: t, menuSalesareaId: r, defaultFilters: n, fetchQuery: o, value: i, excludedResourceIdentifierObjects: a = [], inputFieldProps: s, renderTags: l, disableClearable: u, enableSelectAll: f, renderOption: h, onFetched: g, sx: m }) => {
  const y = yt(() => Ve.merge(n, { vestiging_id: { field: "vestiging_id", operator: "=", value: r } }), [n, r]);
  return L(fo, { useLazyFetchQuery: o, onFetched: g, itemsKey: "products", searchFilterName: "idNaamApiId1", defaultFilters: y, excludedResourceIdentifierObjects: a, inputFieldProps: { label: "Search products...", ...s }, primaryFilterKey: "id", onChange: (p) => {
    t == null || t(p);
  }, enableSelectAll: f, value: i, autocompleteProps: {
    multiple: e,
    disableClearable: u,
    renderTags: l ?? ((p, v) => p.map((w, R) => {
      const { key: x, ...b } = v({ index: R });
      return L(Kn, { color: "primary", size: "small", label: `${w.naam} #${w.id}`, ...b }, "#" + w.id);
    })),
    getOptionLabel: (p) => p.naam ?? "???",
    renderOption: h ?? ((p, v) => L(Gn, { children: v.naam })),
    sx: m
  } });
}, vm = ({ multiple: e, onChange: t, menuSalesareaId: r, defaultFilters: n, fetchQuery: o, value: i, excludedResourceIdentifierObjects: a = [], inputFieldProps: s, renderTags: l, disableClearable: u, enableSelectAll: f, renderOption: h, onFetched: g }) => {
  const m = yt(() => Ve.merge(n, { vestiging_id: { field: "vestiging_id", operator: "=", value: r } }), [n, r]);
  return L(fo, { useLazyFetchQuery: o, onFetched: g, itemsKey: "option_groups", defaultFilters: m, excludedResourceIdentifierObjects: a, inputFieldProps: { label: "Search option groups...", ...s }, searchFilterName: "idNameApiId", primaryFilterKey: "id", onChange: (y) => {
    t == null || t(y);
  }, enableSelectAll: f, value: i, autocompleteProps: {
    multiple: e,
    disableClearable: u,
    renderTags: l ?? ((y, p) => y.map((v, w) => {
      const { key: R, ...x } = p({ index: w });
      return L(Kn, { color: "primary", size: "small", label: `${v.name} #${v.id}`, ...x }, v.id);
    })),
    getOptionLabel: (y) => (y == null ? void 0 : y.name) ?? "???",
    renderOption: h ?? ((y, p) => L(Gn, { children: p.name }))
  } });
}, bm = ({ multiple: e, onChange: t, menuSalesareaId: r, defaultFilters: n, fetchQuery: o, value: i, excludedResourceIdentifierObjects: a = [], inputFieldProps: s, renderTags: l, disableClearable: u, enableSelectAll: f, renderOption: h, onFetched: g }) => {
  const m = yt(() => Ve.merge(n, { salesarea_id: { field: "salesarea_id", operator: "=", value: r } }), [n, r]);
  return L(fo, { useLazyFetchQuery: o, onFetched: g, itemsKey: "time_schedules", defaultFilters: m, excludedResourceIdentifierObjects: a, inputFieldProps: { label: "Search time schedules...", ...s }, searchFilterName: "name", primaryFilterKey: "id", onChange: (y) => {
    t == null || t(y);
  }, enableSelectAll: f, value: i, autocompleteProps: {
    multiple: e,
    disableClearable: u,
    renderTags: l ?? ((y, p) => y.map((v, w) => {
      const { key: R, ...x } = p({ index: w });
      return L(Kn, { color: "primary", size: "small", label: `${v.name} #${v.id}`, ...x }, v.id);
    })),
    getOptionLabel: (y) => (y == null ? void 0 : y.name) ?? "???",
    renderOption: h ?? ((y, p) => L(Gn, { children: p.name }))
  } });
}, Sm = ({ multiple: e, onChange: t, menuSalesareaId: r, defaultFilters: n, fetchQuery: o, value: i, excludedResourceIdentifierObjects: a = [], inputFieldProps: s, renderTags: l, disableClearable: u, enableSelectAll: f, renderOption: h, onFetched: g, sx: m }) => {
  const y = yt(() => Ve.merge(n, { vestiging_id: { field: "vestiging_id", operator: "=", value: r } }), [n, r]);
  return L(fo, { useLazyFetchQuery: o, onFetched: g, itemsKey: "menukaarten", defaultFilters: y, excludedResourceIdentifierObjects: a, inputFieldProps: { label: "Search categories...", ...s }, searchFilterName: "naam", primaryFilterKey: "id", onChange: (p) => {
    t == null || t(p);
  }, enableSelectAll: f, value: i, autocompleteProps: {
    multiple: e,
    disableClearable: u,
    renderTags: l ?? ((p, v) => p.map((w, R) => {
      const { key: x, ...b } = v({ index: R });
      return L(Kn, { color: "primary", size: "small", label: `${w.naam} #${w.id}`, ...b }, w.id);
    })),
    getOptionLabel: (p) => (p == null ? void 0 : p.naam) ?? "???",
    renderOption: h ?? ((p, v) => L(Gn, { children: v.naam })),
    sx: m
  } });
}, Ky = "en", wm = (e, t) => {
  const r = {
    locale: Ky,
    messages: e.en ?? {},
    changeLanguage: (n) => console.log(n)
  };
  return t(r);
}, Om = (e, t) => function({ children: n }) {
  const [o, i] = vr("en"), a = yt(() => Xy(o, e), [o]);
  return L(t.Provider, { value: { locale: o, messages: a, changeLanguage: i }, children: n });
};
function Em(e, t) {
  const r = Ve.cloneDeep(e);
  return Object.keys(t).forEach((n) => {
    var o, i, a;
    (o = t[n]) != null && o.OVERWRITE ? r[n] = t[n].OVERWRITE.translation : (a = (i = t[n]) == null ? void 0 : i.AI) != null && a.translation && (r[n] = t[n].AI.translation);
  }), r;
}
function Xy(e, t) {
  const n = e.split("-")[0];
  return t[e] ?? t[n] ?? t.en;
}
const xm = {
  useIsUserInputBlocked: Ds,
  isUserInputBlocked: Cc,
  useBlockUserInput: Ns,
  useWrapPromise: Ic,
  blockingStarted: Tc,
  blockingStopped: $c,
  View: xc
};
export {
  Sm as AutocompleteCategory,
  vm as AutocompleteOptionGroup,
  mm as AutocompleteProduct,
  bm as AutocompleteTimeSchedule,
  xm as BlockUserInput,
  cm as ScrollShadows,
  Ee as TimeMethods,
  vi as TimeRangeMethods,
  wm as createLanguageContext,
  Om as createLanguageProvider,
  Jc as currentOpenRange,
  Kc as days,
  ar as forDate,
  Xc as forDateTime,
  Xy as getMessagesForLanguage,
  on as getTimeRangeOfOpeningHoursForDay,
  qt as getTimezone,
  pm as isClosed,
  aa as isClosedAt,
  um as isOfTypeDay,
  tu as isOpen,
  Xn as isOpenAt,
  dm as isOpenComingDays,
  fm as isOpenInOpeningHoursForDay,
  Ws as isOpenInTimeRange,
  Em as mapLanguageFile,
  eu as nextClose,
  Zc as nextOpen,
  Mc as toTimeRange
};
